// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_array from "rescript/lib/es6/js_array.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as GraphQL_PPX from "@reasonml-community/graphql-ppx/bucklescript/GraphQL_PPX.bs.js";
import * as Media$LiveRoom from "./Media.bs.js";
import * as Amount$LiveRoom from "./Amount.bs.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.bs.js";
import * as ApolloClient__React_Hooks_UseMutation from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseMutation.bs.js";
import * as ApolloClient__React_Hooks_UseSubscription from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseSubscription.bs.js";

var Raw = {};

var query = (require("@apollo/client").gql`
  fragment LotSymbolFragment on LotSymbol   {
    __typename
    description
    previouslyKnownAs
    name
    lotSymbolId
    image  {
      __typename
      ...on LotSymbolSVGImage   {
        __typename
        path
        width
        height
      }
    }
  }
`);

function parse(value) {
  var value$1 = value.previouslyKnownAs;
  var value$2 = value.image;
  var tmp;
  if (value$2 == null) {
    tmp = undefined;
  } else {
    var typename = value$2["__typename"];
    var tmp$1 = typename === "LotSymbolSVGImage" ? ({
          NAME: "LotSymbolSVGImage",
          VAL: {
            __typename: value$2.__typename,
            path: value$2.path,
            width: value$2.width,
            height: value$2.height
          }
        }) : ({
          NAME: "FutureAddedValue",
          VAL: value$2
        });
    tmp = tmp$1;
  }
  return {
          __typename: value.__typename,
          description: value.description,
          previouslyKnownAs: !(value$1 == null) ? value$1 : undefined,
          name: value.name,
          lotSymbolId: value.lotSymbolId,
          image: tmp
        };
}

function serialize(value) {
  var value$1 = value.image;
  var image;
  if (value$1 !== undefined) {
    if (value$1.NAME === "LotSymbolSVGImage") {
      var value$2 = value$1.VAL;
      var value$3 = value$2.height;
      var value$4 = value$2.width;
      var value$5 = value$2.path;
      image = {
        __typename: "LotSymbolSVGImage",
        path: value$5,
        width: value$4,
        height: value$3
      };
    } else {
      image = value$1.VAL;
    }
  } else {
    image = null;
  }
  var value$6 = value.lotSymbolId;
  var value$7 = value.name;
  var value$8 = value.previouslyKnownAs;
  var previouslyKnownAs = value$8 !== undefined ? value$8 : null;
  var value$9 = value.description;
  var value$10 = value.__typename;
  return {
          __typename: value$10,
          description: value$9,
          previouslyKnownAs: previouslyKnownAs,
          name: value$7,
          lotSymbolId: value$6,
          image: image
        };
}

function verifyArgsAndParse(_LotSymbolFragment, value) {
  return parse(value);
}

function verifyName(param) {
  
}

var LotSymbolFragment = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  verifyArgsAndParse: verifyArgsAndParse,
  verifyName: verifyName
};

var LotSymbol = {
  LotSymbolFragment: LotSymbolFragment
};

var Raw$1 = {};

var query$1 = (require("@apollo/client").gql`
  fragment PremiumLotStateFragment on PremiumLotState   {
    __typename
    id
    isPremium
    userIsWhitelisted
  }
`);

function parse$1(value) {
  return {
          __typename: value.__typename,
          id: value.id,
          isPremium: value.isPremium,
          userIsWhitelisted: value.userIsWhitelisted
        };
}

function serialize$1(value) {
  var value$1 = value.userIsWhitelisted;
  var value$2 = value.isPremium;
  var value$3 = value.id;
  var value$4 = value.__typename;
  return {
          __typename: value$4,
          id: value$3,
          isPremium: value$2,
          userIsWhitelisted: value$1
        };
}

function verifyArgsAndParse$1(_PremiumLotStateFragment, value) {
  return parse$1(value);
}

function verifyName$1(param) {
  
}

var PremiumLotStateFragment = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  verifyArgsAndParse: verifyArgsAndParse$1,
  verifyName: verifyName$1
};

var PremiumLotState = {
  PremiumLotStateFragment: PremiumLotStateFragment
};

var Raw$2 = {};

var query$2 = (require("@apollo/client").gql`
  fragment SessionStateFragment on SessionState   {
    __typename
    id
    state
  }
`);

function parse$2(value) {
  var value$1 = value.state;
  var tmp;
  switch (value$1) {
    case "Closed" :
        tmp = "Closed";
        break;
    case "Open" :
        tmp = "Open";
        break;
    case "PreOpen" :
        tmp = "PreOpen";
        break;
    default:
      tmp = {
        NAME: "FutureAddedValue",
        VAL: value$1
      };
  }
  return {
          __typename: value.__typename,
          id: value.id,
          state: tmp
        };
}

function serialize$2(value) {
  var value$1 = value.state;
  var state = typeof value$1 === "object" ? value$1.VAL : (
      value$1 === "PreOpen" ? "PreOpen" : (
          value$1 === "Open" ? "Open" : "Closed"
        )
    );
  var value$2 = value.id;
  var value$3 = value.__typename;
  return {
          __typename: value$3,
          id: value$2,
          state: state
        };
}

function verifyArgsAndParse$2(_SessionStateFragment, value) {
  return parse$2(value);
}

function verifyName$2(param) {
  
}

var SessionStateFragment = {
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  verifyArgsAndParse: verifyArgsAndParse$2,
  verifyName: verifyName$2
};

var SessionState = {
  SessionStateFragment: SessionStateFragment
};

var Raw$3 = {};

var query$3 = ((frag_0) => require("@apollo/client").gql`
  fragment LatestUserBid on UserBidConnection   {
    __typename
    id
    bid  {
      __typename
      bidState
      amount: amountV2  {
        ...AmountFragment
      }
    }
  }
  ${frag_0}
`)(Amount$LiveRoom.AmountFragment.query);

function parse$3(value) {
  var value$1 = value.bid;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.bidState;
    var tmp$1;
    switch (value$2) {
      case "Absentee" :
          tmp$1 = "Absentee";
          break;
      case "BidAheadOfYou" :
          tmp$1 = "BidAheadOfYou";
          break;
      case "Cancelled" :
          tmp$1 = "Cancelled";
          break;
      case "CurrentBid" :
          tmp$1 = "CurrentBid";
          break;
      case "IrrevocableBid" :
          tmp$1 = "IrrevocableBid";
          break;
      case "Lost" :
          tmp$1 = "Lost";
          break;
      case "MaxBid" :
          tmp$1 = "MaxBid";
          break;
      case "Outbid" :
          tmp$1 = "Outbid";
          break;
      case "ReserveNotMet" :
          tmp$1 = "ReserveNotMet";
          break;
      case "Won" :
          tmp$1 = "Won";
          break;
      default:
        tmp$1 = {
          NAME: "FutureAddedValue",
          VAL: value$2
        };
    }
    var value$3 = value$1.amount;
    tmp = {
      __typename: value$1.__typename,
      bidState: tmp$1,
      amount: Amount$LiveRoom.AmountFragment.verifyArgsAndParse("AmountFragment", value$3)
    };
  }
  return {
          __typename: value.__typename,
          id: value.id,
          bid: tmp
        };
}

function serialize$3(value) {
  var value$1 = value.bid;
  var bid;
  if (value$1 !== undefined) {
    var value$2 = value$1.amount;
    var amount = Amount$LiveRoom.AmountFragment.serialize(value$2);
    var value$3 = value$1.bidState;
    var bidState = typeof value$3 === "object" ? value$3.VAL : (
        value$3 === "Cancelled" ? "Cancelled" : (
            value$3 === "IrrevocableBid" ? "IrrevocableBid" : (
                value$3 === "Absentee" ? "Absentee" : (
                    value$3 === "BidAheadOfYou" ? "BidAheadOfYou" : (
                        value$3 === "MaxBid" ? "MaxBid" : (
                            value$3 === "Won" ? "Won" : (
                                value$3 === "ReserveNotMet" ? "ReserveNotMet" : (
                                    value$3 === "Lost" ? "Lost" : (
                                        value$3 === "CurrentBid" ? "CurrentBid" : "Outbid"
                                      )
                                  )
                              )
                          )
                      )
                  )
              )
          )
      );
    var value$4 = value$1.__typename;
    bid = {
      __typename: value$4,
      bidState: bidState,
      amount: amount
    };
  } else {
    bid = null;
  }
  var value$5 = value.id;
  var value$6 = value.__typename;
  return {
          __typename: value$6,
          id: value$5,
          bid: bid
        };
}

function verifyArgsAndParse$3(_LatestUserBid, value) {
  return parse$3(value);
}

function verifyName$3(param) {
  
}

var LatestUserBid = {
  Raw: Raw$3,
  query: query$3,
  parse: parse$3,
  serialize: serialize$3,
  verifyArgsAndParse: verifyArgsAndParse$3,
  verifyName: verifyName$3
};

var Raw$4 = {};

var query$4 = ((frag_0) => require("@apollo/client").gql`
  fragment BidStateFragment on BidState   {
    __typename
    id
    isClosed
    bidType: bidTypeV2  {
      __typename
      ...on LiveBidType   {
        __typename
        liveBidPhase
        bidMethod
      }
    }
    currentBid: currentBidV2  {
      ...AmountFragment
    }
    startingBid: startingBidV2  {
      ...AmountFragment
    }
    sold  {
      __typename
      ...on ResultHidden   {
        __typename
        lotId
      }
      ...on ResultVisible   {
        __typename
        isSold
        premiums  {
          __typename
          finalPrice: finalPriceV2  {
            ...AmountFragment
          }
        }
      }
    }
  }
  ${frag_0}
`)(Amount$LiveRoom.AmountFragment.query);

function parse$4(value) {
  var value$1 = value.bidType;
  var typename = value$1["__typename"];
  var tmp;
  if (typename === "LiveBidType") {
    var value$2 = value$1.liveBidPhase;
    var tmp$1;
    switch (value$2) {
      case "AcceptingBids" :
          tmp$1 = "AcceptingBids";
          break;
      case "Closed" :
          tmp$1 = "Closed";
          break;
      case "ConfirmingResult" :
          tmp$1 = "ConfirmingResult";
          break;
      case "Live" :
          tmp$1 = "Live";
          break;
      case "Preview" :
          tmp$1 = "Preview";
          break;
      case "Published" :
          tmp$1 = "Published";
          break;
      case "Upcoming" :
          tmp$1 = "Upcoming";
          break;
      default:
        tmp$1 = {
          NAME: "FutureAddedValue",
          VAL: value$2
        };
    }
    var value$3 = value$1.bidMethod;
    var tmp$2;
    switch (value$3) {
      case "Absentee" :
          tmp$2 = "Absentee";
          break;
      case "Advanced" :
          tmp$2 = "Advanced";
          break;
      default:
        tmp$2 = {
          NAME: "FutureAddedValue",
          VAL: value$3
        };
    }
    tmp = {
      NAME: "LiveBidType",
      VAL: {
        __typename: value$1.__typename,
        liveBidPhase: tmp$1,
        bidMethod: tmp$2
      }
    };
  } else {
    tmp = {
      NAME: "FutureAddedValue",
      VAL: value$1
    };
  }
  var value$4 = value.currentBid;
  var value$5 = value.startingBid;
  var value$6 = value.sold;
  var tmp$3;
  if (value$6 == null) {
    tmp$3 = undefined;
  } else {
    var typename$1 = value$6["__typename"];
    var tmp$4;
    switch (typename$1) {
      case "ResultHidden" :
          tmp$4 = {
            NAME: "ResultHidden",
            VAL: {
              __typename: value$6.__typename,
              lotId: value$6.lotId
            }
          };
          break;
      case "ResultVisible" :
          var value$7 = value$6.premiums;
          var tmp$5;
          if (value$7 == null) {
            tmp$5 = undefined;
          } else {
            var value$8 = value$7.finalPrice;
            tmp$5 = {
              __typename: value$7.__typename,
              finalPrice: !(value$8 == null) ? Amount$LiveRoom.AmountFragment.verifyArgsAndParse("AmountFragment", value$8) : undefined
            };
          }
          tmp$4 = {
            NAME: "ResultVisible",
            VAL: {
              __typename: value$6.__typename,
              isSold: value$6.isSold,
              premiums: tmp$5
            }
          };
          break;
      default:
        tmp$4 = {
          NAME: "FutureAddedValue",
          VAL: value$6
        };
    }
    tmp$3 = tmp$4;
  }
  return {
          __typename: value.__typename,
          id: value.id,
          isClosed: value.isClosed,
          bidType: tmp,
          currentBid: !(value$4 == null) ? Amount$LiveRoom.AmountFragment.verifyArgsAndParse("AmountFragment", value$4) : undefined,
          startingBid: !(value$5 == null) ? Amount$LiveRoom.AmountFragment.verifyArgsAndParse("AmountFragment", value$5) : undefined,
          sold: tmp$3
        };
}

function serialize$4(value) {
  var value$1 = value.sold;
  var sold;
  if (value$1 !== undefined) {
    var variant = value$1.NAME;
    if (variant === "FutureAddedValue") {
      sold = value$1.VAL;
    } else if (variant === "ResultHidden") {
      var value$2 = value$1.VAL.lotId;
      sold = {
        __typename: "ResultHidden",
        lotId: value$2
      };
    } else {
      var value$3 = value$1.VAL;
      var value$4 = value$3.premiums;
      var premiums;
      if (value$4 !== undefined) {
        var value$5 = value$4.finalPrice;
        var finalPrice = value$5 !== undefined ? Amount$LiveRoom.AmountFragment.serialize(value$5) : null;
        var value$6 = value$4.__typename;
        premiums = {
          __typename: value$6,
          finalPrice: finalPrice
        };
      } else {
        premiums = null;
      }
      var value$7 = value$3.isSold;
      sold = {
        __typename: "ResultVisible",
        isSold: value$7,
        premiums: premiums
      };
    }
  } else {
    sold = null;
  }
  var value$8 = value.startingBid;
  var startingBid = value$8 !== undefined ? Amount$LiveRoom.AmountFragment.serialize(value$8) : null;
  var value$9 = value.currentBid;
  var currentBid = value$9 !== undefined ? Amount$LiveRoom.AmountFragment.serialize(value$9) : null;
  var value$10 = value.bidType;
  var bidType;
  if (value$10.NAME === "FutureAddedValue") {
    bidType = value$10.VAL;
  } else {
    var value$11 = value$10.VAL;
    var value$12 = value$11.bidMethod;
    var bidMethod = typeof value$12 === "object" ? value$12.VAL : (
        value$12 === "Advanced" ? "Advanced" : "Absentee"
      );
    var value$13 = value$11.liveBidPhase;
    var liveBidPhase = typeof value$13 === "object" ? value$13.VAL : (
        value$13 === "Published" ? "Published" : (
            value$13 === "Upcoming" ? "Upcoming" : (
                value$13 === "ConfirmingResult" ? "ConfirmingResult" : (
                    value$13 === "Preview" ? "Preview" : (
                        value$13 === "AcceptingBids" ? "AcceptingBids" : (
                            value$13 === "Live" ? "Live" : "Closed"
                          )
                      )
                  )
              )
          )
      );
    bidType = {
      __typename: "LiveBidType",
      liveBidPhase: liveBidPhase,
      bidMethod: bidMethod
    };
  }
  var value$14 = value.isClosed;
  var value$15 = value.id;
  var value$16 = value.__typename;
  return {
          __typename: value$16,
          id: value$15,
          isClosed: value$14,
          bidType: bidType,
          currentBid: currentBid,
          startingBid: startingBid,
          sold: sold
        };
}

function verifyArgsAndParse$4(_BidStateFragment, value) {
  return parse$4(value);
}

function verifyName$4(param) {
  
}

var BidStateFragment = {
  Raw: Raw$4,
  query: query$4,
  parse: parse$4,
  serialize: serialize$4,
  verifyArgsAndParse: verifyArgsAndParse$4,
  verifyName: verifyName$4
};

var Raw$5 = {};

var query$5 = (require("@apollo/client").gql`
  fragment LotWithdrawnStateFragment on LotWithdrawnState   {
    __typename
    id
    state
  }
`);

function parse$5(value) {
  var value$1 = value.state;
  var tmp;
  switch (value$1) {
    case "NotAffected" :
        tmp = "NotAffected";
        break;
    case "UnWithdrawn" :
        tmp = "UnWithdrawn";
        break;
    case "Withdrawn" :
        tmp = "Withdrawn";
        break;
    default:
      tmp = {
        NAME: "FutureAddedValue",
        VAL: value$1
      };
  }
  return {
          __typename: value.__typename,
          id: value.id,
          state: tmp
        };
}

function serialize$5(value) {
  var value$1 = value.state;
  var state = typeof value$1 === "object" ? value$1.VAL : (
      value$1 === "Withdrawn" ? "Withdrawn" : (
          value$1 === "NotAffected" ? "NotAffected" : "UnWithdrawn"
        )
    );
  var value$2 = value.id;
  var value$3 = value.__typename;
  return {
          __typename: value$3,
          id: value$2,
          state: state
        };
}

function verifyArgsAndParse$5(_LotWithdrawnStateFragment, value) {
  return parse$5(value);
}

function verifyName$5(param) {
  
}

var LotWithdrawnStateFragment = {
  Raw: Raw$5,
  query: query$5,
  parse: parse$5,
  serialize: serialize$5,
  verifyArgsAndParse: verifyArgsAndParse$5,
  verifyName: verifyName$5
};

var Raw$6 = {};

var query$6 = ((frag_0, frag_1, frag_2, frag_3, frag_4) => require("@apollo/client").gql`
  fragment LotCardFragment on LotCard   {
    __typename
    id
    lotId
    title
    subtitle
    creatorsDisplayNames
    estimate: estimateV2  {
      __typename
      ...on EstimateUponRequest   {
        __typename
        estimateUponRequest
      }
      ...on LowHighEstimateV2   {
        __typename
        lowEstimate  {
          ...AmountFragment
        }
        highEstimate  {
          ...AmountFragment
        }
      }
    }
    lotNumber  {
      __typename
      ...on VisibleLotNumber   {
        __typename
        lotNumber
      }
      ...on HiddenLotNumber   {
        __typename
        isHidden
      }
    }
    bidState  {
      ...BidStateFragment
    }
    latestBid  {
      ...LatestUserBid
    }
    withdrawnState  {
      ...LotWithdrawnStateFragment
    }
    premiumLotState  {
      ...PremiumLotStateFragment
    }
    parcel  {
      __typename
      parcelId
      parcelName
    }
    lotTags
  }
  ${frag_0}
  ${frag_1}
  ${frag_2}
  ${frag_3}
  ${frag_4}
`)(Amount$LiveRoom.AmountFragment.query, query$4, query$3, query$5, query$1);

function parse$6(value) {
  var value$1 = value.subtitle;
  var value$2 = value.creatorsDisplayNames;
  var value$3 = value.estimate;
  var tmp;
  if (value$3 == null) {
    tmp = undefined;
  } else {
    var typename = value$3["__typename"];
    var tmp$1;
    switch (typename) {
      case "EstimateUponRequest" :
          tmp$1 = {
            NAME: "EstimateUponRequest",
            VAL: {
              __typename: value$3.__typename,
              estimateUponRequest: value$3.estimateUponRequest
            }
          };
          break;
      case "LowHighEstimateV2" :
          var value$4 = value$3.lowEstimate;
          var value$5 = value$3.highEstimate;
          tmp$1 = {
            NAME: "LowHighEstimateV2",
            VAL: {
              __typename: value$3.__typename,
              lowEstimate: Amount$LiveRoom.AmountFragment.verifyArgsAndParse("AmountFragment", value$4),
              highEstimate: Amount$LiveRoom.AmountFragment.verifyArgsAndParse("AmountFragment", value$5)
            }
          };
          break;
      default:
        tmp$1 = {
          NAME: "FutureAddedValue",
          VAL: value$3
        };
    }
    tmp = tmp$1;
  }
  var value$6 = value.lotNumber;
  var typename$1 = value$6["__typename"];
  var tmp$2;
  switch (typename$1) {
    case "HiddenLotNumber" :
        tmp$2 = {
          NAME: "HiddenLotNumber",
          VAL: {
            __typename: value$6.__typename,
            isHidden: value$6.isHidden
          }
        };
        break;
    case "VisibleLotNumber" :
        tmp$2 = {
          NAME: "VisibleLotNumber",
          VAL: {
            __typename: value$6.__typename,
            lotNumber: value$6.lotNumber
          }
        };
        break;
    default:
      tmp$2 = {
        NAME: "FutureAddedValue",
        VAL: value$6
      };
  }
  var value$7 = value.bidState;
  var value$8 = value.parcel;
  var value$9 = value.lotTags;
  return {
          __typename: value.__typename,
          id: value.id,
          lotId: value.lotId,
          title: value.title,
          subtitle: !(value$1 == null) ? value$1 : undefined,
          creatorsDisplayNames: !(value$2 == null) ? Js_array.map((function (value) {
                    return value;
                  }), value$2) : undefined,
          estimate: tmp,
          lotNumber: tmp$2,
          bidState: !(value$7 == null) ? parse$4(value$7) : undefined,
          latestBid: parse$3(value.latestBid),
          withdrawnState: parse$5(value.withdrawnState),
          premiumLotState: parse$1(value.premiumLotState),
          parcel: !(value$8 == null) ? ({
                __typename: value$8.__typename,
                parcelId: value$8.parcelId,
                parcelName: value$8.parcelName
              }) : undefined,
          lotTags: !(value$9 == null) ? Js_array.map((function (value) {
                    return value;
                  }), value$9) : undefined
        };
}

function serialize$6(value) {
  var value$1 = value.lotTags;
  var lotTags = value$1 !== undefined ? Js_array.map((function (value) {
            return value;
          }), value$1) : null;
  var value$2 = value.parcel;
  var parcel;
  if (value$2 !== undefined) {
    var value$3 = value$2.parcelName;
    var value$4 = value$2.parcelId;
    var value$5 = value$2.__typename;
    parcel = {
      __typename: value$5,
      parcelId: value$4,
      parcelName: value$3
    };
  } else {
    parcel = null;
  }
  var value$6 = value.premiumLotState;
  var premiumLotState = serialize$1(value$6);
  var value$7 = value.withdrawnState;
  var withdrawnState = serialize$5(value$7);
  var value$8 = value.latestBid;
  var latestBid = serialize$3(value$8);
  var value$9 = value.bidState;
  var bidState = value$9 !== undefined ? serialize$4(value$9) : null;
  var value$10 = value.lotNumber;
  var variant = value$10.NAME;
  var lotNumber;
  if (variant === "VisibleLotNumber") {
    var value$11 = value$10.VAL.lotNumber;
    lotNumber = {
      __typename: "VisibleLotNumber",
      lotNumber: value$11
    };
  } else if (variant === "HiddenLotNumber") {
    var value$12 = value$10.VAL.isHidden;
    lotNumber = {
      __typename: "HiddenLotNumber",
      isHidden: value$12
    };
  } else {
    lotNumber = value$10.VAL;
  }
  var value$13 = value.estimate;
  var estimate;
  if (value$13 !== undefined) {
    var variant$1 = value$13.NAME;
    if (variant$1 === "LowHighEstimateV2") {
      var value$14 = value$13.VAL;
      var value$15 = value$14.highEstimate;
      var highEstimate = Amount$LiveRoom.AmountFragment.serialize(value$15);
      var value$16 = value$14.lowEstimate;
      var lowEstimate = Amount$LiveRoom.AmountFragment.serialize(value$16);
      estimate = {
        __typename: "LowHighEstimateV2",
        lowEstimate: lowEstimate,
        highEstimate: highEstimate
      };
    } else if (variant$1 === "FutureAddedValue") {
      estimate = value$13.VAL;
    } else {
      var value$17 = value$13.VAL.estimateUponRequest;
      estimate = {
        __typename: "EstimateUponRequest",
        estimateUponRequest: value$17
      };
    }
  } else {
    estimate = null;
  }
  var value$18 = value.creatorsDisplayNames;
  var creatorsDisplayNames = value$18 !== undefined ? Js_array.map((function (value) {
            return value;
          }), value$18) : null;
  var value$19 = value.subtitle;
  var subtitle = value$19 !== undefined ? value$19 : null;
  var value$20 = value.title;
  var value$21 = value.lotId;
  var value$22 = value.id;
  var value$23 = value.__typename;
  return {
          __typename: value$23,
          id: value$22,
          lotId: value$21,
          title: value$20,
          subtitle: subtitle,
          creatorsDisplayNames: creatorsDisplayNames,
          estimate: estimate,
          lotNumber: lotNumber,
          bidState: bidState,
          latestBid: latestBid,
          withdrawnState: withdrawnState,
          premiumLotState: premiumLotState,
          parcel: parcel,
          lotTags: lotTags
        };
}

function verifyArgsAndParse$6(_LotCardFragment, value) {
  return parse$6(value);
}

function verifyName$6(param) {
  
}

var LotCardFragment = {
  Raw: Raw$6,
  query: query$6,
  parse: parse$6,
  serialize: serialize$6,
  verifyArgsAndParse: verifyArgsAndParse$6,
  verifyName: verifyName$6
};

var Raw$7 = {};

var query$7 = ((frag_0) => require("@apollo/client").gql`
  fragment LotCardListAuctionFragment on Auction   {
    __typename
    useCreatorSplit
    sessions  {
      __typename
      sessionId
      title
      lotCards  {
        ...LotCardFragment
      }
      lotRange  {
        __typename
        fromLotNr
        toLotNr
      }
      state: stateV2  {
        __typename
        state
      }
      scheduledOpeningDate
    }
    slug  {
      __typename
      name
      year
    }
  }
  ${frag_0}
`)(query$6);

function parse$7(value) {
  var value$1 = value.sessions;
  var value$2 = value.slug;
  return {
          __typename: value.__typename,
          useCreatorSplit: value.useCreatorSplit,
          sessions: Js_array.map((function (value) {
                  var value$1 = value.title;
                  var value$2 = value.lotCards;
                  var value$3 = value.lotRange;
                  var value$4 = value.state;
                  var value$5 = value$4.state;
                  var tmp;
                  switch (value$5) {
                    case "Closed" :
                        tmp = "Closed";
                        break;
                    case "Open" :
                        tmp = "Open";
                        break;
                    case "PreOpen" :
                        tmp = "PreOpen";
                        break;
                    default:
                      tmp = {
                        NAME: "FutureAddedValue",
                        VAL: value$5
                      };
                  }
                  return {
                          __typename: value.__typename,
                          sessionId: value.sessionId,
                          title: !(value$1 == null) ? value$1 : undefined,
                          lotCards: !(value$2 == null) ? Js_array.map(parse$6, value$2) : undefined,
                          lotRange: !(value$3 == null) ? ({
                                __typename: value$3.__typename,
                                fromLotNr: value$3.fromLotNr,
                                toLotNr: value$3.toLotNr
                              }) : undefined,
                          state: {
                            __typename: value$4.__typename,
                            state: tmp
                          },
                          scheduledOpeningDate: value.scheduledOpeningDate
                        };
                }), value$1),
          slug: {
            __typename: value$2.__typename,
            name: value$2.name,
            year: value$2.year
          }
        };
}

function serialize$7(value) {
  var value$1 = value.slug;
  var value$2 = value$1.year;
  var value$3 = value$1.name;
  var value$4 = value$1.__typename;
  var slug = {
    __typename: value$4,
    name: value$3,
    year: value$2
  };
  var value$5 = value.sessions;
  var sessions = Js_array.map((function (value) {
          var value$1 = value.scheduledOpeningDate;
          var value$2 = value.state;
          var value$3 = value$2.state;
          var state = typeof value$3 === "object" ? value$3.VAL : (
              value$3 === "PreOpen" ? "PreOpen" : (
                  value$3 === "Open" ? "Open" : "Closed"
                )
            );
          var value$4 = value$2.__typename;
          var state$1 = {
            __typename: value$4,
            state: state
          };
          var value$5 = value.lotRange;
          var lotRange;
          if (value$5 !== undefined) {
            var value$6 = value$5.toLotNr;
            var value$7 = value$5.fromLotNr;
            var value$8 = value$5.__typename;
            lotRange = {
              __typename: value$8,
              fromLotNr: value$7,
              toLotNr: value$6
            };
          } else {
            lotRange = null;
          }
          var value$9 = value.lotCards;
          var lotCards = value$9 !== undefined ? Js_array.map(serialize$6, value$9) : null;
          var value$10 = value.title;
          var title = value$10 !== undefined ? value$10 : null;
          var value$11 = value.sessionId;
          var value$12 = value.__typename;
          return {
                  __typename: value$12,
                  sessionId: value$11,
                  title: title,
                  lotCards: lotCards,
                  lotRange: lotRange,
                  state: state$1,
                  scheduledOpeningDate: value$1
                };
        }), value$5);
  var value$6 = value.useCreatorSplit;
  var value$7 = value.__typename;
  return {
          __typename: value$7,
          useCreatorSplit: value$6,
          sessions: sessions,
          slug: slug
        };
}

function verifyArgsAndParse$7(_LotCardListAuctionFragment, value) {
  return parse$7(value);
}

function verifyName$7(param) {
  
}

var LotCardListAuctionFragment = {
  Raw: Raw$7,
  query: query$7,
  parse: parse$7,
  serialize: serialize$7,
  verifyArgsAndParse: verifyArgsAndParse$7,
  verifyName: verifyName$7
};

var LotCard = {
  PremiumLotStateFragment: undefined,
  LatestUserBid: LatestUserBid,
  BidStateFragment: BidStateFragment,
  LotWithdrawnStateFragment: LotWithdrawnStateFragment,
  LotCardFragment: LotCardFragment,
  LotCardListAuctionFragment: LotCardListAuctionFragment
};

var Raw$8 = {};

var query$8 = (require("@apollo/client").gql`
  fragment AgreementsFragment on Auction   {
    __typename
    agreements  {
      __typename
      agreementId
      accepted
    }
  }
`);

function parse$8(value) {
  var value$1 = value.agreements;
  return {
          __typename: value.__typename,
          agreements: Js_array.map((function (value) {
                  var value$1 = value.accepted;
                  return {
                          __typename: value.__typename,
                          agreementId: value.agreementId,
                          accepted: !(value$1 == null) ? value$1 : undefined
                        };
                }), value$1)
        };
}

function serialize$8(value) {
  var value$1 = value.agreements;
  var agreements = Js_array.map((function (value) {
          var value$1 = value.accepted;
          var accepted = value$1 !== undefined ? value$1 : null;
          var value$2 = value.agreementId;
          var value$3 = value.__typename;
          return {
                  __typename: value$3,
                  agreementId: value$2,
                  accepted: accepted
                };
        }), value$1);
  var value$2 = value.__typename;
  return {
          __typename: value$2,
          agreements: agreements
        };
}

function verifyArgsAndParse$8(_AgreementsFragment, value) {
  return parse$8(value);
}

function verifyName$8(param) {
  
}

var AgreementsFragment = {
  Raw: Raw$8,
  query: query$8,
  parse: parse$8,
  serialize: serialize$8,
  verifyArgsAndParse: verifyArgsAndParse$8,
  verifyName: verifyName$8
};

var Agreements = {
  AgreementsFragment: AgreementsFragment
};

var Raw$9 = {};

var query$9 = ((frag_0) => require("@apollo/client").gql`
  fragment AuctionEnrollmentModalFragment on Auction   {
    __typename
    auctionId
    type
    location: locationV2  {
      __typename
      displayLocation  {
        __typename
        name
      }
      name
    }
    enrollment  {
      __typename
      restrictedDate
    }
    conditionsOfSale
    ...AgreementsFragment
  }
  ${frag_0}
`)(query$8);

function parse$9(value) {
  var value$1 = value["type"];
  var tmp;
  switch (value$1) {
    case "Live" :
        tmp = "Live";
        break;
    case "Timed" :
        tmp = "Timed";
        break;
    default:
      tmp = {
        NAME: "FutureAddedValue",
        VAL: value$1
      };
  }
  var value$2 = value["location"];
  var tmp$1;
  if (value$2 == null) {
    tmp$1 = undefined;
  } else {
    var value$3 = value$2.displayLocation;
    tmp$1 = {
      __typename: value$2.__typename,
      displayLocation: {
        __typename: value$3.__typename,
        name: value$3.name
      },
      name: value$2.name
    };
  }
  var value$4 = value["enrollment"];
  var value$5 = value$4.restrictedDate;
  var value$6 = value["conditionsOfSale"];
  return {
          __typename: value["__typename"],
          auctionId: value["auctionId"],
          type: tmp,
          location: tmp$1,
          enrollment: {
            __typename: value$4.__typename,
            restrictedDate: !(value$5 == null) ? Caml_option.some(value$5) : undefined
          },
          conditionsOfSale: !(value$6 == null) ? Caml_option.some(value$6) : undefined,
          agreementsFragment: parse$8(value)
        };
}

function serialize$9(value) {
  var value$1 = value.conditionsOfSale;
  var conditionsOfSale = value$1 !== undefined ? Caml_option.valFromOption(value$1) : null;
  var value$2 = value.enrollment;
  var value$3 = value$2.restrictedDate;
  var restrictedDate = value$3 !== undefined ? Caml_option.valFromOption(value$3) : null;
  var value$4 = value$2.__typename;
  var enrollment = {
    __typename: value$4,
    restrictedDate: restrictedDate
  };
  var value$5 = value.location;
  var $$location;
  if (value$5 !== undefined) {
    var value$6 = value$5.name;
    var value$7 = value$5.displayLocation;
    var value$8 = value$7.name;
    var value$9 = value$7.__typename;
    var displayLocation = {
      __typename: value$9,
      name: value$8
    };
    var value$10 = value$5.__typename;
    $$location = {
      __typename: value$10,
      displayLocation: displayLocation,
      name: value$6
    };
  } else {
    $$location = null;
  }
  var value$11 = value.type;
  var type_ = typeof value$11 === "object" ? value$11.VAL : (
      value$11 === "Live" ? "Live" : "Timed"
    );
  var value$12 = value.auctionId;
  var value$13 = value.__typename;
  return Js_array.reduce(GraphQL_PPX.deepMerge, {
              __typename: value$13,
              auctionId: value$12,
              type_: type_,
              location: $$location,
              enrollment: enrollment,
              conditionsOfSale: conditionsOfSale
            }, [serialize$8(value.agreementsFragment)]);
}

function verifyArgsAndParse$9(_AuctionEnrollmentModalFragment, value) {
  return parse$9(value);
}

function verifyName$9(param) {
  
}

var AuctionEnrollmentModalFragment = {
  Raw: Raw$9,
  query: query$9,
  parse: parse$9,
  serialize: serialize$9,
  verifyArgsAndParse: verifyArgsAndParse$9,
  verifyName: verifyName$9
};

var Raw$10 = {};

var query$10 = (require("@apollo/client").gql`
  mutation RequestToEnrollMutation($auctionId: String!, $accountId: String!, $registrationType: RegistrationType!, $isAgentBidder: Boolean)  {
    requestToEnroll(auctionId: $auctionId, accountId: $accountId, registrationType: $registrationType, isAgentBidder: $isAgentBidder)  {
      __typename
      paddle
      enrollmentResult  {
        __typename
        ...on EnrollmentAccepted   {
          __typename
          paddleId
        }
        ...on EnrollmentUpForReview   {
          __typename
          auctionId
          enrollmentUpForReviewReason
        }
        ...on EnrollmentDeclined   {
          __typename
          auctionId
        }
      }
    }
  }
`);

function parse$10(value) {
  var value$1 = value.requestToEnroll;
  var value$2 = value$1.paddle;
  var value$3 = value$1.enrollmentResult;
  var tmp;
  if (value$3 == null) {
    tmp = undefined;
  } else {
    var typename = value$3["__typename"];
    var tmp$1;
    switch (typename) {
      case "EnrollmentAccepted" :
          tmp$1 = {
            NAME: "EnrollmentAccepted",
            VAL: {
              __typename: value$3.__typename,
              paddleId: value$3.paddleId
            }
          };
          break;
      case "EnrollmentDeclined" :
          tmp$1 = {
            NAME: "EnrollmentDeclined",
            VAL: {
              __typename: value$3.__typename,
              auctionId: value$3.auctionId
            }
          };
          break;
      case "EnrollmentUpForReview" :
          var value$4 = value$3.enrollmentUpForReviewReason;
          var tmp$2;
          if (value$4 == null) {
            tmp$2 = undefined;
          } else {
            var tmp$3;
            switch (value$4) {
              case "IdAgentException" :
                  tmp$3 = "IdAgentException";
                  break;
              case "InRestrictedAuction" :
                  tmp$3 = "InRestrictedAuction";
                  break;
              default:
                tmp$3 = {
                  NAME: "FutureAddedValue",
                  VAL: value$4
                };
            }
            tmp$2 = tmp$3;
          }
          tmp$1 = {
            NAME: "EnrollmentUpForReview",
            VAL: {
              __typename: value$3.__typename,
              auctionId: value$3.auctionId,
              enrollmentUpForReviewReason: tmp$2
            }
          };
          break;
      default:
        tmp$1 = {
          NAME: "FutureAddedValue",
          VAL: value$3
        };
    }
    tmp = tmp$1;
  }
  return {
          requestToEnroll: {
            __typename: value$1.__typename,
            paddle: !(value$2 == null) ? value$2 : undefined,
            enrollmentResult: tmp
          }
        };
}

function serialize$10(value) {
  var value$1 = value.requestToEnroll;
  var value$2 = value$1.enrollmentResult;
  var enrollmentResult;
  if (value$2 !== undefined) {
    var variant = value$2.NAME;
    if (variant === "EnrollmentDeclined") {
      var value$3 = value$2.VAL.auctionId;
      enrollmentResult = {
        __typename: "EnrollmentDeclined",
        auctionId: value$3
      };
    } else if (variant === "FutureAddedValue") {
      enrollmentResult = value$2.VAL;
    } else if (variant === "EnrollmentUpForReview") {
      var value$4 = value$2.VAL;
      var value$5 = value$4.enrollmentUpForReviewReason;
      var enrollmentUpForReviewReason = value$5 !== undefined ? (
          typeof value$5 === "object" ? value$5.VAL : (
              value$5 === "InRestrictedAuction" ? "InRestrictedAuction" : "IdAgentException"
            )
        ) : null;
      var value$6 = value$4.auctionId;
      enrollmentResult = {
        __typename: "EnrollmentUpForReview",
        auctionId: value$6,
        enrollmentUpForReviewReason: enrollmentUpForReviewReason
      };
    } else {
      var value$7 = value$2.VAL.paddleId;
      enrollmentResult = {
        __typename: "EnrollmentAccepted",
        paddleId: value$7
      };
    }
  } else {
    enrollmentResult = null;
  }
  var value$8 = value$1.paddle;
  var paddle = value$8 !== undefined ? value$8 : null;
  var value$9 = value$1.__typename;
  var requestToEnroll = {
    __typename: value$9,
    paddle: paddle,
    enrollmentResult: enrollmentResult
  };
  return {
          requestToEnroll: requestToEnroll
        };
}

function serializeVariables(inp) {
  var a = inp.registrationType;
  var a$1 = inp.isAgentBidder;
  return {
          auctionId: inp.auctionId,
          accountId: inp.accountId,
          registrationType: a === "Online" ? "Online" : "SaleRoom",
          isAgentBidder: a$1 !== undefined ? a$1 : undefined
        };
}

function makeVariables(auctionId, accountId, registrationType, isAgentBidder, param) {
  return {
          auctionId: auctionId,
          accountId: accountId,
          registrationType: registrationType,
          isAgentBidder: isAgentBidder
        };
}

var RequestToEnrollMutation_inner = {
  Raw: Raw$10,
  query: query$10,
  parse: parse$10,
  serialize: serialize$10,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};

var include = ApolloClient__React_Hooks_UseMutation.Extend({
      query: query$10,
      Raw: Raw$10,
      parse: parse$10,
      serialize: serialize$10,
      serializeVariables: serializeVariables
    });

var RequestToEnrollMutation_use = include.use;

var RequestToEnrollMutation_useWithVariables = include.useWithVariables;

var RequestToEnrollMutation = {
  RequestToEnrollMutation_inner: RequestToEnrollMutation_inner,
  Raw: Raw$10,
  query: query$10,
  parse: parse$10,
  serialize: serialize$10,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  use: RequestToEnrollMutation_use,
  useWithVariables: RequestToEnrollMutation_useWithVariables
};

var Raw$11 = {};

var query$11 = (require("@apollo/client").gql`
  mutation SetAgreementStatusMutation($agreementId: String!, $accepted: Boolean!)  {
    setAgreementStatus(agreementId: $agreementId, status: $accepted)  {
      __typename
      agreementId
      accepted
    }
  }
`);

function parse$11(value) {
  var value$1 = value.setAgreementStatus;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.accepted;
    tmp = {
      __typename: value$1.__typename,
      agreementId: value$1.agreementId,
      accepted: !(value$2 == null) ? value$2 : undefined
    };
  }
  return {
          setAgreementStatus: tmp
        };
}

function serialize$11(value) {
  var value$1 = value.setAgreementStatus;
  var setAgreementStatus;
  if (value$1 !== undefined) {
    var value$2 = value$1.accepted;
    var accepted = value$2 !== undefined ? value$2 : null;
    var value$3 = value$1.agreementId;
    var value$4 = value$1.__typename;
    setAgreementStatus = {
      __typename: value$4,
      agreementId: value$3,
      accepted: accepted
    };
  } else {
    setAgreementStatus = null;
  }
  return {
          setAgreementStatus: setAgreementStatus
        };
}

function serializeVariables$1(inp) {
  return {
          agreementId: inp.agreementId,
          accepted: inp.accepted
        };
}

function makeVariables$1(agreementId, accepted, param) {
  return {
          agreementId: agreementId,
          accepted: accepted
        };
}

var SetAgreementStatusMutation_inner = {
  Raw: Raw$11,
  query: query$11,
  parse: parse$11,
  serialize: serialize$11,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1
};

var include$1 = ApolloClient__React_Hooks_UseMutation.Extend({
      query: query$11,
      Raw: Raw$11,
      parse: parse$11,
      serialize: serialize$11,
      serializeVariables: serializeVariables$1
    });

var SetAgreementStatusMutation_use = include$1.use;

var SetAgreementStatusMutation_useWithVariables = include$1.useWithVariables;

var SetAgreementStatusMutation = {
  SetAgreementStatusMutation_inner: SetAgreementStatusMutation_inner,
  Raw: Raw$11,
  query: query$11,
  parse: parse$11,
  serialize: serialize$11,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1,
  use: SetAgreementStatusMutation_use,
  useWithVariables: SetAgreementStatusMutation_useWithVariables
};

var AuctionEnrollmentModal = {
  AgreementsFragment: undefined,
  AuctionEnrollmentModalFragment: AuctionEnrollmentModalFragment,
  RequestToEnrollMutation: RequestToEnrollMutation,
  SetAgreementStatusMutation: SetAgreementStatusMutation
};

var Raw$12 = {};

var query$12 = (require("@apollo/client").gql`
  query AuctionOverviewQuery($auctionId: String!)  {
    auction(id: $auctionId)  {
      __typename
      overview
    }
  }
`);

function parse$12(value) {
  var value$1 = value.auction;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.overview;
    tmp = {
      __typename: value$1.__typename,
      overview: !(value$2 == null) ? value$2 : undefined
    };
  }
  return {
          auction: tmp
        };
}

function serialize$12(value) {
  var value$1 = value.auction;
  var auction;
  if (value$1 !== undefined) {
    var value$2 = value$1.overview;
    var overview = value$2 !== undefined ? value$2 : null;
    var value$3 = value$1.__typename;
    auction = {
      __typename: value$3,
      overview: overview
    };
  } else {
    auction = null;
  }
  return {
          auction: auction
        };
}

function serializeVariables$2(inp) {
  return {
          auctionId: inp.auctionId
        };
}

function makeVariables$2(auctionId, param) {
  return {
          auctionId: auctionId
        };
}

var AuctionOverviewQuery_inner = {
  Raw: Raw$12,
  query: query$12,
  parse: parse$12,
  serialize: serialize$12,
  serializeVariables: serializeVariables$2,
  makeVariables: makeVariables$2
};

var include$2 = ApolloClient__React_Hooks_UseQuery.Extend({
      query: query$12,
      Raw: Raw$12,
      parse: parse$12,
      serialize: serialize$12,
      serializeVariables: serializeVariables$2
    });

var AuctionOverviewQuery_refetchQueryDescription = include$2.refetchQueryDescription;

var AuctionOverviewQuery_use = include$2.use;

var AuctionOverviewQuery_useLazy = include$2.useLazy;

var AuctionOverviewQuery_useLazyWithVariables = include$2.useLazyWithVariables;

var AuctionOverviewQuery = {
  AuctionOverviewQuery_inner: AuctionOverviewQuery_inner,
  Raw: Raw$12,
  query: query$12,
  parse: parse$12,
  serialize: serialize$12,
  serializeVariables: serializeVariables$2,
  makeVariables: makeVariables$2,
  refetchQueryDescription: AuctionOverviewQuery_refetchQueryDescription,
  use: AuctionOverviewQuery_use,
  useLazy: AuctionOverviewQuery_useLazy,
  useLazyWithVariables: AuctionOverviewQuery_useLazyWithVariables
};

var Raw$13 = {};

var query$13 = (require("@apollo/client").gql`
  query AuctionTermsQuery($auctionId: String!)  {
    auction(id: $auctionId)  {
      __typename
      conditionsOfSale
    }
  }
`);

function parse$13(value) {
  var value$1 = value.auction;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.conditionsOfSale;
    tmp = {
      __typename: value$1.__typename,
      conditionsOfSale: !(value$2 == null) ? Caml_option.some(value$2) : undefined
    };
  }
  return {
          auction: tmp
        };
}

function serialize$13(value) {
  var value$1 = value.auction;
  var auction;
  if (value$1 !== undefined) {
    var value$2 = value$1.conditionsOfSale;
    var conditionsOfSale = value$2 !== undefined ? Caml_option.valFromOption(value$2) : null;
    var value$3 = value$1.__typename;
    auction = {
      __typename: value$3,
      conditionsOfSale: conditionsOfSale
    };
  } else {
    auction = null;
  }
  return {
          auction: auction
        };
}

function serializeVariables$3(inp) {
  return {
          auctionId: inp.auctionId
        };
}

function makeVariables$3(auctionId, param) {
  return {
          auctionId: auctionId
        };
}

var AuctionTermsQuery_inner = {
  Raw: Raw$13,
  query: query$13,
  parse: parse$13,
  serialize: serialize$13,
  serializeVariables: serializeVariables$3,
  makeVariables: makeVariables$3
};

var include$3 = ApolloClient__React_Hooks_UseQuery.Extend({
      query: query$13,
      Raw: Raw$13,
      parse: parse$13,
      serialize: serialize$13,
      serializeVariables: serializeVariables$3
    });

var AuctionTermsQuery_refetchQueryDescription = include$3.refetchQueryDescription;

var AuctionTermsQuery_use = include$3.use;

var AuctionTermsQuery_useLazy = include$3.useLazy;

var AuctionTermsQuery_useLazyWithVariables = include$3.useLazyWithVariables;

var AuctionTermsQuery = {
  AuctionTermsQuery_inner: AuctionTermsQuery_inner,
  Raw: Raw$13,
  query: query$13,
  parse: parse$13,
  serialize: serialize$13,
  serializeVariables: serializeVariables$3,
  makeVariables: makeVariables$3,
  refetchQueryDescription: AuctionTermsQuery_refetchQueryDescription,
  use: AuctionTermsQuery_use,
  useLazy: AuctionTermsQuery_useLazy,
  useLazyWithVariables: AuctionTermsQuery_useLazyWithVariables
};

var AuctionInfo = {
  AuctionOverviewQuery: AuctionOverviewQuery,
  AuctionTermsQuery: AuctionTermsQuery
};

var Raw$14 = {};

var query$14 = ((frag_0) => require("@apollo/client").gql`
  query BetweenSessionModalQuery($auctionId: String!)  {
    auction(id: $auctionId)  {
      __typename
      id
      title
      sessions  {
        __typename
        scheduledOpeningDate
        sessionId
        title
        state: stateV2  {
          ...SessionStateFragment
        }
        lotRange  {
          __typename
          fromLotNr
        }
      }
      slug  {
        __typename
        name
        year
      }
    }
  }
  ${frag_0}
`)(query$2);

function parse$14(value) {
  var value$1 = value.auction;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.title;
    var value$3 = value$1.sessions;
    var value$4 = value$1.slug;
    tmp = {
      __typename: value$1.__typename,
      id: value$1.id,
      title: !(value$2 == null) ? value$2 : undefined,
      sessions: Js_array.map((function (value) {
              var value$1 = value.title;
              var value$2 = value.lotRange;
              return {
                      __typename: value.__typename,
                      scheduledOpeningDate: value.scheduledOpeningDate,
                      sessionId: value.sessionId,
                      title: !(value$1 == null) ? value$1 : undefined,
                      state: parse$2(value.state),
                      lotRange: !(value$2 == null) ? ({
                            __typename: value$2.__typename,
                            fromLotNr: value$2.fromLotNr
                          }) : undefined
                    };
            }), value$3),
      slug: {
        __typename: value$4.__typename,
        name: value$4.name,
        year: value$4.year
      }
    };
  }
  return {
          auction: tmp
        };
}

function serialize$14(value) {
  var value$1 = value.auction;
  var auction;
  if (value$1 !== undefined) {
    var value$2 = value$1.slug;
    var value$3 = value$2.year;
    var value$4 = value$2.name;
    var value$5 = value$2.__typename;
    var slug = {
      __typename: value$5,
      name: value$4,
      year: value$3
    };
    var value$6 = value$1.sessions;
    var sessions = Js_array.map((function (value) {
            var value$1 = value.lotRange;
            var lotRange;
            if (value$1 !== undefined) {
              var value$2 = value$1.fromLotNr;
              var value$3 = value$1.__typename;
              lotRange = {
                __typename: value$3,
                fromLotNr: value$2
              };
            } else {
              lotRange = null;
            }
            var value$4 = value.state;
            var state = serialize$2(value$4);
            var value$5 = value.title;
            var title = value$5 !== undefined ? value$5 : null;
            var value$6 = value.sessionId;
            var value$7 = value.scheduledOpeningDate;
            var value$8 = value.__typename;
            return {
                    __typename: value$8,
                    scheduledOpeningDate: value$7,
                    sessionId: value$6,
                    title: title,
                    state: state,
                    lotRange: lotRange
                  };
          }), value$6);
    var value$7 = value$1.title;
    var title = value$7 !== undefined ? value$7 : null;
    var value$8 = value$1.id;
    var value$9 = value$1.__typename;
    auction = {
      __typename: value$9,
      id: value$8,
      title: title,
      sessions: sessions,
      slug: slug
    };
  } else {
    auction = null;
  }
  return {
          auction: auction
        };
}

function serializeVariables$4(inp) {
  return {
          auctionId: inp.auctionId
        };
}

function makeVariables$4(auctionId, param) {
  return {
          auctionId: auctionId
        };
}

var BetweenSessionModalQuery_inner = {
  Raw: Raw$14,
  query: query$14,
  parse: parse$14,
  serialize: serialize$14,
  serializeVariables: serializeVariables$4,
  makeVariables: makeVariables$4
};

var include$4 = ApolloClient__React_Hooks_UseQuery.Extend({
      query: query$14,
      Raw: Raw$14,
      parse: parse$14,
      serialize: serialize$14,
      serializeVariables: serializeVariables$4
    });

var BetweenSessionModalQuery_refetchQueryDescription = include$4.refetchQueryDescription;

var BetweenSessionModalQuery_use = include$4.use;

var BetweenSessionModalQuery_useLazy = include$4.useLazy;

var BetweenSessionModalQuery_useLazyWithVariables = include$4.useLazyWithVariables;

var BetweenSessionModalQuery = {
  BetweenSessionModalQuery_inner: BetweenSessionModalQuery_inner,
  Raw: Raw$14,
  query: query$14,
  parse: parse$14,
  serialize: serialize$14,
  serializeVariables: serializeVariables$4,
  makeVariables: makeVariables$4,
  refetchQueryDescription: BetweenSessionModalQuery_refetchQueryDescription,
  use: BetweenSessionModalQuery_use,
  useLazy: BetweenSessionModalQuery_useLazy,
  useLazyWithVariables: BetweenSessionModalQuery_useLazyWithVariables
};

var BetweenSessionModal = {
  SessionStateFragment: undefined,
  BetweenSessionModalQuery: BetweenSessionModalQuery
};

var Raw$15 = {};

var query$15 = ((frag_0) => require("@apollo/client").gql`
  fragment LotDetailsLotFragment on LotV2   {
    __typename
    lotId
    title
    subtitle
    creatorPrefix
    lotTags
    description
    conditionReport
    conditionDisclaimer
    condition  {
      __typename
      ...on ConditionHidden   {
        __typename
        contactEmail
      }
      ...on ConditionPublished   {
        __typename
        disclaimer
        report
        conditionReportDisclaimers  {
          __typename
          content
        }
      }
      ...on ConditionBehindLogin   {
        __typename
        lotId
      }
    }
    conditionReportDisclaimers  {
      __typename
      content
    }
    generalLotNotices  {
      __typename
      content
    }
    saleroomNotice
    catalogueNote
    provenance
    literature
    exhibition
    media  {
      ...MediaFragment
    }
    lotNumber  {
      __typename
      ...on VisibleLotNumber   {
        __typename
        lotNumber
      }
      ...on HiddenLotNumber   {
        __typename
        isHidden
      }
    }
    creatorsDisplayNames
    parcel  {
      __typename
      parcelName
    }
    auction  {
      __typename
      auctionId
      useCreatorSplit
    }
    session  {
      __typename
      sessionId
      stream  {
        __typename
        streamData  {
          __typename
          ...on MediaStreamVindral   {
            __typename
            streamId
            streamUrl
          }
        }
      }
    }
  }
  ${frag_0}
`)(Media$LiveRoom.MediaFragment.query);

function parse$15(value) {
  var value$1 = value.subtitle;
  var value$2 = value.creatorPrefix;
  var value$3 = value.lotTags;
  var value$4 = value.description;
  var value$5 = value.conditionReport;
  var value$6 = value.conditionDisclaimer;
  var value$7 = value.condition;
  var typename = value$7["__typename"];
  var tmp;
  switch (typename) {
    case "ConditionBehindLogin" :
        tmp = {
          NAME: "ConditionBehindLogin",
          VAL: {
            __typename: value$7.__typename,
            lotId: value$7.lotId
          }
        };
        break;
    case "ConditionHidden" :
        var value$8 = value$7.contactEmail;
        tmp = {
          NAME: "ConditionHidden",
          VAL: {
            __typename: value$7.__typename,
            contactEmail: !(value$8 == null) ? value$8 : undefined
          }
        };
        break;
    case "ConditionPublished" :
        var value$9 = value$7.disclaimer;
        var value$10 = value$7.report;
        var value$11 = value$7.conditionReportDisclaimers;
        tmp = {
          NAME: "ConditionPublished",
          VAL: {
            __typename: value$7.__typename,
            disclaimer: !(value$9 == null) ? value$9 : undefined,
            report: !(value$10 == null) ? value$10 : undefined,
            conditionReportDisclaimers: Js_array.map((function (value) {
                    var value$1 = value.content;
                    return {
                            __typename: value.__typename,
                            content: !(value$1 == null) ? value$1 : undefined
                          };
                  }), value$11)
          }
        };
        break;
    default:
      tmp = {
        NAME: "FutureAddedValue",
        VAL: value$7
      };
  }
  var value$12 = value.conditionReportDisclaimers;
  var value$13 = value.generalLotNotices;
  var value$14 = value.saleroomNotice;
  var value$15 = value.catalogueNote;
  var value$16 = value.provenance;
  var value$17 = value.literature;
  var value$18 = value.exhibition;
  var value$19 = value.media;
  var value$20 = value.lotNumber;
  var typename$1 = value$20["__typename"];
  var tmp$1;
  switch (typename$1) {
    case "HiddenLotNumber" :
        tmp$1 = {
          NAME: "HiddenLotNumber",
          VAL: {
            __typename: value$20.__typename,
            isHidden: value$20.isHidden
          }
        };
        break;
    case "VisibleLotNumber" :
        tmp$1 = {
          NAME: "VisibleLotNumber",
          VAL: {
            __typename: value$20.__typename,
            lotNumber: value$20.lotNumber
          }
        };
        break;
    default:
      tmp$1 = {
        NAME: "FutureAddedValue",
        VAL: value$20
      };
  }
  var value$21 = value.creatorsDisplayNames;
  var value$22 = value.parcel;
  var value$23 = value.auction;
  var value$24 = value.session;
  var tmp$2;
  if (value$24 == null) {
    tmp$2 = undefined;
  } else {
    var value$25 = value$24.stream;
    var tmp$3;
    if (value$25 == null) {
      tmp$3 = undefined;
    } else {
      var value$26 = value$25.streamData;
      var typename$2 = value$26["__typename"];
      var tmp$4 = typename$2 === "MediaStreamVindral" ? ({
            NAME: "MediaStreamVindral",
            VAL: {
              __typename: value$26.__typename,
              streamId: value$26.streamId,
              streamUrl: value$26.streamUrl
            }
          }) : ({
            NAME: "FutureAddedValue",
            VAL: value$26
          });
      tmp$3 = {
        __typename: value$25.__typename,
        streamData: tmp$4
      };
    }
    tmp$2 = {
      __typename: value$24.__typename,
      sessionId: value$24.sessionId,
      stream: tmp$3
    };
  }
  return {
          __typename: value.__typename,
          lotId: value.lotId,
          title: value.title,
          subtitle: !(value$1 == null) ? value$1 : undefined,
          creatorPrefix: !(value$2 == null) ? value$2 : undefined,
          lotTags: !(value$3 == null) ? Js_array.map((function (value) {
                    return value;
                  }), value$3) : undefined,
          description: !(value$4 == null) ? value$4 : undefined,
          conditionReport: !(value$5 == null) ? value$5 : undefined,
          conditionDisclaimer: !(value$6 == null) ? value$6 : undefined,
          condition: tmp,
          conditionReportDisclaimers: Js_array.map((function (value) {
                  var value$1 = value.content;
                  return {
                          __typename: value.__typename,
                          content: !(value$1 == null) ? value$1 : undefined
                        };
                }), value$12),
          generalLotNotices: Js_array.map((function (value) {
                  var value$1 = value.content;
                  return {
                          __typename: value.__typename,
                          content: !(value$1 == null) ? value$1 : undefined
                        };
                }), value$13),
          saleroomNotice: !(value$14 == null) ? value$14 : undefined,
          catalogueNote: !(value$15 == null) ? value$15 : undefined,
          provenance: !(value$16 == null) ? value$16 : undefined,
          literature: !(value$17 == null) ? value$17 : undefined,
          exhibition: !(value$18 == null) ? value$18 : undefined,
          media: !(value$19 == null) ? Media$LiveRoom.MediaFragment.verifyArgsAndParse("MediaFragment", value$19) : undefined,
          lotNumber: tmp$1,
          creatorsDisplayNames: !(value$21 == null) ? Js_array.map((function (value) {
                    return value;
                  }), value$21) : undefined,
          parcel: !(value$22 == null) ? ({
                __typename: value$22.__typename,
                parcelName: value$22.parcelName
              }) : undefined,
          auction: {
            __typename: value$23.__typename,
            auctionId: value$23.auctionId,
            useCreatorSplit: value$23.useCreatorSplit
          },
          session: tmp$2
        };
}

function serialize$15(value) {
  var value$1 = value.session;
  var session;
  if (value$1 !== undefined) {
    var value$2 = value$1.stream;
    var stream;
    if (value$2 !== undefined) {
      var value$3 = value$2.streamData;
      var streamData;
      if (value$3.NAME === "FutureAddedValue") {
        streamData = value$3.VAL;
      } else {
        var value$4 = value$3.VAL;
        var value$5 = value$4.streamUrl;
        var value$6 = value$4.streamId;
        streamData = {
          __typename: "MediaStreamVindral",
          streamId: value$6,
          streamUrl: value$5
        };
      }
      var value$7 = value$2.__typename;
      stream = {
        __typename: value$7,
        streamData: streamData
      };
    } else {
      stream = null;
    }
    var value$8 = value$1.sessionId;
    var value$9 = value$1.__typename;
    session = {
      __typename: value$9,
      sessionId: value$8,
      stream: stream
    };
  } else {
    session = null;
  }
  var value$10 = value.auction;
  var value$11 = value$10.useCreatorSplit;
  var value$12 = value$10.auctionId;
  var value$13 = value$10.__typename;
  var auction = {
    __typename: value$13,
    auctionId: value$12,
    useCreatorSplit: value$11
  };
  var value$14 = value.parcel;
  var parcel;
  if (value$14 !== undefined) {
    var value$15 = value$14.parcelName;
    var value$16 = value$14.__typename;
    parcel = {
      __typename: value$16,
      parcelName: value$15
    };
  } else {
    parcel = null;
  }
  var value$17 = value.creatorsDisplayNames;
  var creatorsDisplayNames = value$17 !== undefined ? Js_array.map((function (value) {
            return value;
          }), value$17) : null;
  var value$18 = value.lotNumber;
  var variant = value$18.NAME;
  var lotNumber;
  if (variant === "VisibleLotNumber") {
    var value$19 = value$18.VAL.lotNumber;
    lotNumber = {
      __typename: "VisibleLotNumber",
      lotNumber: value$19
    };
  } else if (variant === "HiddenLotNumber") {
    var value$20 = value$18.VAL.isHidden;
    lotNumber = {
      __typename: "HiddenLotNumber",
      isHidden: value$20
    };
  } else {
    lotNumber = value$18.VAL;
  }
  var value$21 = value.media;
  var media = value$21 !== undefined ? Media$LiveRoom.MediaFragment.serialize(value$21) : null;
  var value$22 = value.exhibition;
  var exhibition = value$22 !== undefined ? value$22 : null;
  var value$23 = value.literature;
  var literature = value$23 !== undefined ? value$23 : null;
  var value$24 = value.provenance;
  var provenance = value$24 !== undefined ? value$24 : null;
  var value$25 = value.catalogueNote;
  var catalogueNote = value$25 !== undefined ? value$25 : null;
  var value$26 = value.saleroomNotice;
  var saleroomNotice = value$26 !== undefined ? value$26 : null;
  var value$27 = value.generalLotNotices;
  var generalLotNotices = Js_array.map((function (value) {
          var value$1 = value.content;
          var content = value$1 !== undefined ? value$1 : null;
          var value$2 = value.__typename;
          return {
                  __typename: value$2,
                  content: content
                };
        }), value$27);
  var value$28 = value.conditionReportDisclaimers;
  var conditionReportDisclaimers = Js_array.map((function (value) {
          var value$1 = value.content;
          var content = value$1 !== undefined ? value$1 : null;
          var value$2 = value.__typename;
          return {
                  __typename: value$2,
                  content: content
                };
        }), value$28);
  var value$29 = value.condition;
  var variant$1 = value$29.NAME;
  var condition;
  if (variant$1 === "ConditionPublished") {
    var value$30 = value$29.VAL;
    var value$31 = value$30.conditionReportDisclaimers;
    var conditionReportDisclaimers$1 = Js_array.map((function (value) {
            var value$1 = value.content;
            var content = value$1 !== undefined ? value$1 : null;
            var value$2 = value.__typename;
            return {
                    __typename: value$2,
                    content: content
                  };
          }), value$31);
    var value$32 = value$30.report;
    var report = value$32 !== undefined ? value$32 : null;
    var value$33 = value$30.disclaimer;
    var disclaimer = value$33 !== undefined ? value$33 : null;
    condition = {
      __typename: "ConditionPublished",
      disclaimer: disclaimer,
      report: report,
      conditionReportDisclaimers: conditionReportDisclaimers$1
    };
  } else if (variant$1 === "ConditionBehindLogin") {
    var value$34 = value$29.VAL.lotId;
    condition = {
      __typename: "ConditionBehindLogin",
      lotId: value$34
    };
  } else if (variant$1 === "ConditionHidden") {
    var value$35 = value$29.VAL.contactEmail;
    var contactEmail = value$35 !== undefined ? value$35 : null;
    condition = {
      __typename: "ConditionHidden",
      contactEmail: contactEmail
    };
  } else {
    condition = value$29.VAL;
  }
  var value$36 = value.conditionDisclaimer;
  var conditionDisclaimer = value$36 !== undefined ? value$36 : null;
  var value$37 = value.conditionReport;
  var conditionReport = value$37 !== undefined ? value$37 : null;
  var value$38 = value.description;
  var description = value$38 !== undefined ? value$38 : null;
  var value$39 = value.lotTags;
  var lotTags = value$39 !== undefined ? Js_array.map((function (value) {
            return value;
          }), value$39) : null;
  var value$40 = value.creatorPrefix;
  var creatorPrefix = value$40 !== undefined ? value$40 : null;
  var value$41 = value.subtitle;
  var subtitle = value$41 !== undefined ? value$41 : null;
  var value$42 = value.title;
  var value$43 = value.lotId;
  var value$44 = value.__typename;
  return {
          __typename: value$44,
          lotId: value$43,
          title: value$42,
          subtitle: subtitle,
          creatorPrefix: creatorPrefix,
          lotTags: lotTags,
          description: description,
          conditionReport: conditionReport,
          conditionDisclaimer: conditionDisclaimer,
          condition: condition,
          conditionReportDisclaimers: conditionReportDisclaimers,
          generalLotNotices: generalLotNotices,
          saleroomNotice: saleroomNotice,
          catalogueNote: catalogueNote,
          provenance: provenance,
          literature: literature,
          exhibition: exhibition,
          media: media,
          lotNumber: lotNumber,
          creatorsDisplayNames: creatorsDisplayNames,
          parcel: parcel,
          auction: auction,
          session: session
        };
}

function verifyArgsAndParse$10(_LotDetailsLotFragment, value) {
  return parse$15(value);
}

function verifyName$10(param) {
  
}

var LotDetailsLotFragment = {
  Raw: Raw$15,
  query: query$15,
  parse: parse$15,
  serialize: serialize$15,
  verifyArgsAndParse: verifyArgsAndParse$10,
  verifyName: verifyName$10
};

var defaultAuction = {
  __typename: "Auction",
  auctionId: "auctionId",
  useCreatorSplit: false
};

var defaultLotNumber = {
  NAME: "HiddenLotNumber",
  VAL: {
    __typename: "HiddenLotNumber",
    isHidden: false
  }
};

var defaultCondition = {
  NAME: "ConditionHidden",
  VAL: {
    __typename: "ConditionHidden",
    contactEmail: undefined
  }
};

function makeLotFragment(param) {
  return {
          __typename: "LotV2",
          lotId: "",
          title: "",
          subtitle: undefined,
          creatorPrefix: undefined,
          lotTags: undefined,
          description: undefined,
          conditionReport: undefined,
          conditionDisclaimer: undefined,
          condition: defaultCondition,
          conditionReportDisclaimers: [],
          generalLotNotices: [],
          saleroomNotice: undefined,
          catalogueNote: undefined,
          provenance: undefined,
          literature: undefined,
          exhibition: undefined,
          media: undefined,
          lotNumber: defaultLotNumber,
          creatorsDisplayNames: undefined,
          parcel: undefined,
          auction: defaultAuction,
          session: undefined
        };
}

var LotDetails = {
  LotDetailsLotFragment: LotDetailsLotFragment,
  defaultAuction: defaultAuction,
  defaultLotNumber: defaultLotNumber,
  defaultCondition: defaultCondition,
  makeLotFragment: makeLotFragment
};

var Raw$16 = {};

var query$16 = ((frag_0, frag_1, frag_2, frag_3, frag_4) => require("@apollo/client").gql`
  fragment CurrentLotCardLotFragment on LotV2   {
    __typename
    lotId
    auction  {
      __typename
      useCreatorSplit
    }
    title
    subtitle
    creatorPrefix
    creatorsDisplayNames
    lotNumber  {
      __typename
      ...on VisibleLotNumber   {
        __typename
        lotNumber
      }
      ...on HiddenLotNumber   {
        __typename
        isHidden
      }
    }
    premiumLotState  {
      ...PremiumLotStateFragment
    }
    withdrawnState  {
      __typename
      state
    }
    lotTags
    parcel  {
      __typename
      parcelName
      canSellAdditionalCount
    }
    estimate: estimateV2  {
      __typename
      ...on LowHighEstimateV2   {
        __typename
        lowEstimate  {
          ...AmountFragment
        }
        highEstimate  {
          ...AmountFragment
        }
      }
      ...on EstimateUponRequest   {
        __typename
        estimateUponRequest
      }
    }
    bidState  {
      ...BidStateFragment
    }
    latestBid  {
      ...LatestUserBid
    }
    symbolsV2  {
      ...LotSymbolFragment
    }
  }
  ${frag_0}
  ${frag_1}
  ${frag_2}
  ${frag_3}
  ${frag_4}
`)(Amount$LiveRoom.AmountFragment.query, query$4, query$3, query, query$1);

function parse$16(value) {
  var value$1 = value.auction;
  var value$2 = value.subtitle;
  var value$3 = value.creatorPrefix;
  var value$4 = value.creatorsDisplayNames;
  var value$5 = value.lotNumber;
  var typename = value$5["__typename"];
  var tmp;
  switch (typename) {
    case "HiddenLotNumber" :
        tmp = {
          NAME: "HiddenLotNumber",
          VAL: {
            __typename: value$5.__typename,
            isHidden: value$5.isHidden
          }
        };
        break;
    case "VisibleLotNumber" :
        tmp = {
          NAME: "VisibleLotNumber",
          VAL: {
            __typename: value$5.__typename,
            lotNumber: value$5.lotNumber
          }
        };
        break;
    default:
      tmp = {
        NAME: "FutureAddedValue",
        VAL: value$5
      };
  }
  var value$6 = value.withdrawnState;
  var value$7 = value$6.state;
  var tmp$1;
  switch (value$7) {
    case "NotAffected" :
        tmp$1 = "NotAffected";
        break;
    case "UnWithdrawn" :
        tmp$1 = "UnWithdrawn";
        break;
    case "Withdrawn" :
        tmp$1 = "Withdrawn";
        break;
    default:
      tmp$1 = {
        NAME: "FutureAddedValue",
        VAL: value$7
      };
  }
  var value$8 = value.lotTags;
  var value$9 = value.parcel;
  var tmp$2;
  if (value$9 == null) {
    tmp$2 = undefined;
  } else {
    var value$10 = value$9.canSellAdditionalCount;
    tmp$2 = {
      __typename: value$9.__typename,
      parcelName: value$9.parcelName,
      canSellAdditionalCount: !(value$10 == null) ? value$10 : undefined
    };
  }
  var value$11 = value.estimate;
  var typename$1 = value$11["__typename"];
  var tmp$3;
  switch (typename$1) {
    case "EstimateUponRequest" :
        tmp$3 = {
          NAME: "EstimateUponRequest",
          VAL: {
            __typename: value$11.__typename,
            estimateUponRequest: value$11.estimateUponRequest
          }
        };
        break;
    case "LowHighEstimateV2" :
        var value$12 = value$11.lowEstimate;
        var value$13 = value$11.highEstimate;
        tmp$3 = {
          NAME: "LowHighEstimateV2",
          VAL: {
            __typename: value$11.__typename,
            lowEstimate: Amount$LiveRoom.AmountFragment.verifyArgsAndParse("AmountFragment", value$12),
            highEstimate: Amount$LiveRoom.AmountFragment.verifyArgsAndParse("AmountFragment", value$13)
          }
        };
        break;
    default:
      tmp$3 = {
        NAME: "FutureAddedValue",
        VAL: value$11
      };
  }
  var value$14 = value.bidState;
  var value$15 = value.symbolsV2;
  return {
          __typename: value.__typename,
          lotId: value.lotId,
          auction: {
            __typename: value$1.__typename,
            useCreatorSplit: value$1.useCreatorSplit
          },
          title: value.title,
          subtitle: !(value$2 == null) ? value$2 : undefined,
          creatorPrefix: !(value$3 == null) ? value$3 : undefined,
          creatorsDisplayNames: !(value$4 == null) ? Js_array.map((function (value) {
                    return value;
                  }), value$4) : undefined,
          lotNumber: tmp,
          premiumLotState: parse$1(value.premiumLotState),
          withdrawnState: {
            __typename: value$6.__typename,
            state: tmp$1
          },
          lotTags: !(value$8 == null) ? Js_array.map((function (value) {
                    return value;
                  }), value$8) : undefined,
          parcel: tmp$2,
          estimate: tmp$3,
          bidState: !(value$14 == null) ? parse$4(value$14) : undefined,
          latestBid: parse$3(value.latestBid),
          symbolsV2: Js_array.map(parse, value$15)
        };
}

function serialize$16(value) {
  var value$1 = value.symbolsV2;
  var symbolsV2 = Js_array.map(serialize, value$1);
  var value$2 = value.latestBid;
  var latestBid = serialize$3(value$2);
  var value$3 = value.bidState;
  var bidState = value$3 !== undefined ? serialize$4(value$3) : null;
  var value$4 = value.estimate;
  var variant = value$4.NAME;
  var estimate;
  if (variant === "LowHighEstimateV2") {
    var value$5 = value$4.VAL;
    var value$6 = value$5.highEstimate;
    var highEstimate = Amount$LiveRoom.AmountFragment.serialize(value$6);
    var value$7 = value$5.lowEstimate;
    var lowEstimate = Amount$LiveRoom.AmountFragment.serialize(value$7);
    estimate = {
      __typename: "LowHighEstimateV2",
      lowEstimate: lowEstimate,
      highEstimate: highEstimate
    };
  } else if (variant === "FutureAddedValue") {
    estimate = value$4.VAL;
  } else {
    var value$8 = value$4.VAL.estimateUponRequest;
    estimate = {
      __typename: "EstimateUponRequest",
      estimateUponRequest: value$8
    };
  }
  var value$9 = value.parcel;
  var parcel;
  if (value$9 !== undefined) {
    var value$10 = value$9.canSellAdditionalCount;
    var canSellAdditionalCount = value$10 !== undefined ? value$10 : null;
    var value$11 = value$9.parcelName;
    var value$12 = value$9.__typename;
    parcel = {
      __typename: value$12,
      parcelName: value$11,
      canSellAdditionalCount: canSellAdditionalCount
    };
  } else {
    parcel = null;
  }
  var value$13 = value.lotTags;
  var lotTags = value$13 !== undefined ? Js_array.map((function (value) {
            return value;
          }), value$13) : null;
  var value$14 = value.withdrawnState;
  var value$15 = value$14.state;
  var state = typeof value$15 === "object" ? value$15.VAL : (
      value$15 === "Withdrawn" ? "Withdrawn" : (
          value$15 === "NotAffected" ? "NotAffected" : "UnWithdrawn"
        )
    );
  var value$16 = value$14.__typename;
  var withdrawnState = {
    __typename: value$16,
    state: state
  };
  var value$17 = value.premiumLotState;
  var premiumLotState = serialize$1(value$17);
  var value$18 = value.lotNumber;
  var variant$1 = value$18.NAME;
  var lotNumber;
  if (variant$1 === "VisibleLotNumber") {
    var value$19 = value$18.VAL.lotNumber;
    lotNumber = {
      __typename: "VisibleLotNumber",
      lotNumber: value$19
    };
  } else if (variant$1 === "HiddenLotNumber") {
    var value$20 = value$18.VAL.isHidden;
    lotNumber = {
      __typename: "HiddenLotNumber",
      isHidden: value$20
    };
  } else {
    lotNumber = value$18.VAL;
  }
  var value$21 = value.creatorsDisplayNames;
  var creatorsDisplayNames = value$21 !== undefined ? Js_array.map((function (value) {
            return value;
          }), value$21) : null;
  var value$22 = value.creatorPrefix;
  var creatorPrefix = value$22 !== undefined ? value$22 : null;
  var value$23 = value.subtitle;
  var subtitle = value$23 !== undefined ? value$23 : null;
  var value$24 = value.title;
  var value$25 = value.auction;
  var value$26 = value$25.useCreatorSplit;
  var value$27 = value$25.__typename;
  var auction = {
    __typename: value$27,
    useCreatorSplit: value$26
  };
  var value$28 = value.lotId;
  var value$29 = value.__typename;
  return {
          __typename: value$29,
          lotId: value$28,
          auction: auction,
          title: value$24,
          subtitle: subtitle,
          creatorPrefix: creatorPrefix,
          creatorsDisplayNames: creatorsDisplayNames,
          lotNumber: lotNumber,
          premiumLotState: premiumLotState,
          withdrawnState: withdrawnState,
          lotTags: lotTags,
          parcel: parcel,
          estimate: estimate,
          bidState: bidState,
          latestBid: latestBid,
          symbolsV2: symbolsV2
        };
}

function verifyArgsAndParse$11(_CurrentLotCardLotFragment, value) {
  return parse$16(value);
}

function verifyName$11(param) {
  
}

var CurrentLotCardLotFragment = {
  Raw: Raw$16,
  query: query$16,
  parse: parse$16,
  serialize: serialize$16,
  verifyArgsAndParse: verifyArgsAndParse$11,
  verifyName: verifyName$11
};

function makeAuction(useCreatorSplitOpt, param) {
  var useCreatorSplit = useCreatorSplitOpt !== undefined ? useCreatorSplitOpt : false;
  return {
          __typename: "Auction",
          useCreatorSplit: useCreatorSplit
        };
}

var useCreatorSplit = false;

var defaultAuction$1 = {
  __typename: "Auction",
  useCreatorSplit: useCreatorSplit
};

var defaultLotNumber$1 = {
  NAME: "HiddenLotNumber",
  VAL: {
    __typename: "HiddenLotNumber",
    isHidden: false
  }
};

var defaultPremiumLotState = {
  __typename: "PremiumLotState",
  id: "",
  isPremium: false,
  userIsWhitelisted: false
};

var defaultWithdrawnState = {
  __typename: "WithdrawnState",
  state: "NotAffected"
};

var estimateUponRequest = {
  NAME: "EstimateUponRequest",
  VAL: {
    __typename: "EstimateUponRequest",
    estimateUponRequest: true
  }
};

function makeLowHighEstimate(lowEstimate, highEstimate) {
  return {
          NAME: "LowHighEstimateV2",
          VAL: {
            __typename: "Estimate",
            lowEstimate: lowEstimate,
            highEstimate: highEstimate
          }
        };
}

function makeBidType(liveBidPhase, bidMethod, param) {
  return {
          NAME: "LiveBidType",
          VAL: {
            __typename: "LiveBidType",
            liveBidPhase: liveBidPhase,
            bidMethod: bidMethod
          }
        };
}

function makeBidStateFragment(isClosedOpt, currentBid, startingBid, bidType, param) {
  var isClosed = isClosedOpt !== undefined ? isClosedOpt : false;
  return {
          __typename: "BidState",
          id: "",
          isClosed: isClosed,
          bidType: bidType,
          currentBid: currentBid,
          startingBid: startingBid,
          sold: {
            NAME: "ResultVisible",
            VAL: {
              __typename: "ResultVisible",
              isSold: false,
              premiums: undefined
            }
          }
        };
}

function makeLotFragment$1(lotIdOpt, auctionOpt, titleOpt, creatorPrefix, creatorsDisplayNames, lotTags, parcel, estimateOpt, bidState, symbolsV2Opt, param) {
  var lotId = lotIdOpt !== undefined ? lotIdOpt : "";
  var auction = auctionOpt !== undefined ? auctionOpt : defaultAuction$1;
  var title = titleOpt !== undefined ? titleOpt : "";
  var estimate = estimateOpt !== undefined ? estimateOpt : estimateUponRequest;
  var symbolsV2 = symbolsV2Opt !== undefined ? symbolsV2Opt : [];
  return {
          __typename: "LotV2",
          lotId: lotId,
          auction: auction,
          title: title,
          subtitle: undefined,
          creatorPrefix: creatorPrefix,
          creatorsDisplayNames: creatorsDisplayNames,
          lotNumber: defaultLotNumber$1,
          premiumLotState: defaultPremiumLotState,
          withdrawnState: defaultWithdrawnState,
          lotTags: lotTags,
          parcel: parcel,
          estimate: estimate,
          bidState: bidState,
          latestBid: {
            __typename: "UserBidConnection",
            id: "",
            bid: undefined
          },
          symbolsV2: symbolsV2
        };
}

var CurrentLotCard = {
  BidStateFragment: undefined,
  LatestUserBid: undefined,
  PremiumLotStateFragment: undefined,
  LotSymbolFragment: undefined,
  CurrentLotCardLotFragment: CurrentLotCardLotFragment,
  makeAuction: makeAuction,
  defaultAuction: defaultAuction$1,
  defaultLotNumber: defaultLotNumber$1,
  defaultPremiumLotState: defaultPremiumLotState,
  defaultWithdrawnState: defaultWithdrawnState,
  estimateUponRequest: estimateUponRequest,
  makeLowHighEstimate: makeLowHighEstimate,
  makeBidType: makeBidType,
  makeBidStateFragment: makeBidStateFragment,
  makeLotFragment: makeLotFragment$1
};

var Raw$17 = {};

var query$17 = (require("@apollo/client").gql`
  query CurrencyRatesQuery($baseCurrency: Currency!, $targetCurrencies: [Currency!]!)  {
    currencies(baseCurrency: $baseCurrency, targetCurrencies: $targetCurrencies)  {
      __typename
      targetCurrencies  {
        __typename
        currency
        rate
      }
    }
  }
`);

function parse$17(value) {
  var value$1 = value.currencies;
  var value$2 = value$1.targetCurrencies;
  return {
          currencies: {
            __typename: value$1.__typename,
            targetCurrencies: Js_array.map((function (value) {
                    var value$1 = value.currency;
                    var tmp;
                    switch (value$1) {
                      case "AED" :
                          tmp = "AED";
                          break;
                      case "ARS" :
                          tmp = "ARS";
                          break;
                      case "AUD" :
                          tmp = "AUD";
                          break;
                      case "BRL" :
                          tmp = "BRL";
                          break;
                      case "BTC" :
                          tmp = "BTC";
                          break;
                      case "CAD" :
                          tmp = "CAD";
                          break;
                      case "CHF" :
                          tmp = "CHF";
                          break;
                      case "CNY" :
                          tmp = "CNY";
                          break;
                      case "ETH" :
                          tmp = "ETH";
                          break;
                      case "EUR" :
                          tmp = "EUR";
                          break;
                      case "GBP" :
                          tmp = "GBP";
                          break;
                      case "HKD" :
                          tmp = "HKD";
                          break;
                      case "IDR" :
                          tmp = "IDR";
                          break;
                      case "INR" :
                          tmp = "INR";
                          break;
                      case "JPY" :
                          tmp = "JPY";
                          break;
                      case "KRW" :
                          tmp = "KRW";
                          break;
                      case "MXN" :
                          tmp = "MXN";
                          break;
                      case "PHP" :
                          tmp = "PHP";
                          break;
                      case "QAR" :
                          tmp = "QAR";
                          break;
                      case "RUB" :
                          tmp = "RUB";
                          break;
                      case "SAR" :
                          tmp = "SAR";
                          break;
                      case "SGD" :
                          tmp = "SGD";
                          break;
                      case "TWD" :
                          tmp = "TWD";
                          break;
                      case "USD" :
                          tmp = "USD";
                          break;
                      default:
                        tmp = {
                          NAME: "FutureAddedValue",
                          VAL: value$1
                        };
                    }
                    return {
                            __typename: value.__typename,
                            currency: tmp,
                            rate: value.rate
                          };
                  }), value$2)
          }
        };
}

function serialize$17(value) {
  var value$1 = value.currencies;
  var value$2 = value$1.targetCurrencies;
  var targetCurrencies = Js_array.map((function (value) {
          var value$1 = value.rate;
          var value$2 = value.currency;
          var currency = typeof value$2 === "object" ? value$2.VAL : (
              value$2 === "ARS" ? "ARS" : (
                  value$2 === "AUD" ? "AUD" : (
                      value$2 === "BRL" ? "BRL" : (
                          value$2 === "BTC" ? "BTC" : (
                              value$2 === "CAD" ? "CAD" : (
                                  value$2 === "CHF" ? "CHF" : (
                                      value$2 === "CNY" ? "CNY" : (
                                          value$2 === "ETH" ? "ETH" : (
                                              value$2 === "EUR" ? "EUR" : (
                                                  value$2 === "GBP" ? "GBP" : (
                                                      value$2 === "HKD" ? "HKD" : (
                                                          value$2 === "IDR" ? "IDR" : (
                                                              value$2 === "INR" ? "INR" : (
                                                                  value$2 === "JPY" ? "JPY" : (
                                                                      value$2 === "KRW" ? "KRW" : (
                                                                          value$2 === "MXN" ? "MXN" : (
                                                                              value$2 === "PHP" ? "PHP" : (
                                                                                  value$2 === "QAR" ? "QAR" : (
                                                                                      value$2 === "RUB" ? "RUB" : (
                                                                                          value$2 === "SAR" ? "SAR" : (
                                                                                              value$2 === "SGD" ? "SGD" : (
                                                                                                  value$2 === "TWD" ? "TWD" : (
                                                                                                      value$2 === "USD" ? "USD" : "AED"
                                                                                                    )
                                                                                                )
                                                                                            )
                                                                                        )
                                                                                    )
                                                                                )
                                                                            )
                                                                        )
                                                                    )
                                                                )
                                                            )
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
          var value$3 = value.__typename;
          return {
                  __typename: value$3,
                  currency: currency,
                  rate: value$1
                };
        }), value$2);
  var value$3 = value$1.__typename;
  var currencies = {
    __typename: value$3,
    targetCurrencies: targetCurrencies
  };
  return {
          currencies: currencies
        };
}

function serializeVariables$5(inp) {
  var a = inp.baseCurrency;
  var a$1 = inp.targetCurrencies;
  return {
          baseCurrency: a === "ARS" ? "ARS" : (
              a === "AUD" ? "AUD" : (
                  a === "BRL" ? "BRL" : (
                      a === "BTC" ? "BTC" : (
                          a === "CAD" ? "CAD" : (
                              a === "CHF" ? "CHF" : (
                                  a === "CNY" ? "CNY" : (
                                      a === "ETH" ? "ETH" : (
                                          a === "EUR" ? "EUR" : (
                                              a === "GBP" ? "GBP" : (
                                                  a === "HKD" ? "HKD" : (
                                                      a === "IDR" ? "IDR" : (
                                                          a === "INR" ? "INR" : (
                                                              a === "JPY" ? "JPY" : (
                                                                  a === "KRW" ? "KRW" : (
                                                                      a === "MXN" ? "MXN" : (
                                                                          a === "PHP" ? "PHP" : (
                                                                              a === "QAR" ? "QAR" : (
                                                                                  a === "RUB" ? "RUB" : (
                                                                                      a === "SAR" ? "SAR" : (
                                                                                          a === "SGD" ? "SGD" : (
                                                                                              a === "TWD" ? "TWD" : (
                                                                                                  a === "USD" ? "USD" : "AED"
                                                                                                )
                                                                                            )
                                                                                        )
                                                                                    )
                                                                                )
                                                                            )
                                                                        )
                                                                    )
                                                                )
                                                            )
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            ),
          targetCurrencies: Js_array.map((function (b) {
                  if (b === "ARS") {
                    return "ARS";
                  } else if (b === "AUD") {
                    return "AUD";
                  } else if (b === "BRL") {
                    return "BRL";
                  } else if (b === "BTC") {
                    return "BTC";
                  } else if (b === "CAD") {
                    return "CAD";
                  } else if (b === "CHF") {
                    return "CHF";
                  } else if (b === "CNY") {
                    return "CNY";
                  } else if (b === "ETH") {
                    return "ETH";
                  } else if (b === "EUR") {
                    return "EUR";
                  } else if (b === "GBP") {
                    return "GBP";
                  } else if (b === "HKD") {
                    return "HKD";
                  } else if (b === "IDR") {
                    return "IDR";
                  } else if (b === "INR") {
                    return "INR";
                  } else if (b === "JPY") {
                    return "JPY";
                  } else if (b === "KRW") {
                    return "KRW";
                  } else if (b === "MXN") {
                    return "MXN";
                  } else if (b === "PHP") {
                    return "PHP";
                  } else if (b === "QAR") {
                    return "QAR";
                  } else if (b === "RUB") {
                    return "RUB";
                  } else if (b === "SAR") {
                    return "SAR";
                  } else if (b === "SGD") {
                    return "SGD";
                  } else if (b === "TWD") {
                    return "TWD";
                  } else if (b === "USD") {
                    return "USD";
                  } else {
                    return "AED";
                  }
                }), a$1)
        };
}

function makeVariables$5(baseCurrency, targetCurrencies, param) {
  return {
          baseCurrency: baseCurrency,
          targetCurrencies: targetCurrencies
        };
}

var CurrencyRatesQuery_inner = {
  Raw: Raw$17,
  query: query$17,
  parse: parse$17,
  serialize: serialize$17,
  serializeVariables: serializeVariables$5,
  makeVariables: makeVariables$5
};

var include$5 = ApolloClient__React_Hooks_UseQuery.Extend({
      query: query$17,
      Raw: Raw$17,
      parse: parse$17,
      serialize: serialize$17,
      serializeVariables: serializeVariables$5
    });

var CurrencyRatesQuery_refetchQueryDescription = include$5.refetchQueryDescription;

var CurrencyRatesQuery_use = include$5.use;

var CurrencyRatesQuery_useLazy = include$5.useLazy;

var CurrencyRatesQuery_useLazyWithVariables = include$5.useLazyWithVariables;

var CurrencyRatesQuery = {
  CurrencyRatesQuery_inner: CurrencyRatesQuery_inner,
  Raw: Raw$17,
  query: query$17,
  parse: parse$17,
  serialize: serialize$17,
  serializeVariables: serializeVariables$5,
  makeVariables: makeVariables$5,
  refetchQueryDescription: CurrencyRatesQuery_refetchQueryDescription,
  use: CurrencyRatesQuery_use,
  useLazy: CurrencyRatesQuery_useLazy,
  useLazyWithVariables: CurrencyRatesQuery_useLazyWithVariables
};

var AlternativeCurrency = {
  CurrencyRatesQuery: CurrencyRatesQuery
};

var Raw$18 = {};

var query$18 = (require("@apollo/client").gql`
  fragment LotFeedEventFragment on LotFeedItem   {
    __typename
    id
    type  {
      __typename
      ...on UnknownFeedType   {
        __typename
        id
      }
      ...on LotOpened   {
        __typename
        id
      }
      ...on LotClosed   {
        __typename
        id
      }
      ...on LotPassed   {
        __typename
        id
      }
      ...on LotSoldFeedEvent   {
        __typename
        id
        isWinner
      }
      ...on StartingBidUpdated   {
        __typename
        id
        newStartingBid
      }
      ...on UserBidFeed   {
        __typename
        id
        bidAmount
        isMyBid
        isAdvance
      }
      ...on AdminBid   {
        __typename
        id
        bidAmount
        onBehalfOfUserId
        bidType
      }
      ...on ConsignorBid   {
        __typename
        id
        bidAmount
        isAdvance
        previousBidWasMine
        previousBidIsSameAmount
      }
      ...on UndoBid   {
        __typename
        id
        newCurrentBid
      }
      ...on BidAskAdjusted   {
        __typename
        id
        newBidAsk
      }
      ...on CurrentBidAdjusted   {
        __typename
        id
        newCurrentBid
      }
      ...on FairWarning   {
        __typename
        id
      }
      ...on Comment   {
        __typename
        id
        comment
      }
      ...on SaleroomNotice   {
        __typename
        id
        notice
      }
      ...on LotWithdrawn   {
        __typename
        id
      }
      ...on LotUnWithdrawn   {
        __typename
        id
      }
      ...on ConfirmSaleResult   {
        __typename
        id
      }
      ...on LotReopened   {
        __typename
        id
      }
      ...on LotContinued   {
        __typename
        id
      }
      ...on ReactiveBid   {
        __typename
        id
        bidAmount
        isAdvance
        previousBidIsSameAmount
        previousBidWasMine
        currentBidIsMine
      }
      ...on AbsenteeBidAmountReached   {
        __typename
        id
        bidAmount
        bidAheadOfYou
      }
    }
  }
`);

function parse$18(value) {
  var value$1 = value.type;
  var typename = value$1["__typename"];
  var tmp;
  switch (typename) {
    case "AbsenteeBidAmountReached" :
        tmp = {
          NAME: "AbsenteeBidAmountReached",
          VAL: {
            __typename: value$1.__typename,
            id: value$1.id,
            bidAmount: value$1.bidAmount,
            bidAheadOfYou: value$1.bidAheadOfYou
          }
        };
        break;
    case "AdminBid" :
        var value$2 = value$1.onBehalfOfUserId;
        var value$3 = value$1.bidType;
        var tmp$1;
        if (value$3 == null) {
          tmp$1 = undefined;
        } else {
          var tmp$2;
          switch (value$3) {
            case "ABSENTEE" :
                tmp$2 = "ABSENTEE";
                break;
            case "ADJUSTED" :
                tmp$2 = "ADJUSTED";
                break;
            case "ADVANCE" :
                tmp$2 = "ADVANCE";
                break;
            case "CONSIGNOR" :
                tmp$2 = "CONSIGNOR";
                break;
            case "FLOOR" :
                tmp$2 = "FLOOR";
                break;
            case "ONLINE" :
                tmp$2 = "ONLINE";
                break;
            case "PHONE" :
                tmp$2 = "PHONE";
                break;
            case "REACTIVE" :
                tmp$2 = "REACTIVE";
                break;
            default:
              tmp$2 = {
                NAME: "FutureAddedValue",
                VAL: value$3
              };
          }
          tmp$1 = tmp$2;
        }
        tmp = {
          NAME: "AdminBid",
          VAL: {
            __typename: value$1.__typename,
            id: value$1.id,
            bidAmount: value$1.bidAmount,
            onBehalfOfUserId: !(value$2 == null) ? value$2 : undefined,
            bidType: tmp$1
          }
        };
        break;
    case "BidAskAdjusted" :
        tmp = {
          NAME: "BidAskAdjusted",
          VAL: {
            __typename: value$1.__typename,
            id: value$1.id,
            newBidAsk: value$1.newBidAsk
          }
        };
        break;
    case "Comment" :
        tmp = {
          NAME: "Comment",
          VAL: {
            __typename: value$1.__typename,
            id: value$1.id,
            comment: value$1.comment
          }
        };
        break;
    case "ConfirmSaleResult" :
        tmp = {
          NAME: "ConfirmSaleResult",
          VAL: {
            __typename: value$1.__typename,
            id: value$1.id
          }
        };
        break;
    case "ConsignorBid" :
        tmp = {
          NAME: "ConsignorBid",
          VAL: {
            __typename: value$1.__typename,
            id: value$1.id,
            bidAmount: value$1.bidAmount,
            isAdvance: value$1.isAdvance,
            previousBidWasMine: value$1.previousBidWasMine,
            previousBidIsSameAmount: value$1.previousBidIsSameAmount
          }
        };
        break;
    case "CurrentBidAdjusted" :
        var value$4 = value$1.newCurrentBid;
        tmp = {
          NAME: "CurrentBidAdjusted",
          VAL: {
            __typename: value$1.__typename,
            id: value$1.id,
            newCurrentBid: !(value$4 == null) ? value$4 : undefined
          }
        };
        break;
    case "FairWarning" :
        tmp = {
          NAME: "FairWarning",
          VAL: {
            __typename: value$1.__typename,
            id: value$1.id
          }
        };
        break;
    case "LotClosed" :
        tmp = {
          NAME: "LotClosed",
          VAL: {
            __typename: value$1.__typename,
            id: value$1.id
          }
        };
        break;
    case "LotContinued" :
        tmp = {
          NAME: "LotContinued",
          VAL: {
            __typename: value$1.__typename,
            id: value$1.id
          }
        };
        break;
    case "LotOpened" :
        tmp = {
          NAME: "LotOpened",
          VAL: {
            __typename: value$1.__typename,
            id: value$1.id
          }
        };
        break;
    case "LotPassed" :
        tmp = {
          NAME: "LotPassed",
          VAL: {
            __typename: value$1.__typename,
            id: value$1.id
          }
        };
        break;
    case "LotReopened" :
        tmp = {
          NAME: "LotReopened",
          VAL: {
            __typename: value$1.__typename,
            id: value$1.id
          }
        };
        break;
    case "LotSoldFeedEvent" :
        tmp = {
          NAME: "LotSoldFeedEvent",
          VAL: {
            __typename: value$1.__typename,
            id: value$1.id,
            isWinner: value$1.isWinner
          }
        };
        break;
    case "LotUnWithdrawn" :
        tmp = {
          NAME: "LotUnWithdrawn",
          VAL: {
            __typename: value$1.__typename,
            id: value$1.id
          }
        };
        break;
    case "LotWithdrawn" :
        tmp = {
          NAME: "LotWithdrawn",
          VAL: {
            __typename: value$1.__typename,
            id: value$1.id
          }
        };
        break;
    case "ReactiveBid" :
        tmp = {
          NAME: "ReactiveBid",
          VAL: {
            __typename: value$1.__typename,
            id: value$1.id,
            bidAmount: value$1.bidAmount,
            isAdvance: value$1.isAdvance,
            previousBidIsSameAmount: value$1.previousBidIsSameAmount,
            previousBidWasMine: value$1.previousBidWasMine,
            currentBidIsMine: value$1.currentBidIsMine
          }
        };
        break;
    case "SaleroomNotice" :
        tmp = {
          NAME: "SaleroomNotice",
          VAL: {
            __typename: value$1.__typename,
            id: value$1.id,
            notice: value$1.notice
          }
        };
        break;
    case "StartingBidUpdated" :
        tmp = {
          NAME: "StartingBidUpdated",
          VAL: {
            __typename: value$1.__typename,
            id: value$1.id,
            newStartingBid: value$1.newStartingBid
          }
        };
        break;
    case "UndoBid" :
        var value$5 = value$1.newCurrentBid;
        tmp = {
          NAME: "UndoBid",
          VAL: {
            __typename: value$1.__typename,
            id: value$1.id,
            newCurrentBid: !(value$5 == null) ? value$5 : undefined
          }
        };
        break;
    case "UnknownFeedType" :
        tmp = {
          NAME: "UnknownFeedType",
          VAL: {
            __typename: value$1.__typename,
            id: value$1.id
          }
        };
        break;
    case "UserBidFeed" :
        tmp = {
          NAME: "UserBidFeed",
          VAL: {
            __typename: value$1.__typename,
            id: value$1.id,
            bidAmount: value$1.bidAmount,
            isMyBid: value$1.isMyBid,
            isAdvance: value$1.isAdvance
          }
        };
        break;
    default:
      tmp = {
        NAME: "FutureAddedValue",
        VAL: value$1
      };
  }
  return {
          __typename: value.__typename,
          id: value.id,
          type: tmp
        };
}

function serialize$18(value) {
  var value$1 = value.type;
  var variant = value$1.NAME;
  var type_;
  if (variant === "UserBidFeed") {
    var value$2 = value$1.VAL;
    var value$3 = value$2.isAdvance;
    var value$4 = value$2.isMyBid;
    var value$5 = value$2.bidAmount;
    var value$6 = value$2.id;
    type_ = {
      __typename: "UserBidFeed",
      id: value$6,
      bidAmount: value$5,
      isMyBid: value$4,
      isAdvance: value$3
    };
  } else if (variant === "ConsignorBid") {
    var value$7 = value$1.VAL;
    var value$8 = value$7.previousBidIsSameAmount;
    var value$9 = value$7.previousBidWasMine;
    var value$10 = value$7.isAdvance;
    var value$11 = value$7.bidAmount;
    var value$12 = value$7.id;
    type_ = {
      __typename: "ConsignorBid",
      id: value$12,
      bidAmount: value$11,
      isAdvance: value$10,
      previousBidWasMine: value$9,
      previousBidIsSameAmount: value$8
    };
  } else if (variant === "StartingBidUpdated") {
    var value$13 = value$1.VAL;
    var value$14 = value$13.newStartingBid;
    var value$15 = value$13.id;
    type_ = {
      __typename: "StartingBidUpdated",
      id: value$15,
      newStartingBid: value$14
    };
  } else if (variant === "LotPassed") {
    var value$16 = value$1.VAL.id;
    type_ = {
      __typename: "LotPassed",
      id: value$16
    };
  } else if (variant === "FairWarning") {
    var value$17 = value$1.VAL.id;
    type_ = {
      __typename: "FairWarning",
      id: value$17
    };
  } else if (variant === "LotWithdrawn") {
    var value$18 = value$1.VAL.id;
    type_ = {
      __typename: "LotWithdrawn",
      id: value$18
    };
  } else if (variant === "FutureAddedValue") {
    type_ = value$1.VAL;
  } else if (variant === "ConfirmSaleResult") {
    var value$19 = value$1.VAL.id;
    type_ = {
      __typename: "ConfirmSaleResult",
      id: value$19
    };
  } else if (variant === "LotContinued") {
    var value$20 = value$1.VAL.id;
    type_ = {
      __typename: "LotContinued",
      id: value$20
    };
  } else if (variant === "LotClosed") {
    var value$21 = value$1.VAL.id;
    type_ = {
      __typename: "LotClosed",
      id: value$21
    };
  } else if (variant === "BidAskAdjusted") {
    var value$22 = value$1.VAL;
    var value$23 = value$22.newBidAsk;
    var value$24 = value$22.id;
    type_ = {
      __typename: "BidAskAdjusted",
      id: value$24,
      newBidAsk: value$23
    };
  } else if (variant === "LotReopened") {
    var value$25 = value$1.VAL.id;
    type_ = {
      __typename: "LotReopened",
      id: value$25
    };
  } else if (variant === "CurrentBidAdjusted") {
    var value$26 = value$1.VAL;
    var value$27 = value$26.newCurrentBid;
    var newCurrentBid = value$27 !== undefined ? value$27 : null;
    var value$28 = value$26.id;
    type_ = {
      __typename: "CurrentBidAdjusted",
      id: value$28,
      newCurrentBid: newCurrentBid
    };
  } else if (variant === "AdminBid") {
    var value$29 = value$1.VAL;
    var value$30 = value$29.bidType;
    var bidType = value$30 !== undefined ? (
        typeof value$30 === "object" ? value$30.VAL : (
            value$30 === "REACTIVE" ? "REACTIVE" : (
                value$30 === "ABSENTEE" ? "ABSENTEE" : (
                    value$30 === "CONSIGNOR" ? "CONSIGNOR" : (
                        value$30 === "ADVANCE" ? "ADVANCE" : (
                            value$30 === "FLOOR" ? "FLOOR" : (
                                value$30 === "ONLINE" ? "ONLINE" : (
                                    value$30 === "PHONE" ? "PHONE" : "ADJUSTED"
                                  )
                              )
                          )
                      )
                  )
              )
          )
      ) : null;
    var value$31 = value$29.onBehalfOfUserId;
    var onBehalfOfUserId = value$31 !== undefined ? value$31 : null;
    var value$32 = value$29.bidAmount;
    var value$33 = value$29.id;
    type_ = {
      __typename: "AdminBid",
      id: value$33,
      bidAmount: value$32,
      onBehalfOfUserId: onBehalfOfUserId,
      bidType: bidType
    };
  } else if (variant === "LotOpened") {
    var value$34 = value$1.VAL.id;
    type_ = {
      __typename: "LotOpened",
      id: value$34
    };
  } else if (variant === "SaleroomNotice") {
    var value$35 = value$1.VAL;
    var value$36 = value$35.notice;
    var value$37 = value$35.id;
    type_ = {
      __typename: "SaleroomNotice",
      id: value$37,
      notice: value$36
    };
  } else if (variant === "AbsenteeBidAmountReached") {
    var value$38 = value$1.VAL;
    var value$39 = value$38.bidAheadOfYou;
    var value$40 = value$38.bidAmount;
    var value$41 = value$38.id;
    type_ = {
      __typename: "AbsenteeBidAmountReached",
      id: value$41,
      bidAmount: value$40,
      bidAheadOfYou: value$39
    };
  } else if (variant === "UnknownFeedType") {
    var value$42 = value$1.VAL.id;
    type_ = {
      __typename: "UnknownFeedType",
      id: value$42
    };
  } else if (variant === "UndoBid") {
    var value$43 = value$1.VAL;
    var value$44 = value$43.newCurrentBid;
    var newCurrentBid$1 = value$44 !== undefined ? value$44 : null;
    var value$45 = value$43.id;
    type_ = {
      __typename: "UndoBid",
      id: value$45,
      newCurrentBid: newCurrentBid$1
    };
  } else if (variant === "LotUnWithdrawn") {
    var value$46 = value$1.VAL.id;
    type_ = {
      __typename: "LotUnWithdrawn",
      id: value$46
    };
  } else if (variant === "LotSoldFeedEvent") {
    var value$47 = value$1.VAL;
    var value$48 = value$47.isWinner;
    var value$49 = value$47.id;
    type_ = {
      __typename: "LotSoldFeedEvent",
      id: value$49,
      isWinner: value$48
    };
  } else if (variant === "ReactiveBid") {
    var value$50 = value$1.VAL;
    var value$51 = value$50.currentBidIsMine;
    var value$52 = value$50.previousBidWasMine;
    var value$53 = value$50.previousBidIsSameAmount;
    var value$54 = value$50.isAdvance;
    var value$55 = value$50.bidAmount;
    var value$56 = value$50.id;
    type_ = {
      __typename: "ReactiveBid",
      id: value$56,
      bidAmount: value$55,
      isAdvance: value$54,
      previousBidIsSameAmount: value$53,
      previousBidWasMine: value$52,
      currentBidIsMine: value$51
    };
  } else {
    var value$57 = value$1.VAL;
    var value$58 = value$57.comment;
    var value$59 = value$57.id;
    type_ = {
      __typename: "Comment",
      id: value$59,
      comment: value$58
    };
  }
  var value$60 = value.id;
  var value$61 = value.__typename;
  return {
          __typename: value$61,
          id: value$60,
          type: type_
        };
}

function verifyArgsAndParse$12(_LotFeedEventFragment, value) {
  return parse$18(value);
}

function verifyName$12(param) {
  
}

var LotFeedEventFragment = {
  Raw: Raw$18,
  query: query$18,
  parse: parse$18,
  serialize: serialize$18,
  verifyArgsAndParse: verifyArgsAndParse$12,
  verifyName: verifyName$12
};

var Raw$19 = {};

var query$19 = ((frag_0) => require("@apollo/client").gql`
  subscription LotFeedSubscription($lotId: String!)  {
    lotFeed(lotId: $lotId)  {
      ...LotFeedEventFragment
    }
  }
  ${frag_0}
`)(query$18);

function parse$19(value) {
  var value$1 = value.lotFeed;
  return {
          lotFeed: !(value$1 == null) ? parse$18(value$1) : undefined
        };
}

function serialize$19(value) {
  var value$1 = value.lotFeed;
  var lotFeed = value$1 !== undefined ? serialize$18(value$1) : null;
  return {
          lotFeed: lotFeed
        };
}

function serializeVariables$6(inp) {
  return {
          lotId: inp.lotId
        };
}

function makeVariables$6(lotId, param) {
  return {
          lotId: lotId
        };
}

var LotFeedSubscription_inner = {
  Raw: Raw$19,
  query: query$19,
  parse: parse$19,
  serialize: serialize$19,
  serializeVariables: serializeVariables$6,
  makeVariables: makeVariables$6
};

var include$6 = ApolloClient__React_Hooks_UseSubscription.Extend({
      query: query$19,
      Raw: Raw$19,
      parse: parse$19,
      serialize: serialize$19,
      serializeVariables: serializeVariables$6
    });

var LotFeedSubscription_use = include$6.use;

var LotFeedSubscription = {
  LotFeedSubscription_inner: LotFeedSubscription_inner,
  Raw: Raw$19,
  query: query$19,
  parse: parse$19,
  serialize: serialize$19,
  serializeVariables: serializeVariables$6,
  makeVariables: makeVariables$6,
  use: LotFeedSubscription_use
};

var LotFeed = {
  LotFeedEventFragment: LotFeedEventFragment,
  LotFeedSubscription: LotFeedSubscription
};

var Raw$20 = {};

var query$20 = ((frag_0) => require("@apollo/client").gql`
  query ParcelLotModalQuery($lotId: String!)  {
    lotV2(lotId: $lotId)  {
      __typename
      ...on LotV2   {
        __typename
        auction  {
          __typename
          auctionId
        }
        parcel  {
          __typename
          canSellAdditionalCount
        }
        latestBid  {
          __typename
          id
          bid  {
            __typename
            amountV2  {
              ...AmountFragment
            }
          }
        }
      }
    }
  }
  ${frag_0}
`)(Amount$LiveRoom.AmountFragment.query);

function parse$20(value) {
  var value$1 = value.lotV2;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var typename = value$1["__typename"];
    var tmp$1;
    if (typename === "LotV2") {
      var value$2 = value$1.auction;
      var value$3 = value$1.parcel;
      var tmp$2;
      if (value$3 == null) {
        tmp$2 = undefined;
      } else {
        var value$4 = value$3.canSellAdditionalCount;
        tmp$2 = {
          __typename: value$3.__typename,
          canSellAdditionalCount: !(value$4 == null) ? value$4 : undefined
        };
      }
      var value$5 = value$1.latestBid;
      var value$6 = value$5.bid;
      var tmp$3;
      if (value$6 == null) {
        tmp$3 = undefined;
      } else {
        var value$7 = value$6.amountV2;
        tmp$3 = {
          __typename: value$6.__typename,
          amountV2: Amount$LiveRoom.AmountFragment.verifyArgsAndParse("AmountFragment", value$7)
        };
      }
      tmp$1 = {
        NAME: "LotV2",
        VAL: {
          __typename: value$1.__typename,
          auction: {
            __typename: value$2.__typename,
            auctionId: value$2.auctionId
          },
          parcel: tmp$2,
          latestBid: {
            __typename: value$5.__typename,
            id: value$5.id,
            bid: tmp$3
          }
        }
      };
    } else {
      tmp$1 = {
        NAME: "UnspecifiedFragment",
        VAL: typename
      };
    }
    tmp = tmp$1;
  }
  return {
          lotV2: tmp
        };
}

function serialize$20(value) {
  var value$1 = value.lotV2;
  var lotV2;
  if (value$1 !== undefined) {
    if (value$1.NAME === "UnspecifiedFragment") {
      lotV2 = {};
    } else {
      var value$2 = value$1.VAL;
      var value$3 = value$2.latestBid;
      var value$4 = value$3.bid;
      var bid;
      if (value$4 !== undefined) {
        var value$5 = value$4.amountV2;
        var amountV2 = Amount$LiveRoom.AmountFragment.serialize(value$5);
        var value$6 = value$4.__typename;
        bid = {
          __typename: value$6,
          amountV2: amountV2
        };
      } else {
        bid = null;
      }
      var value$7 = value$3.id;
      var value$8 = value$3.__typename;
      var latestBid = {
        __typename: value$8,
        id: value$7,
        bid: bid
      };
      var value$9 = value$2.parcel;
      var parcel;
      if (value$9 !== undefined) {
        var value$10 = value$9.canSellAdditionalCount;
        var canSellAdditionalCount = value$10 !== undefined ? value$10 : null;
        var value$11 = value$9.__typename;
        parcel = {
          __typename: value$11,
          canSellAdditionalCount: canSellAdditionalCount
        };
      } else {
        parcel = null;
      }
      var value$12 = value$2.auction;
      var value$13 = value$12.auctionId;
      var value$14 = value$12.__typename;
      var auction = {
        __typename: value$14,
        auctionId: value$13
      };
      lotV2 = {
        __typename: "LotV2",
        auction: auction,
        parcel: parcel,
        latestBid: latestBid
      };
    }
  } else {
    lotV2 = null;
  }
  return {
          lotV2: lotV2
        };
}

function serializeVariables$7(inp) {
  return {
          lotId: inp.lotId
        };
}

function makeVariables$7(lotId, param) {
  return {
          lotId: lotId
        };
}

var ParcelLotModalQuery_inner = {
  Raw: Raw$20,
  query: query$20,
  parse: parse$20,
  serialize: serialize$20,
  serializeVariables: serializeVariables$7,
  makeVariables: makeVariables$7
};

var include$7 = ApolloClient__React_Hooks_UseQuery.Extend({
      query: query$20,
      Raw: Raw$20,
      parse: parse$20,
      serialize: serialize$20,
      serializeVariables: serializeVariables$7
    });

var ParcelLotModalQuery_refetchQueryDescription = include$7.refetchQueryDescription;

var ParcelLotModalQuery_use = include$7.use;

var ParcelLotModalQuery_useLazy = include$7.useLazy;

var ParcelLotModalQuery_useLazyWithVariables = include$7.useLazyWithVariables;

var ParcelLotModalQuery = {
  ParcelLotModalQuery_inner: ParcelLotModalQuery_inner,
  Raw: Raw$20,
  query: query$20,
  parse: parse$20,
  serialize: serialize$20,
  serializeVariables: serializeVariables$7,
  makeVariables: makeVariables$7,
  refetchQueryDescription: ParcelLotModalQuery_refetchQueryDescription,
  use: ParcelLotModalQuery_use,
  useLazy: ParcelLotModalQuery_useLazy,
  useLazyWithVariables: ParcelLotModalQuery_useLazyWithVariables
};

var Raw$21 = {};

var query$21 = (require("@apollo/client").gql`
  mutation InterestInAdditionalParcelLots($auctionId: String!, $lotId: String!, $additionalLotsToBuy: Int!)  {
    interestInAdditionalParcelLots(auctionId: $auctionId, lotId: $lotId, additionalLotsToBuy: $additionalLotsToBuy)
  }
`);

function parse$21(value) {
  return {
          interestInAdditionalParcelLots: value.interestInAdditionalParcelLots
        };
}

function serialize$21(value) {
  var value$1 = value.interestInAdditionalParcelLots;
  return {
          interestInAdditionalParcelLots: value$1
        };
}

function serializeVariables$8(inp) {
  return {
          auctionId: inp.auctionId,
          lotId: inp.lotId,
          additionalLotsToBuy: inp.additionalLotsToBuy
        };
}

function makeVariables$8(auctionId, lotId, additionalLotsToBuy, param) {
  return {
          auctionId: auctionId,
          lotId: lotId,
          additionalLotsToBuy: additionalLotsToBuy
        };
}

var InterestInAdditionalParcelLots_inner = {
  Raw: Raw$21,
  query: query$21,
  parse: parse$21,
  serialize: serialize$21,
  serializeVariables: serializeVariables$8,
  makeVariables: makeVariables$8
};

var include$8 = ApolloClient__React_Hooks_UseMutation.Extend({
      query: query$21,
      Raw: Raw$21,
      parse: parse$21,
      serialize: serialize$21,
      serializeVariables: serializeVariables$8
    });

var InterestInAdditionalParcelLots_use = include$8.use;

var InterestInAdditionalParcelLots_useWithVariables = include$8.useWithVariables;

var InterestInAdditionalParcelLots = {
  InterestInAdditionalParcelLots_inner: InterestInAdditionalParcelLots_inner,
  Raw: Raw$21,
  query: query$21,
  parse: parse$21,
  serialize: serialize$21,
  serializeVariables: serializeVariables$8,
  makeVariables: makeVariables$8,
  use: InterestInAdditionalParcelLots_use,
  useWithVariables: InterestInAdditionalParcelLots_useWithVariables
};

var ParcelLotModal = {
  ParcelLotModalQuery: ParcelLotModalQuery,
  InterestInAdditionalParcelLots: InterestInAdditionalParcelLots
};

var Raw$22 = {};

var query$22 = ((frag_0, frag_1, frag_2) => require("@apollo/client").gql`
  fragment FeedLotMessageBoxFragment on LotV2   {
    __typename
    id
    auction  {
      __typename
      id
      location: locationV2  {
        __typename
        name
      }
      currency: currencyV2
      enrollment  {
        __typename
        paddle
      }
      bidTypeAvailability  {
        __typename
        online  {
          __typename
          isAvailable
        }
      }
    }
    bidState  {
      __typename
      id
      bidAsk
      isClosed
      sold  {
        __typename
        ...on ResultVisible   {
          __typename
          isSold
          premiums  {
            __typename
            finalPrice: finalPriceV2  {
              ...AmountFragment
            }
          }
        }
      }
      bidType: bidTypeV2  {
        __typename
        ...on LiveBidType   {
          __typename
          liveBidPhase
        }
      }
    }
    latestBid  {
      __typename
      id
      bid  {
        __typename
        bidState
        amount: amountV2  {
          ...AmountFragment
        }
      }
    }
    withdrawnState  {
      __typename
      id
      state
    }
    premiumLotState  {
      ...PremiumLotStateFragment
    }
    session  {
      __typename
      id
      state: stateV2  {
        ...SessionStateFragment
      }
      sessionId
      title
    }
  }
  ${frag_0}
  ${frag_1}
  ${frag_2}
`)(Amount$LiveRoom.AmountFragment.query, query$1, query$2);

function parse$22(value) {
  var value$1 = value.auction;
  var value$2 = value$1.location;
  var value$3 = value$1.currency;
  var tmp;
  if (value$3 == null) {
    tmp = undefined;
  } else {
    var tmp$1;
    switch (value$3) {
      case "AED" :
          tmp$1 = "AED";
          break;
      case "ARS" :
          tmp$1 = "ARS";
          break;
      case "AUD" :
          tmp$1 = "AUD";
          break;
      case "BRL" :
          tmp$1 = "BRL";
          break;
      case "BTC" :
          tmp$1 = "BTC";
          break;
      case "CAD" :
          tmp$1 = "CAD";
          break;
      case "CHF" :
          tmp$1 = "CHF";
          break;
      case "CNY" :
          tmp$1 = "CNY";
          break;
      case "ETH" :
          tmp$1 = "ETH";
          break;
      case "EUR" :
          tmp$1 = "EUR";
          break;
      case "GBP" :
          tmp$1 = "GBP";
          break;
      case "HKD" :
          tmp$1 = "HKD";
          break;
      case "IDR" :
          tmp$1 = "IDR";
          break;
      case "INR" :
          tmp$1 = "INR";
          break;
      case "JPY" :
          tmp$1 = "JPY";
          break;
      case "KRW" :
          tmp$1 = "KRW";
          break;
      case "MXN" :
          tmp$1 = "MXN";
          break;
      case "PHP" :
          tmp$1 = "PHP";
          break;
      case "QAR" :
          tmp$1 = "QAR";
          break;
      case "RUB" :
          tmp$1 = "RUB";
          break;
      case "SAR" :
          tmp$1 = "SAR";
          break;
      case "SGD" :
          tmp$1 = "SGD";
          break;
      case "TWD" :
          tmp$1 = "TWD";
          break;
      case "USD" :
          tmp$1 = "USD";
          break;
      default:
        tmp$1 = {
          NAME: "FutureAddedValue",
          VAL: value$3
        };
    }
    tmp = tmp$1;
  }
  var value$4 = value$1.enrollment;
  var value$5 = value$4.paddle;
  var value$6 = value$1.bidTypeAvailability;
  var tmp$2;
  if (value$6 == null) {
    tmp$2 = undefined;
  } else {
    var value$7 = value$6.online;
    tmp$2 = {
      __typename: value$6.__typename,
      online: {
        __typename: value$7.__typename,
        isAvailable: value$7.isAvailable
      }
    };
  }
  var value$8 = value.bidState;
  var tmp$3;
  if (value$8 == null) {
    tmp$3 = undefined;
  } else {
    var value$9 = value$8.bidAsk;
    var value$10 = value$8.sold;
    var tmp$4;
    if (value$10 == null) {
      tmp$4 = undefined;
    } else {
      var typename = value$10["__typename"];
      var tmp$5;
      if (typename === "ResultVisible") {
        var value$11 = value$10.premiums;
        var tmp$6;
        if (value$11 == null) {
          tmp$6 = undefined;
        } else {
          var value$12 = value$11.finalPrice;
          tmp$6 = {
            __typename: value$11.__typename,
            finalPrice: !(value$12 == null) ? Amount$LiveRoom.AmountFragment.verifyArgsAndParse("AmountFragment", value$12) : undefined
          };
        }
        tmp$5 = {
          NAME: "ResultVisible",
          VAL: {
            __typename: value$10.__typename,
            isSold: value$10.isSold,
            premiums: tmp$6
          }
        };
      } else {
        tmp$5 = {
          NAME: "FutureAddedValue",
          VAL: value$10
        };
      }
      tmp$4 = tmp$5;
    }
    var value$13 = value$8.bidType;
    var typename$1 = value$13["__typename"];
    var tmp$7;
    if (typename$1 === "LiveBidType") {
      var value$14 = value$13.liveBidPhase;
      var tmp$8;
      switch (value$14) {
        case "AcceptingBids" :
            tmp$8 = "AcceptingBids";
            break;
        case "Closed" :
            tmp$8 = "Closed";
            break;
        case "ConfirmingResult" :
            tmp$8 = "ConfirmingResult";
            break;
        case "Live" :
            tmp$8 = "Live";
            break;
        case "Preview" :
            tmp$8 = "Preview";
            break;
        case "Published" :
            tmp$8 = "Published";
            break;
        case "Upcoming" :
            tmp$8 = "Upcoming";
            break;
        default:
          tmp$8 = {
            NAME: "FutureAddedValue",
            VAL: value$14
          };
      }
      tmp$7 = {
        NAME: "LiveBidType",
        VAL: {
          __typename: value$13.__typename,
          liveBidPhase: tmp$8
        }
      };
    } else {
      tmp$7 = {
        NAME: "FutureAddedValue",
        VAL: value$13
      };
    }
    tmp$3 = {
      __typename: value$8.__typename,
      id: value$8.id,
      bidAsk: !(value$9 == null) ? value$9 : undefined,
      isClosed: value$8.isClosed,
      sold: tmp$4,
      bidType: tmp$7
    };
  }
  var value$15 = value.latestBid;
  var value$16 = value$15.bid;
  var tmp$9;
  if (value$16 == null) {
    tmp$9 = undefined;
  } else {
    var value$17 = value$16.bidState;
    var tmp$10;
    switch (value$17) {
      case "Absentee" :
          tmp$10 = "Absentee";
          break;
      case "BidAheadOfYou" :
          tmp$10 = "BidAheadOfYou";
          break;
      case "Cancelled" :
          tmp$10 = "Cancelled";
          break;
      case "CurrentBid" :
          tmp$10 = "CurrentBid";
          break;
      case "IrrevocableBid" :
          tmp$10 = "IrrevocableBid";
          break;
      case "Lost" :
          tmp$10 = "Lost";
          break;
      case "MaxBid" :
          tmp$10 = "MaxBid";
          break;
      case "Outbid" :
          tmp$10 = "Outbid";
          break;
      case "ReserveNotMet" :
          tmp$10 = "ReserveNotMet";
          break;
      case "Won" :
          tmp$10 = "Won";
          break;
      default:
        tmp$10 = {
          NAME: "FutureAddedValue",
          VAL: value$17
        };
    }
    var value$18 = value$16.amount;
    tmp$9 = {
      __typename: value$16.__typename,
      bidState: tmp$10,
      amount: Amount$LiveRoom.AmountFragment.verifyArgsAndParse("AmountFragment", value$18)
    };
  }
  var value$19 = value.withdrawnState;
  var value$20 = value$19.state;
  var tmp$11;
  switch (value$20) {
    case "NotAffected" :
        tmp$11 = "NotAffected";
        break;
    case "UnWithdrawn" :
        tmp$11 = "UnWithdrawn";
        break;
    case "Withdrawn" :
        tmp$11 = "Withdrawn";
        break;
    default:
      tmp$11 = {
        NAME: "FutureAddedValue",
        VAL: value$20
      };
  }
  var value$21 = value.session;
  var tmp$12;
  if (value$21 == null) {
    tmp$12 = undefined;
  } else {
    var value$22 = value$21.title;
    tmp$12 = {
      __typename: value$21.__typename,
      id: value$21.id,
      state: parse$2(value$21.state),
      sessionId: value$21.sessionId,
      title: !(value$22 == null) ? value$22 : undefined
    };
  }
  return {
          __typename: value.__typename,
          id: value.id,
          auction: {
            __typename: value$1.__typename,
            id: value$1.id,
            location: !(value$2 == null) ? ({
                  __typename: value$2.__typename,
                  name: value$2.name
                }) : undefined,
            currency: tmp,
            enrollment: {
              __typename: value$4.__typename,
              paddle: !(value$5 == null) ? value$5 : undefined
            },
            bidTypeAvailability: tmp$2
          },
          bidState: tmp$3,
          latestBid: {
            __typename: value$15.__typename,
            id: value$15.id,
            bid: tmp$9
          },
          withdrawnState: {
            __typename: value$19.__typename,
            id: value$19.id,
            state: tmp$11
          },
          premiumLotState: parse$1(value.premiumLotState),
          session: tmp$12
        };
}

function serialize$22(value) {
  var value$1 = value.session;
  var session;
  if (value$1 !== undefined) {
    var value$2 = value$1.title;
    var title = value$2 !== undefined ? value$2 : null;
    var value$3 = value$1.sessionId;
    var value$4 = value$1.state;
    var state = serialize$2(value$4);
    var value$5 = value$1.id;
    var value$6 = value$1.__typename;
    session = {
      __typename: value$6,
      id: value$5,
      state: state,
      sessionId: value$3,
      title: title
    };
  } else {
    session = null;
  }
  var value$7 = value.premiumLotState;
  var premiumLotState = serialize$1(value$7);
  var value$8 = value.withdrawnState;
  var value$9 = value$8.state;
  var state$1 = typeof value$9 === "object" ? value$9.VAL : (
      value$9 === "Withdrawn" ? "Withdrawn" : (
          value$9 === "NotAffected" ? "NotAffected" : "UnWithdrawn"
        )
    );
  var value$10 = value$8.id;
  var value$11 = value$8.__typename;
  var withdrawnState = {
    __typename: value$11,
    id: value$10,
    state: state$1
  };
  var value$12 = value.latestBid;
  var value$13 = value$12.bid;
  var bid;
  if (value$13 !== undefined) {
    var value$14 = value$13.amount;
    var amount = Amount$LiveRoom.AmountFragment.serialize(value$14);
    var value$15 = value$13.bidState;
    var bidState = typeof value$15 === "object" ? value$15.VAL : (
        value$15 === "Cancelled" ? "Cancelled" : (
            value$15 === "IrrevocableBid" ? "IrrevocableBid" : (
                value$15 === "Absentee" ? "Absentee" : (
                    value$15 === "BidAheadOfYou" ? "BidAheadOfYou" : (
                        value$15 === "MaxBid" ? "MaxBid" : (
                            value$15 === "Won" ? "Won" : (
                                value$15 === "ReserveNotMet" ? "ReserveNotMet" : (
                                    value$15 === "Lost" ? "Lost" : (
                                        value$15 === "CurrentBid" ? "CurrentBid" : "Outbid"
                                      )
                                  )
                              )
                          )
                      )
                  )
              )
          )
      );
    var value$16 = value$13.__typename;
    bid = {
      __typename: value$16,
      bidState: bidState,
      amount: amount
    };
  } else {
    bid = null;
  }
  var value$17 = value$12.id;
  var value$18 = value$12.__typename;
  var latestBid = {
    __typename: value$18,
    id: value$17,
    bid: bid
  };
  var value$19 = value.bidState;
  var bidState$1;
  if (value$19 !== undefined) {
    var value$20 = value$19.bidType;
    var bidType;
    if (value$20.NAME === "FutureAddedValue") {
      bidType = value$20.VAL;
    } else {
      var value$21 = value$20.VAL.liveBidPhase;
      var liveBidPhase = typeof value$21 === "object" ? value$21.VAL : (
          value$21 === "Published" ? "Published" : (
              value$21 === "Upcoming" ? "Upcoming" : (
                  value$21 === "ConfirmingResult" ? "ConfirmingResult" : (
                      value$21 === "Preview" ? "Preview" : (
                          value$21 === "AcceptingBids" ? "AcceptingBids" : (
                              value$21 === "Live" ? "Live" : "Closed"
                            )
                        )
                    )
                )
            )
        );
      bidType = {
        __typename: "LiveBidType",
        liveBidPhase: liveBidPhase
      };
    }
    var value$22 = value$19.sold;
    var sold;
    if (value$22 !== undefined) {
      if (value$22.NAME === "FutureAddedValue") {
        sold = value$22.VAL;
      } else {
        var value$23 = value$22.VAL;
        var value$24 = value$23.premiums;
        var premiums;
        if (value$24 !== undefined) {
          var value$25 = value$24.finalPrice;
          var finalPrice = value$25 !== undefined ? Amount$LiveRoom.AmountFragment.serialize(value$25) : null;
          var value$26 = value$24.__typename;
          premiums = {
            __typename: value$26,
            finalPrice: finalPrice
          };
        } else {
          premiums = null;
        }
        var value$27 = value$23.isSold;
        sold = {
          __typename: "ResultVisible",
          isSold: value$27,
          premiums: premiums
        };
      }
    } else {
      sold = null;
    }
    var value$28 = value$19.isClosed;
    var value$29 = value$19.bidAsk;
    var bidAsk = value$29 !== undefined ? value$29 : null;
    var value$30 = value$19.id;
    var value$31 = value$19.__typename;
    bidState$1 = {
      __typename: value$31,
      id: value$30,
      bidAsk: bidAsk,
      isClosed: value$28,
      sold: sold,
      bidType: bidType
    };
  } else {
    bidState$1 = null;
  }
  var value$32 = value.auction;
  var value$33 = value$32.bidTypeAvailability;
  var bidTypeAvailability;
  if (value$33 !== undefined) {
    var value$34 = value$33.online;
    var value$35 = value$34.isAvailable;
    var value$36 = value$34.__typename;
    var online = {
      __typename: value$36,
      isAvailable: value$35
    };
    var value$37 = value$33.__typename;
    bidTypeAvailability = {
      __typename: value$37,
      online: online
    };
  } else {
    bidTypeAvailability = null;
  }
  var value$38 = value$32.enrollment;
  var value$39 = value$38.paddle;
  var paddle = value$39 !== undefined ? value$39 : null;
  var value$40 = value$38.__typename;
  var enrollment = {
    __typename: value$40,
    paddle: paddle
  };
  var value$41 = value$32.currency;
  var currency = value$41 !== undefined ? (
      typeof value$41 === "object" ? value$41.VAL : (
          value$41 === "ARS" ? "ARS" : (
              value$41 === "AUD" ? "AUD" : (
                  value$41 === "BRL" ? "BRL" : (
                      value$41 === "BTC" ? "BTC" : (
                          value$41 === "CAD" ? "CAD" : (
                              value$41 === "CHF" ? "CHF" : (
                                  value$41 === "CNY" ? "CNY" : (
                                      value$41 === "ETH" ? "ETH" : (
                                          value$41 === "EUR" ? "EUR" : (
                                              value$41 === "GBP" ? "GBP" : (
                                                  value$41 === "HKD" ? "HKD" : (
                                                      value$41 === "IDR" ? "IDR" : (
                                                          value$41 === "INR" ? "INR" : (
                                                              value$41 === "JPY" ? "JPY" : (
                                                                  value$41 === "KRW" ? "KRW" : (
                                                                      value$41 === "MXN" ? "MXN" : (
                                                                          value$41 === "PHP" ? "PHP" : (
                                                                              value$41 === "QAR" ? "QAR" : (
                                                                                  value$41 === "RUB" ? "RUB" : (
                                                                                      value$41 === "SAR" ? "SAR" : (
                                                                                          value$41 === "SGD" ? "SGD" : (
                                                                                              value$41 === "TWD" ? "TWD" : (
                                                                                                  value$41 === "USD" ? "USD" : "AED"
                                                                                                )
                                                                                            )
                                                                                        )
                                                                                    )
                                                                                )
                                                                            )
                                                                        )
                                                                    )
                                                                )
                                                            )
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            )
        )
    ) : null;
  var value$42 = value$32.location;
  var $$location;
  if (value$42 !== undefined) {
    var value$43 = value$42.name;
    var value$44 = value$42.__typename;
    $$location = {
      __typename: value$44,
      name: value$43
    };
  } else {
    $$location = null;
  }
  var value$45 = value$32.id;
  var value$46 = value$32.__typename;
  var auction = {
    __typename: value$46,
    id: value$45,
    location: $$location,
    currency: currency,
    enrollment: enrollment,
    bidTypeAvailability: bidTypeAvailability
  };
  var value$47 = value.id;
  var value$48 = value.__typename;
  return {
          __typename: value$48,
          id: value$47,
          auction: auction,
          bidState: bidState$1,
          latestBid: latestBid,
          withdrawnState: withdrawnState,
          premiumLotState: premiumLotState,
          session: session
        };
}

function verifyArgsAndParse$13(_FeedLotMessageBoxFragment, value) {
  return parse$22(value);
}

function verifyName$13(param) {
  
}

var FeedLotMessageBoxFragment = {
  Raw: Raw$22,
  query: query$22,
  parse: parse$22,
  serialize: serialize$22,
  verifyArgsAndParse: verifyArgsAndParse$13,
  verifyName: verifyName$13
};

function makeAuction$1(paddleIdOpt, bidTypeAvailabilityOpt, param) {
  var paddleId = paddleIdOpt !== undefined ? Caml_option.valFromOption(paddleIdOpt) : undefined;
  var bidTypeAvailability = bidTypeAvailabilityOpt !== undefined ? Caml_option.valFromOption(bidTypeAvailabilityOpt) : undefined;
  return {
          __typename: "Auction",
          id: "",
          location: {
            __typename: "AuctionLocation",
            name: "Paris"
          },
          currency: "USD",
          enrollment: {
            __typename: "AuctionEnrollment",
            paddle: paddleId
          },
          bidTypeAvailability: bidTypeAvailability
        };
}

function makeBidType$1(liveBidPhaseOpt, param) {
  var liveBidPhase = liveBidPhaseOpt !== undefined ? liveBidPhaseOpt : "Published";
  return {
          NAME: "LiveBidType",
          VAL: {
            __typename: "LiveBidType",
            liveBidPhase: liveBidPhase
          }
        };
}

function makeBidState(bidAskOpt, isClosedOpt, isLotSoldOpt, bidTypeOpt, premiumsOpt, param) {
  var bidAsk = bidAskOpt !== undefined ? Caml_option.valFromOption(bidAskOpt) : undefined;
  var isClosed = isClosedOpt !== undefined ? isClosedOpt : false;
  var isLotSold = isLotSoldOpt !== undefined ? isLotSoldOpt : false;
  var bidType = bidTypeOpt !== undefined ? bidTypeOpt : makeBidType$1(undefined, undefined);
  var premiums = premiumsOpt !== undefined ? Caml_option.valFromOption(premiumsOpt) : undefined;
  return {
          __typename: "BidState",
          id: "",
          bidAsk: bidAsk,
          isClosed: isClosed,
          sold: {
            NAME: "ResultVisible",
            VAL: {
              __typename: "ResultVisible",
              isSold: isLotSold,
              premiums: premiums
            }
          },
          bidType: bidType
        };
}

function makeWithdrawnState(stateOpt, param) {
  var state = stateOpt !== undefined ? stateOpt : "NotAffected";
  return {
          __typename: "LotWithdrawnState",
          id: "LotWithdrawnState",
          state: state
        };
}

function makePremiumLotState(isPremiumOpt, userIsWhitelistedOpt, param) {
  var isPremium = isPremiumOpt !== undefined ? isPremiumOpt : false;
  var userIsWhitelisted = userIsWhitelistedOpt !== undefined ? userIsWhitelistedOpt : false;
  return {
          __typename: "PremiumLotState",
          id: "premiumLotState",
          isPremium: isPremium,
          userIsWhitelisted: userIsWhitelisted
        };
}

function makeLot(auctionOpt, bidStateOpt, latestBidOpt, withdrawnStateOpt, premiumLotStateOpt, sessionOpt, param) {
  var auction = auctionOpt !== undefined ? auctionOpt : makeAuction$1(undefined, undefined, undefined);
  var bidState = bidStateOpt !== undefined ? Caml_option.valFromOption(bidStateOpt) : makeBidState(undefined, undefined, undefined, undefined, undefined, undefined);
  var latestBid = latestBidOpt !== undefined ? Caml_option.valFromOption(latestBidOpt) : undefined;
  var withdrawnState;
  if (withdrawnStateOpt !== undefined) {
    withdrawnState = withdrawnStateOpt;
  } else {
    var state = "NotAffected";
    withdrawnState = {
      __typename: "LotWithdrawnState",
      id: "LotWithdrawnState",
      state: state
    };
  }
  var premiumLotState = premiumLotStateOpt !== undefined ? premiumLotStateOpt : makePremiumLotState(undefined, undefined, undefined);
  var session = sessionOpt !== undefined ? Caml_option.valFromOption(sessionOpt) : undefined;
  return {
          __typename: "LotV2",
          id: "LotV2",
          auction: auction,
          bidState: bidState,
          latestBid: {
            __typename: "UserBidConnection",
            id: "",
            bid: latestBid
          },
          withdrawnState: withdrawnState,
          premiumLotState: premiumLotState,
          session: session
        };
}

var FeedLotMessageBox = {
  PremiumLotStateFragment: undefined,
  SessionStateFragment: undefined,
  FeedLotMessageBoxFragment: FeedLotMessageBoxFragment,
  makeAuction: makeAuction$1,
  makeBidType: makeBidType$1,
  makeBidState: makeBidState,
  makeWithdrawnState: makeWithdrawnState,
  makePremiumLotState: makePremiumLotState,
  makeLot: makeLot
};

var Raw$23 = {};

var query$23 = (require("@apollo/client").gql`
  fragment AuctionBaseEnrollmentResultFragment on EnrollmentResultConnection   {
    __typename
    id
    auctionId
    enrollmentResult  {
      __typename
      ...on EnrollmentAccepted   {
        __typename
        auctionId
        paddleId
      }
      ...on EnrollmentDeclined   {
        __typename
        auctionId
        enrollmentDeclinedReason
      }
      ...on EnrollmentUpForReview   {
        __typename
        auctionId
      }
    }
  }
`);

function parse$23(value) {
  var value$1 = value.enrollmentResult;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var typename = value$1["__typename"];
    var tmp$1;
    switch (typename) {
      case "EnrollmentAccepted" :
          tmp$1 = {
            NAME: "EnrollmentAccepted",
            VAL: {
              __typename: value$1.__typename,
              auctionId: value$1.auctionId,
              paddleId: value$1.paddleId
            }
          };
          break;
      case "EnrollmentDeclined" :
          var value$2 = value$1.enrollmentDeclinedReason;
          var tmp$2;
          if (value$2 == null) {
            tmp$2 = undefined;
          } else {
            var tmp$3;
            switch (value$2) {
              case "AutochargeMissingPaymentMethod" :
                  tmp$3 = "AutochargeMissingPaymentMethod";
                  break;
              case "IdentificationMissing" :
                  tmp$3 = "IdentificationMissing";
                  break;
              case "MexicoVatCheck" :
                  tmp$3 = "MexicoVatCheck";
                  break;
              default:
                tmp$3 = {
                  NAME: "FutureAddedValue",
                  VAL: value$2
                };
            }
            tmp$2 = tmp$3;
          }
          tmp$1 = {
            NAME: "EnrollmentDeclined",
            VAL: {
              __typename: value$1.__typename,
              auctionId: value$1.auctionId,
              enrollmentDeclinedReason: tmp$2
            }
          };
          break;
      case "EnrollmentUpForReview" :
          tmp$1 = {
            NAME: "EnrollmentUpForReview",
            VAL: {
              __typename: value$1.__typename,
              auctionId: value$1.auctionId
            }
          };
          break;
      default:
        tmp$1 = {
          NAME: "FutureAddedValue",
          VAL: value$1
        };
    }
    tmp = tmp$1;
  }
  return {
          __typename: value.__typename,
          id: value.id,
          auctionId: value.auctionId,
          enrollmentResult: tmp
        };
}

function serialize$23(value) {
  var value$1 = value.enrollmentResult;
  var enrollmentResult;
  if (value$1 !== undefined) {
    var variant = value$1.NAME;
    if (variant === "EnrollmentDeclined") {
      var value$2 = value$1.VAL;
      var value$3 = value$2.enrollmentDeclinedReason;
      var enrollmentDeclinedReason = value$3 !== undefined ? (
          typeof value$3 === "object" ? value$3.VAL : (
              value$3 === "IdentificationMissing" ? "IdentificationMissing" : (
                  value$3 === "AutochargeMissingPaymentMethod" ? "AutochargeMissingPaymentMethod" : "MexicoVatCheck"
                )
            )
        ) : null;
      var value$4 = value$2.auctionId;
      enrollmentResult = {
        __typename: "EnrollmentDeclined",
        auctionId: value$4,
        enrollmentDeclinedReason: enrollmentDeclinedReason
      };
    } else if (variant === "FutureAddedValue") {
      enrollmentResult = value$1.VAL;
    } else if (variant === "EnrollmentUpForReview") {
      var value$5 = value$1.VAL.auctionId;
      enrollmentResult = {
        __typename: "EnrollmentUpForReview",
        auctionId: value$5
      };
    } else {
      var value$6 = value$1.VAL;
      var value$7 = value$6.paddleId;
      var value$8 = value$6.auctionId;
      enrollmentResult = {
        __typename: "EnrollmentAccepted",
        auctionId: value$8,
        paddleId: value$7
      };
    }
  } else {
    enrollmentResult = null;
  }
  var value$9 = value.auctionId;
  var value$10 = value.id;
  var value$11 = value.__typename;
  return {
          __typename: value$11,
          id: value$10,
          auctionId: value$9,
          enrollmentResult: enrollmentResult
        };
}

function verifyArgsAndParse$14(_AuctionBaseEnrollmentResultFragment, value) {
  return parse$23(value);
}

function verifyName$14(param) {
  
}

var AuctionBaseEnrollmentResultFragment = {
  Raw: Raw$23,
  query: query$23,
  parse: parse$23,
  serialize: serialize$23,
  verifyArgsAndParse: verifyArgsAndParse$14,
  verifyName: verifyName$14
};

var Enrollment = {
  AuctionBaseEnrollmentResultFragment: AuctionBaseEnrollmentResultFragment
};

var Raw$24 = {};

var query$24 = (require("@apollo/client").gql`
  fragment PlaceBidUserBidConnectionFragment on UserBidConnection   {
    __typename
    id
    bid  {
      __typename
      bidState
      additionalLotsToBuy
    }
  }
`);

function parse$24(value) {
  var value$1 = value.bid;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.bidState;
    var tmp$1;
    switch (value$2) {
      case "Absentee" :
          tmp$1 = "Absentee";
          break;
      case "BidAheadOfYou" :
          tmp$1 = "BidAheadOfYou";
          break;
      case "Cancelled" :
          tmp$1 = "Cancelled";
          break;
      case "CurrentBid" :
          tmp$1 = "CurrentBid";
          break;
      case "IrrevocableBid" :
          tmp$1 = "IrrevocableBid";
          break;
      case "Lost" :
          tmp$1 = "Lost";
          break;
      case "MaxBid" :
          tmp$1 = "MaxBid";
          break;
      case "Outbid" :
          tmp$1 = "Outbid";
          break;
      case "ReserveNotMet" :
          tmp$1 = "ReserveNotMet";
          break;
      case "Won" :
          tmp$1 = "Won";
          break;
      default:
        tmp$1 = {
          NAME: "FutureAddedValue",
          VAL: value$2
        };
    }
    var value$3 = value$1.additionalLotsToBuy;
    tmp = {
      __typename: value$1.__typename,
      bidState: tmp$1,
      additionalLotsToBuy: !(value$3 == null) ? value$3 : undefined
    };
  }
  return {
          __typename: value.__typename,
          id: value.id,
          bid: tmp
        };
}

function serialize$24(value) {
  var value$1 = value.bid;
  var bid;
  if (value$1 !== undefined) {
    var value$2 = value$1.additionalLotsToBuy;
    var additionalLotsToBuy = value$2 !== undefined ? value$2 : null;
    var value$3 = value$1.bidState;
    var bidState = typeof value$3 === "object" ? value$3.VAL : (
        value$3 === "Cancelled" ? "Cancelled" : (
            value$3 === "IrrevocableBid" ? "IrrevocableBid" : (
                value$3 === "Absentee" ? "Absentee" : (
                    value$3 === "BidAheadOfYou" ? "BidAheadOfYou" : (
                        value$3 === "MaxBid" ? "MaxBid" : (
                            value$3 === "Won" ? "Won" : (
                                value$3 === "ReserveNotMet" ? "ReserveNotMet" : (
                                    value$3 === "Lost" ? "Lost" : (
                                        value$3 === "CurrentBid" ? "CurrentBid" : "Outbid"
                                      )
                                  )
                              )
                          )
                      )
                  )
              )
          )
      );
    var value$4 = value$1.__typename;
    bid = {
      __typename: value$4,
      bidState: bidState,
      additionalLotsToBuy: additionalLotsToBuy
    };
  } else {
    bid = null;
  }
  var value$5 = value.id;
  var value$6 = value.__typename;
  return {
          __typename: value$6,
          id: value$5,
          bid: bid
        };
}

function verifyArgsAndParse$15(_PlaceBidUserBidConnectionFragment, value) {
  return parse$24(value);
}

function verifyName$15(param) {
  
}

var PlaceBidUserBidConnectionFragment = {
  Raw: Raw$24,
  query: query$24,
  parse: parse$24,
  serialize: serialize$24,
  verifyArgsAndParse: verifyArgsAndParse$15,
  verifyName: verifyName$15
};

var Raw$25 = {};

var query$25 = (require("@apollo/client").gql`
  fragment PlaceBidBidStateFragment on BidState   {
    __typename
    id
    isClosed
    bidAsk
    bidType: bidTypeV2  {
      __typename
      ...on LiveBidType   {
        __typename
        liveBidPhase
      }
    }
    sold  {
      __typename
      ...on ResultVisible   {
        __typename
        isSold
      }
    }
  }
`);

function parse$25(value) {
  var value$1 = value.bidAsk;
  var value$2 = value.bidType;
  var typename = value$2["__typename"];
  var tmp;
  if (typename === "LiveBidType") {
    var value$3 = value$2.liveBidPhase;
    var tmp$1;
    switch (value$3) {
      case "AcceptingBids" :
          tmp$1 = "AcceptingBids";
          break;
      case "Closed" :
          tmp$1 = "Closed";
          break;
      case "ConfirmingResult" :
          tmp$1 = "ConfirmingResult";
          break;
      case "Live" :
          tmp$1 = "Live";
          break;
      case "Preview" :
          tmp$1 = "Preview";
          break;
      case "Published" :
          tmp$1 = "Published";
          break;
      case "Upcoming" :
          tmp$1 = "Upcoming";
          break;
      default:
        tmp$1 = {
          NAME: "FutureAddedValue",
          VAL: value$3
        };
    }
    tmp = {
      NAME: "LiveBidType",
      VAL: {
        __typename: value$2.__typename,
        liveBidPhase: tmp$1
      }
    };
  } else {
    tmp = {
      NAME: "FutureAddedValue",
      VAL: value$2
    };
  }
  var value$4 = value.sold;
  var tmp$2;
  if (value$4 == null) {
    tmp$2 = undefined;
  } else {
    var typename$1 = value$4["__typename"];
    var tmp$3 = typename$1 === "ResultVisible" ? ({
          NAME: "ResultVisible",
          VAL: {
            __typename: value$4.__typename,
            isSold: value$4.isSold
          }
        }) : ({
          NAME: "FutureAddedValue",
          VAL: value$4
        });
    tmp$2 = tmp$3;
  }
  return {
          __typename: value.__typename,
          id: value.id,
          isClosed: value.isClosed,
          bidAsk: !(value$1 == null) ? value$1 : undefined,
          bidType: tmp,
          sold: tmp$2
        };
}

function serialize$25(value) {
  var value$1 = value.sold;
  var sold;
  if (value$1 !== undefined) {
    if (value$1.NAME === "FutureAddedValue") {
      sold = value$1.VAL;
    } else {
      var value$2 = value$1.VAL.isSold;
      sold = {
        __typename: "ResultVisible",
        isSold: value$2
      };
    }
  } else {
    sold = null;
  }
  var value$3 = value.bidType;
  var bidType;
  if (value$3.NAME === "FutureAddedValue") {
    bidType = value$3.VAL;
  } else {
    var value$4 = value$3.VAL.liveBidPhase;
    var liveBidPhase = typeof value$4 === "object" ? value$4.VAL : (
        value$4 === "Published" ? "Published" : (
            value$4 === "Upcoming" ? "Upcoming" : (
                value$4 === "ConfirmingResult" ? "ConfirmingResult" : (
                    value$4 === "Preview" ? "Preview" : (
                        value$4 === "AcceptingBids" ? "AcceptingBids" : (
                            value$4 === "Live" ? "Live" : "Closed"
                          )
                      )
                  )
              )
          )
      );
    bidType = {
      __typename: "LiveBidType",
      liveBidPhase: liveBidPhase
    };
  }
  var value$5 = value.bidAsk;
  var bidAsk = value$5 !== undefined ? value$5 : null;
  var value$6 = value.isClosed;
  var value$7 = value.id;
  var value$8 = value.__typename;
  return {
          __typename: value$8,
          id: value$7,
          isClosed: value$6,
          bidAsk: bidAsk,
          bidType: bidType,
          sold: sold
        };
}

function verifyArgsAndParse$16(_PlaceBidBidStateFragment, value) {
  return parse$25(value);
}

function verifyName$16(param) {
  
}

var PlaceBidBidStateFragment = {
  Raw: Raw$25,
  query: query$25,
  parse: parse$25,
  serialize: serialize$25,
  verifyArgsAndParse: verifyArgsAndParse$16,
  verifyName: verifyName$16
};

var Raw$26 = {};

var query$26 = ((frag_0) => require("@apollo/client").gql`
  fragment PlaceBidButtonAuctionFragment on Auction   {
    __typename
    id
    auctionId
    type
    sapSaleNumber
    departmentNames
    currency: currencyV2
    enrollment  {
      __typename
      result  {
        ...AuctionBaseEnrollmentResultFragment
      }
    }
    title
    slug  {
      __typename
      name
      year
    }
  }
  ${frag_0}
`)(query$23);

function parse$26(value) {
  var value$1 = value.type;
  var tmp;
  switch (value$1) {
    case "Live" :
        tmp = "Live";
        break;
    case "Timed" :
        tmp = "Timed";
        break;
    default:
      tmp = {
        NAME: "FutureAddedValue",
        VAL: value$1
      };
  }
  var value$2 = value.sapSaleNumber;
  var value$3 = value.departmentNames;
  var value$4 = value.currency;
  var tmp$1;
  if (value$4 == null) {
    tmp$1 = undefined;
  } else {
    var tmp$2;
    switch (value$4) {
      case "AED" :
          tmp$2 = "AED";
          break;
      case "ARS" :
          tmp$2 = "ARS";
          break;
      case "AUD" :
          tmp$2 = "AUD";
          break;
      case "BRL" :
          tmp$2 = "BRL";
          break;
      case "BTC" :
          tmp$2 = "BTC";
          break;
      case "CAD" :
          tmp$2 = "CAD";
          break;
      case "CHF" :
          tmp$2 = "CHF";
          break;
      case "CNY" :
          tmp$2 = "CNY";
          break;
      case "ETH" :
          tmp$2 = "ETH";
          break;
      case "EUR" :
          tmp$2 = "EUR";
          break;
      case "GBP" :
          tmp$2 = "GBP";
          break;
      case "HKD" :
          tmp$2 = "HKD";
          break;
      case "IDR" :
          tmp$2 = "IDR";
          break;
      case "INR" :
          tmp$2 = "INR";
          break;
      case "JPY" :
          tmp$2 = "JPY";
          break;
      case "KRW" :
          tmp$2 = "KRW";
          break;
      case "MXN" :
          tmp$2 = "MXN";
          break;
      case "PHP" :
          tmp$2 = "PHP";
          break;
      case "QAR" :
          tmp$2 = "QAR";
          break;
      case "RUB" :
          tmp$2 = "RUB";
          break;
      case "SAR" :
          tmp$2 = "SAR";
          break;
      case "SGD" :
          tmp$2 = "SGD";
          break;
      case "TWD" :
          tmp$2 = "TWD";
          break;
      case "USD" :
          tmp$2 = "USD";
          break;
      default:
        tmp$2 = {
          NAME: "FutureAddedValue",
          VAL: value$4
        };
    }
    tmp$1 = tmp$2;
  }
  var value$5 = value.enrollment;
  var value$6 = value$5.result;
  var value$7 = value.title;
  var value$8 = value.slug;
  return {
          __typename: value.__typename,
          id: value.id,
          auctionId: value.auctionId,
          type: tmp,
          sapSaleNumber: !(value$2 == null) ? value$2 : undefined,
          departmentNames: Js_array.map((function (value) {
                  return value;
                }), value$3),
          currency: tmp$1,
          enrollment: {
            __typename: value$5.__typename,
            result: !(value$6 == null) ? parse$23(value$6) : undefined
          },
          title: !(value$7 == null) ? value$7 : undefined,
          slug: {
            __typename: value$8.__typename,
            name: value$8.name,
            year: value$8.year
          }
        };
}

function serialize$26(value) {
  var value$1 = value.slug;
  var value$2 = value$1.year;
  var value$3 = value$1.name;
  var value$4 = value$1.__typename;
  var slug = {
    __typename: value$4,
    name: value$3,
    year: value$2
  };
  var value$5 = value.title;
  var title = value$5 !== undefined ? value$5 : null;
  var value$6 = value.enrollment;
  var value$7 = value$6.result;
  var result = value$7 !== undefined ? serialize$23(value$7) : null;
  var value$8 = value$6.__typename;
  var enrollment = {
    __typename: value$8,
    result: result
  };
  var value$9 = value.currency;
  var currency = value$9 !== undefined ? (
      typeof value$9 === "object" ? value$9.VAL : (
          value$9 === "ARS" ? "ARS" : (
              value$9 === "AUD" ? "AUD" : (
                  value$9 === "BRL" ? "BRL" : (
                      value$9 === "BTC" ? "BTC" : (
                          value$9 === "CAD" ? "CAD" : (
                              value$9 === "CHF" ? "CHF" : (
                                  value$9 === "CNY" ? "CNY" : (
                                      value$9 === "ETH" ? "ETH" : (
                                          value$9 === "EUR" ? "EUR" : (
                                              value$9 === "GBP" ? "GBP" : (
                                                  value$9 === "HKD" ? "HKD" : (
                                                      value$9 === "IDR" ? "IDR" : (
                                                          value$9 === "INR" ? "INR" : (
                                                              value$9 === "JPY" ? "JPY" : (
                                                                  value$9 === "KRW" ? "KRW" : (
                                                                      value$9 === "MXN" ? "MXN" : (
                                                                          value$9 === "PHP" ? "PHP" : (
                                                                              value$9 === "QAR" ? "QAR" : (
                                                                                  value$9 === "RUB" ? "RUB" : (
                                                                                      value$9 === "SAR" ? "SAR" : (
                                                                                          value$9 === "SGD" ? "SGD" : (
                                                                                              value$9 === "TWD" ? "TWD" : (
                                                                                                  value$9 === "USD" ? "USD" : "AED"
                                                                                                )
                                                                                            )
                                                                                        )
                                                                                    )
                                                                                )
                                                                            )
                                                                        )
                                                                    )
                                                                )
                                                            )
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            )
        )
    ) : null;
  var value$10 = value.departmentNames;
  var departmentNames = Js_array.map((function (value) {
          return value;
        }), value$10);
  var value$11 = value.sapSaleNumber;
  var sapSaleNumber = value$11 !== undefined ? value$11 : null;
  var value$12 = value.type;
  var type_ = typeof value$12 === "object" ? value$12.VAL : (
      value$12 === "Live" ? "Live" : "Timed"
    );
  var value$13 = value.auctionId;
  var value$14 = value.id;
  var value$15 = value.__typename;
  return {
          __typename: value$15,
          id: value$14,
          auctionId: value$13,
          type: type_,
          sapSaleNumber: sapSaleNumber,
          departmentNames: departmentNames,
          currency: currency,
          enrollment: enrollment,
          title: title,
          slug: slug
        };
}

function verifyArgsAndParse$17(_PlaceBidButtonAuctionFragment, value) {
  return parse$26(value);
}

function verifyName$17(param) {
  
}

var PlaceBidButtonAuctionFragment = {
  Raw: Raw$26,
  query: query$26,
  parse: parse$26,
  serialize: serialize$26,
  verifyArgsAndParse: verifyArgsAndParse$17,
  verifyName: verifyName$17
};

var Raw$27 = {};

var query$27 = ((frag_0, frag_1, frag_2, frag_3) => require("@apollo/client").gql`
  fragment PlaceBidButtonLotFragment on LotV2   {
    __typename
    id
    lotId
    title
    lotNumber  {
      __typename
      ...on VisibleLotNumber   {
        __typename
        lotNumber
      }
      ...on HiddenLotNumber   {
        __typename
        isHidden
      }
    }
    premiumLotState  {
      ...PremiumLotStateFragment
    }
    bidState  {
      ...PlaceBidBidStateFragment
    }
    latestBid  {
      ...PlaceBidUserBidConnectionFragment
    }
    withdrawnState  {
      __typename
      id
      state
    }
    session  {
      __typename
      state: stateV2  {
        ...SessionStateFragment
      }
    }
  }
  ${frag_0}
  ${frag_1}
  ${frag_2}
  ${frag_3}
`)(query$25, query$24, query$1, query$2);

function parse$27(value) {
  var value$1 = value.lotNumber;
  var typename = value$1["__typename"];
  var tmp;
  switch (typename) {
    case "HiddenLotNumber" :
        tmp = {
          NAME: "HiddenLotNumber",
          VAL: {
            __typename: value$1.__typename,
            isHidden: value$1.isHidden
          }
        };
        break;
    case "VisibleLotNumber" :
        tmp = {
          NAME: "VisibleLotNumber",
          VAL: {
            __typename: value$1.__typename,
            lotNumber: value$1.lotNumber
          }
        };
        break;
    default:
      tmp = {
        NAME: "FutureAddedValue",
        VAL: value$1
      };
  }
  var value$2 = value.bidState;
  var value$3 = value.withdrawnState;
  var value$4 = value$3.state;
  var tmp$1;
  switch (value$4) {
    case "NotAffected" :
        tmp$1 = "NotAffected";
        break;
    case "UnWithdrawn" :
        tmp$1 = "UnWithdrawn";
        break;
    case "Withdrawn" :
        tmp$1 = "Withdrawn";
        break;
    default:
      tmp$1 = {
        NAME: "FutureAddedValue",
        VAL: value$4
      };
  }
  var value$5 = value.session;
  return {
          __typename: value.__typename,
          id: value.id,
          lotId: value.lotId,
          title: value.title,
          lotNumber: tmp,
          premiumLotState: parse$1(value.premiumLotState),
          bidState: !(value$2 == null) ? parse$25(value$2) : undefined,
          latestBid: parse$24(value.latestBid),
          withdrawnState: {
            __typename: value$3.__typename,
            id: value$3.id,
            state: tmp$1
          },
          session: !(value$5 == null) ? ({
                __typename: value$5.__typename,
                state: parse$2(value$5.state)
              }) : undefined
        };
}

function serialize$27(value) {
  var value$1 = value.session;
  var session;
  if (value$1 !== undefined) {
    var value$2 = value$1.state;
    var state = serialize$2(value$2);
    var value$3 = value$1.__typename;
    session = {
      __typename: value$3,
      state: state
    };
  } else {
    session = null;
  }
  var value$4 = value.withdrawnState;
  var value$5 = value$4.state;
  var state$1 = typeof value$5 === "object" ? value$5.VAL : (
      value$5 === "Withdrawn" ? "Withdrawn" : (
          value$5 === "NotAffected" ? "NotAffected" : "UnWithdrawn"
        )
    );
  var value$6 = value$4.id;
  var value$7 = value$4.__typename;
  var withdrawnState = {
    __typename: value$7,
    id: value$6,
    state: state$1
  };
  var value$8 = value.latestBid;
  var latestBid = serialize$24(value$8);
  var value$9 = value.bidState;
  var bidState = value$9 !== undefined ? serialize$25(value$9) : null;
  var value$10 = value.premiumLotState;
  var premiumLotState = serialize$1(value$10);
  var value$11 = value.lotNumber;
  var variant = value$11.NAME;
  var lotNumber;
  if (variant === "VisibleLotNumber") {
    var value$12 = value$11.VAL.lotNumber;
    lotNumber = {
      __typename: "VisibleLotNumber",
      lotNumber: value$12
    };
  } else if (variant === "HiddenLotNumber") {
    var value$13 = value$11.VAL.isHidden;
    lotNumber = {
      __typename: "HiddenLotNumber",
      isHidden: value$13
    };
  } else {
    lotNumber = value$11.VAL;
  }
  var value$14 = value.title;
  var value$15 = value.lotId;
  var value$16 = value.id;
  var value$17 = value.__typename;
  return {
          __typename: value$17,
          id: value$16,
          lotId: value$15,
          title: value$14,
          lotNumber: lotNumber,
          premiumLotState: premiumLotState,
          bidState: bidState,
          latestBid: latestBid,
          withdrawnState: withdrawnState,
          session: session
        };
}

function verifyArgsAndParse$18(_PlaceBidButtonLotFragment, value) {
  return parse$27(value);
}

function verifyName$18(param) {
  
}

var PlaceBidButtonLotFragment = {
  Raw: Raw$27,
  query: query$27,
  parse: parse$27,
  serialize: serialize$27,
  verifyArgsAndParse: verifyArgsAndParse$18,
  verifyName: verifyName$18
};

var Raw$28 = {};

var query$28 = (require("@apollo/client").gql`
  mutation PlaceBidMutation($auctionId: String!, $lotId: String!, $bidAmount: String!)  {
    placeLiveBid(auctionId: $auctionId, bidAmount: $bidAmount, lotId: $lotId)
  }
`);

function parse$28(value) {
  var value$1 = value.placeLiveBid;
  var tmp;
  switch (value$1) {
    case "BidAgainstYou" :
        tmp = "BidAgainstYou";
        break;
    case "BidBelowCurrentBid" :
        tmp = "BidBelowCurrentBid";
        break;
    case "BidBelowHighBid" :
        tmp = "BidBelowHighBid";
        break;
    case "BidBlocked" :
        tmp = "BidBlocked";
        break;
    case "BidOffIncrement" :
        tmp = "BidOffIncrement";
        break;
    case "BidPlaced" :
        tmp = "BidPlaced";
        break;
    case "BidPlacedAbsentee" :
        tmp = "BidPlacedAbsentee";
        break;
    case "BidRequestSent" :
        tmp = "BidRequestSent";
        break;
    case "UnknownStatus" :
        tmp = "UnknownStatus";
        break;
    default:
      tmp = {
        NAME: "FutureAddedValue",
        VAL: value$1
      };
  }
  return {
          placeLiveBid: tmp
        };
}

function serialize$28(value) {
  var value$1 = value.placeLiveBid;
  var placeLiveBid = typeof value$1 === "object" ? value$1.VAL : (
      value$1 === "BidPlacedAbsentee" ? "BidPlacedAbsentee" : (
          value$1 === "BidBlocked" ? "BidBlocked" : (
              value$1 === "BidPlaced" ? "BidPlaced" : (
                  value$1 === "UnknownStatus" ? "UnknownStatus" : (
                      value$1 === "BidBelowCurrentBid" ? "BidBelowCurrentBid" : (
                          value$1 === "BidOffIncrement" ? "BidOffIncrement" : (
                              value$1 === "BidAgainstYou" ? "BidAgainstYou" : (
                                  value$1 === "BidBelowHighBid" ? "BidBelowHighBid" : "BidRequestSent"
                                )
                            )
                        )
                    )
                )
            )
        )
    );
  return {
          placeLiveBid: placeLiveBid
        };
}

function serializeVariables$9(inp) {
  return {
          auctionId: inp.auctionId,
          lotId: inp.lotId,
          bidAmount: inp.bidAmount
        };
}

function makeVariables$9(auctionId, lotId, bidAmount, param) {
  return {
          auctionId: auctionId,
          lotId: lotId,
          bidAmount: bidAmount
        };
}

var PlaceBidMutation_inner = {
  Raw: Raw$28,
  query: query$28,
  parse: parse$28,
  serialize: serialize$28,
  serializeVariables: serializeVariables$9,
  makeVariables: makeVariables$9
};

var include$9 = ApolloClient__React_Hooks_UseMutation.Extend({
      query: query$28,
      Raw: Raw$28,
      parse: parse$28,
      serialize: serialize$28,
      serializeVariables: serializeVariables$9
    });

var PlaceBidMutation_use = include$9.use;

var PlaceBidMutation_useWithVariables = include$9.useWithVariables;

var PlaceBidMutation = {
  PlaceBidMutation_inner: PlaceBidMutation_inner,
  Raw: Raw$28,
  query: query$28,
  parse: parse$28,
  serialize: serialize$28,
  serializeVariables: serializeVariables$9,
  makeVariables: makeVariables$9,
  use: PlaceBidMutation_use,
  useWithVariables: PlaceBidMutation_useWithVariables
};

function makeUserBidConnectionFragment(param) {
  return {
          __typename: "UserBidConnection",
          id: "UserBidConnection",
          bid: undefined
        };
}

var defaultLotNumber$2 = {
  NAME: "HiddenLotNumber",
  VAL: {
    __typename: "HiddenLotNumber",
    isHidden: false
  }
};

var defaultPremiumLotState$1 = {
  __typename: "PremiumLotState",
  id: "",
  isPremium: false,
  userIsWhitelisted: true
};

var defaultWithdrawnState$1 = {
  __typename: "WithdrawnState",
  id: "",
  state: "NotAffected"
};

function makeLotFragment$2(lotId, param) {
  return {
          __typename: "LotV2",
          id: "",
          lotId: lotId,
          title: "",
          lotNumber: defaultLotNumber$2,
          premiumLotState: defaultPremiumLotState$1,
          bidState: undefined,
          latestBid: {
            __typename: "UserBidConnection",
            id: "UserBidConnection",
            bid: undefined
          },
          withdrawnState: defaultWithdrawnState$1,
          session: undefined
        };
}

var PlaceBidButton = {
  PremiumLotStateFragment: undefined,
  SessionStateFragment: undefined,
  AuctionBaseEnrollmentResultFragment: undefined,
  PlaceBidUserBidConnectionFragment: PlaceBidUserBidConnectionFragment,
  PlaceBidBidStateFragment: PlaceBidBidStateFragment,
  PlaceBidButtonAuctionFragment: PlaceBidButtonAuctionFragment,
  PlaceBidButtonLotFragment: PlaceBidButtonLotFragment,
  PlaceBidMutation: PlaceBidMutation,
  makeUserBidConnectionFragment: makeUserBidConnectionFragment,
  defaultLotNumber: defaultLotNumber$2,
  defaultPremiumLotState: defaultPremiumLotState$1,
  defaultWithdrawnState: defaultWithdrawnState$1,
  makeLotFragment: makeLotFragment$2
};

var Raw$29 = {};

var query$29 = ((frag_0) => require("@apollo/client").gql`
  fragment AuctionHeaderAuctionFragment on Auction   {
    __typename
    id
    auctionId
    sapSaleNumber
    title
    hasConditionsOfSale
    hasOverview
    currency: currencyV2
    departmentNames
    location: locationV2  {
      __typename
      name
      displayLocation  {
        __typename
        name
      }
    }
    sessions  {
      __typename
      title
      sessionId
      scheduledOpeningDate
      state: stateV2  {
        ...SessionStateFragment
      }
    }
    slug  {
      __typename
      name
      year
    }
    enrollment  {
      __typename
      paddle
      enrollmentResult  {
        __typename
        ...on EnrollmentAccepted   {
          __typename
          auctionId
          paddleId
        }
        ...on EnrollmentDeclined   {
          __typename
          auctionId
          enrollmentDeclinedReason
        }
        ...on EnrollmentUpForReview   {
          __typename
          auctionId
        }
      }
    }
  }
  ${frag_0}
`)(query$2);

function parse$29(value) {
  var value$1 = value.sapSaleNumber;
  var value$2 = value.title;
  var value$3 = value.currency;
  var tmp;
  if (value$3 == null) {
    tmp = undefined;
  } else {
    var tmp$1;
    switch (value$3) {
      case "AED" :
          tmp$1 = "AED";
          break;
      case "ARS" :
          tmp$1 = "ARS";
          break;
      case "AUD" :
          tmp$1 = "AUD";
          break;
      case "BRL" :
          tmp$1 = "BRL";
          break;
      case "BTC" :
          tmp$1 = "BTC";
          break;
      case "CAD" :
          tmp$1 = "CAD";
          break;
      case "CHF" :
          tmp$1 = "CHF";
          break;
      case "CNY" :
          tmp$1 = "CNY";
          break;
      case "ETH" :
          tmp$1 = "ETH";
          break;
      case "EUR" :
          tmp$1 = "EUR";
          break;
      case "GBP" :
          tmp$1 = "GBP";
          break;
      case "HKD" :
          tmp$1 = "HKD";
          break;
      case "IDR" :
          tmp$1 = "IDR";
          break;
      case "INR" :
          tmp$1 = "INR";
          break;
      case "JPY" :
          tmp$1 = "JPY";
          break;
      case "KRW" :
          tmp$1 = "KRW";
          break;
      case "MXN" :
          tmp$1 = "MXN";
          break;
      case "PHP" :
          tmp$1 = "PHP";
          break;
      case "QAR" :
          tmp$1 = "QAR";
          break;
      case "RUB" :
          tmp$1 = "RUB";
          break;
      case "SAR" :
          tmp$1 = "SAR";
          break;
      case "SGD" :
          tmp$1 = "SGD";
          break;
      case "TWD" :
          tmp$1 = "TWD";
          break;
      case "USD" :
          tmp$1 = "USD";
          break;
      default:
        tmp$1 = {
          NAME: "FutureAddedValue",
          VAL: value$3
        };
    }
    tmp = tmp$1;
  }
  var value$4 = value.departmentNames;
  var value$5 = value.location;
  var tmp$2;
  if (value$5 == null) {
    tmp$2 = undefined;
  } else {
    var value$6 = value$5.displayLocation;
    tmp$2 = {
      __typename: value$5.__typename,
      name: value$5.name,
      displayLocation: {
        __typename: value$6.__typename,
        name: value$6.name
      }
    };
  }
  var value$7 = value.sessions;
  var value$8 = value.slug;
  var value$9 = value.enrollment;
  var value$10 = value$9.paddle;
  var value$11 = value$9.enrollmentResult;
  var tmp$3;
  if (value$11 == null) {
    tmp$3 = undefined;
  } else {
    var typename = value$11["__typename"];
    var tmp$4;
    switch (typename) {
      case "EnrollmentAccepted" :
          tmp$4 = {
            NAME: "EnrollmentAccepted",
            VAL: {
              __typename: value$11.__typename,
              auctionId: value$11.auctionId,
              paddleId: value$11.paddleId
            }
          };
          break;
      case "EnrollmentDeclined" :
          var value$12 = value$11.enrollmentDeclinedReason;
          var tmp$5;
          if (value$12 == null) {
            tmp$5 = undefined;
          } else {
            var tmp$6;
            switch (value$12) {
              case "AutochargeMissingPaymentMethod" :
                  tmp$6 = "AutochargeMissingPaymentMethod";
                  break;
              case "IdentificationMissing" :
                  tmp$6 = "IdentificationMissing";
                  break;
              case "MexicoVatCheck" :
                  tmp$6 = "MexicoVatCheck";
                  break;
              default:
                tmp$6 = {
                  NAME: "FutureAddedValue",
                  VAL: value$12
                };
            }
            tmp$5 = tmp$6;
          }
          tmp$4 = {
            NAME: "EnrollmentDeclined",
            VAL: {
              __typename: value$11.__typename,
              auctionId: value$11.auctionId,
              enrollmentDeclinedReason: tmp$5
            }
          };
          break;
      case "EnrollmentUpForReview" :
          tmp$4 = {
            NAME: "EnrollmentUpForReview",
            VAL: {
              __typename: value$11.__typename,
              auctionId: value$11.auctionId
            }
          };
          break;
      default:
        tmp$4 = {
          NAME: "FutureAddedValue",
          VAL: value$11
        };
    }
    tmp$3 = tmp$4;
  }
  return {
          __typename: value.__typename,
          id: value.id,
          auctionId: value.auctionId,
          sapSaleNumber: !(value$1 == null) ? value$1 : undefined,
          title: !(value$2 == null) ? value$2 : undefined,
          hasConditionsOfSale: value.hasConditionsOfSale,
          hasOverview: value.hasOverview,
          currency: tmp,
          departmentNames: Js_array.map((function (value) {
                  return value;
                }), value$4),
          location: tmp$2,
          sessions: Js_array.map((function (value) {
                  var value$1 = value.title;
                  return {
                          __typename: value.__typename,
                          title: !(value$1 == null) ? value$1 : undefined,
                          sessionId: value.sessionId,
                          scheduledOpeningDate: value.scheduledOpeningDate,
                          state: parse$2(value.state)
                        };
                }), value$7),
          slug: {
            __typename: value$8.__typename,
            name: value$8.name,
            year: value$8.year
          },
          enrollment: {
            __typename: value$9.__typename,
            paddle: !(value$10 == null) ? value$10 : undefined,
            enrollmentResult: tmp$3
          }
        };
}

function serialize$29(value) {
  var value$1 = value.enrollment;
  var value$2 = value$1.enrollmentResult;
  var enrollmentResult;
  if (value$2 !== undefined) {
    var variant = value$2.NAME;
    if (variant === "EnrollmentDeclined") {
      var value$3 = value$2.VAL;
      var value$4 = value$3.enrollmentDeclinedReason;
      var enrollmentDeclinedReason = value$4 !== undefined ? (
          typeof value$4 === "object" ? value$4.VAL : (
              value$4 === "IdentificationMissing" ? "IdentificationMissing" : (
                  value$4 === "AutochargeMissingPaymentMethod" ? "AutochargeMissingPaymentMethod" : "MexicoVatCheck"
                )
            )
        ) : null;
      var value$5 = value$3.auctionId;
      enrollmentResult = {
        __typename: "EnrollmentDeclined",
        auctionId: value$5,
        enrollmentDeclinedReason: enrollmentDeclinedReason
      };
    } else if (variant === "FutureAddedValue") {
      enrollmentResult = value$2.VAL;
    } else if (variant === "EnrollmentUpForReview") {
      var value$6 = value$2.VAL.auctionId;
      enrollmentResult = {
        __typename: "EnrollmentUpForReview",
        auctionId: value$6
      };
    } else {
      var value$7 = value$2.VAL;
      var value$8 = value$7.paddleId;
      var value$9 = value$7.auctionId;
      enrollmentResult = {
        __typename: "EnrollmentAccepted",
        auctionId: value$9,
        paddleId: value$8
      };
    }
  } else {
    enrollmentResult = null;
  }
  var value$10 = value$1.paddle;
  var paddle = value$10 !== undefined ? value$10 : null;
  var value$11 = value$1.__typename;
  var enrollment = {
    __typename: value$11,
    paddle: paddle,
    enrollmentResult: enrollmentResult
  };
  var value$12 = value.slug;
  var value$13 = value$12.year;
  var value$14 = value$12.name;
  var value$15 = value$12.__typename;
  var slug = {
    __typename: value$15,
    name: value$14,
    year: value$13
  };
  var value$16 = value.sessions;
  var sessions = Js_array.map((function (value) {
          var value$1 = value.state;
          var state = serialize$2(value$1);
          var value$2 = value.scheduledOpeningDate;
          var value$3 = value.sessionId;
          var value$4 = value.title;
          var title = value$4 !== undefined ? value$4 : null;
          var value$5 = value.__typename;
          return {
                  __typename: value$5,
                  title: title,
                  sessionId: value$3,
                  scheduledOpeningDate: value$2,
                  state: state
                };
        }), value$16);
  var value$17 = value.location;
  var $$location;
  if (value$17 !== undefined) {
    var value$18 = value$17.displayLocation;
    var value$19 = value$18.name;
    var value$20 = value$18.__typename;
    var displayLocation = {
      __typename: value$20,
      name: value$19
    };
    var value$21 = value$17.name;
    var value$22 = value$17.__typename;
    $$location = {
      __typename: value$22,
      name: value$21,
      displayLocation: displayLocation
    };
  } else {
    $$location = null;
  }
  var value$23 = value.departmentNames;
  var departmentNames = Js_array.map((function (value) {
          return value;
        }), value$23);
  var value$24 = value.currency;
  var currency = value$24 !== undefined ? (
      typeof value$24 === "object" ? value$24.VAL : (
          value$24 === "ARS" ? "ARS" : (
              value$24 === "AUD" ? "AUD" : (
                  value$24 === "BRL" ? "BRL" : (
                      value$24 === "BTC" ? "BTC" : (
                          value$24 === "CAD" ? "CAD" : (
                              value$24 === "CHF" ? "CHF" : (
                                  value$24 === "CNY" ? "CNY" : (
                                      value$24 === "ETH" ? "ETH" : (
                                          value$24 === "EUR" ? "EUR" : (
                                              value$24 === "GBP" ? "GBP" : (
                                                  value$24 === "HKD" ? "HKD" : (
                                                      value$24 === "IDR" ? "IDR" : (
                                                          value$24 === "INR" ? "INR" : (
                                                              value$24 === "JPY" ? "JPY" : (
                                                                  value$24 === "KRW" ? "KRW" : (
                                                                      value$24 === "MXN" ? "MXN" : (
                                                                          value$24 === "PHP" ? "PHP" : (
                                                                              value$24 === "QAR" ? "QAR" : (
                                                                                  value$24 === "RUB" ? "RUB" : (
                                                                                      value$24 === "SAR" ? "SAR" : (
                                                                                          value$24 === "SGD" ? "SGD" : (
                                                                                              value$24 === "TWD" ? "TWD" : (
                                                                                                  value$24 === "USD" ? "USD" : "AED"
                                                                                                )
                                                                                            )
                                                                                        )
                                                                                    )
                                                                                )
                                                                            )
                                                                        )
                                                                    )
                                                                )
                                                            )
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            )
        )
    ) : null;
  var value$25 = value.hasOverview;
  var value$26 = value.hasConditionsOfSale;
  var value$27 = value.title;
  var title = value$27 !== undefined ? value$27 : null;
  var value$28 = value.sapSaleNumber;
  var sapSaleNumber = value$28 !== undefined ? value$28 : null;
  var value$29 = value.auctionId;
  var value$30 = value.id;
  var value$31 = value.__typename;
  return {
          __typename: value$31,
          id: value$30,
          auctionId: value$29,
          sapSaleNumber: sapSaleNumber,
          title: title,
          hasConditionsOfSale: value$26,
          hasOverview: value$25,
          currency: currency,
          departmentNames: departmentNames,
          location: $$location,
          sessions: sessions,
          slug: slug,
          enrollment: enrollment
        };
}

function verifyArgsAndParse$19(_AuctionHeaderAuctionFragment, value) {
  return parse$29(value);
}

function verifyName$19(param) {
  
}

var AuctionHeaderAuctionFragment = {
  Raw: Raw$29,
  query: query$29,
  parse: parse$29,
  serialize: serialize$29,
  verifyArgsAndParse: verifyArgsAndParse$19,
  verifyName: verifyName$19
};

var AuctionHeader = {
  SessionStateFragment: undefined,
  AuctionHeaderAuctionFragment: AuctionHeaderAuctionFragment
};

var Raw$30 = {};

var query$30 = ((frag_0, frag_1, frag_2, frag_3) => require("@apollo/client").gql`
  fragment LotOnDisplayLotFragment on LotV2   {
    __typename
    id
    lotId
    ...CurrentLotCardLotFragment
    ...LotDetailsLotFragment
    ...PlaceBidButtonLotFragment
    ...FeedLotMessageBoxFragment
  }
  ${frag_0}
  ${frag_1}
  ${frag_2}
  ${frag_3}
`)(query$16, query$22, query$15, query$27);

function parse$30(value) {
  return {
          __typename: value["__typename"],
          id: value["id"],
          lotId: value["lotId"],
          currentLotCardLotFragment: parse$16(value),
          lotDetailsLotFragment: parse$15(value),
          placeBidButtonLotFragment: parse$27(value),
          feedLotMessageBoxFragment: parse$22(value)
        };
}

function serialize$30(value) {
  var value$1 = value.lotId;
  var value$2 = value.id;
  var value$3 = value.__typename;
  return Js_array.reduce(GraphQL_PPX.deepMerge, {
              __typename: value$3,
              id: value$2,
              lotId: value$1
            }, [
              serialize$16(value.currentLotCardLotFragment),
              serialize$15(value.lotDetailsLotFragment),
              serialize$27(value.placeBidButtonLotFragment),
              serialize$22(value.feedLotMessageBoxFragment)
            ]);
}

function verifyArgsAndParse$20(_LotOnDisplayLotFragment, value) {
  return parse$30(value);
}

function verifyName$20(param) {
  
}

var LotOnDisplayLotFragment = {
  Raw: Raw$30,
  query: query$30,
  parse: parse$30,
  serialize: serialize$30,
  verifyArgsAndParse: verifyArgsAndParse$20,
  verifyName: verifyName$20
};

var Raw$31 = {};

var query$31 = ((frag_0) => require("@apollo/client").gql`
  query LotOnDisplayQuery($lotId: String!, $language: TranslationLanguage!)  {
    lotV2(lotId: $lotId, language: $language)  {
      __typename
      ...on LotV2   {
        ...LotOnDisplayLotFragment
      }
    }
  }
  ${frag_0}
`)(query$30);

function parse$31(value) {
  var value$1 = value.lotV2;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var typename = value$1["__typename"];
    var tmp$1 = typename === "LotV2" ? ({
          NAME: "LotV2",
          VAL: {
            lotOnDisplayLotFragment: parse$30(value$1)
          }
        }) : ({
          NAME: "UnspecifiedFragment",
          VAL: typename
        });
    tmp = tmp$1;
  }
  return {
          lotV2: tmp
        };
}

function serialize$31(value) {
  var value$1 = value.lotV2;
  var lotV2 = value$1 !== undefined ? (
      value$1.NAME === "UnspecifiedFragment" ? ({}) : Js_array.reduce(GraphQL_PPX.deepMerge, (function (prim) {
                return {};
              }), [serialize$30(value$1.VAL.lotOnDisplayLotFragment)])
    ) : null;
  return {
          lotV2: lotV2
        };
}

function serializeVariables$10(inp) {
  var a = inp.language;
  return {
          lotId: inp.lotId,
          language: a === "CHINESE_TRADITIONAL" ? "CHINESE_TRADITIONAL" : (
              a === "GERMAN" ? "GERMAN" : (
                  a === "FRENCH" ? "FRENCH" : (
                      a === "ENGLISH" ? "ENGLISH" : (
                          a === "ITALIAN" ? "ITALIAN" : "CHINESE_SIMPLIFIED"
                        )
                    )
                )
            )
        };
}

function makeVariables$10(lotId, language, param) {
  return {
          lotId: lotId,
          language: language
        };
}

var LotOnDisplayQuery_inner = {
  Raw: Raw$31,
  query: query$31,
  parse: parse$31,
  serialize: serialize$31,
  serializeVariables: serializeVariables$10,
  makeVariables: makeVariables$10
};

var include$10 = ApolloClient__React_Hooks_UseQuery.Extend({
      query: query$31,
      Raw: Raw$31,
      parse: parse$31,
      serialize: serialize$31,
      serializeVariables: serializeVariables$10
    });

var LotOnDisplayQuery_refetchQueryDescription = include$10.refetchQueryDescription;

var LotOnDisplayQuery_use = include$10.use;

var LotOnDisplayQuery_useLazy = include$10.useLazy;

var LotOnDisplayQuery_useLazyWithVariables = include$10.useLazyWithVariables;

var LotOnDisplayQuery = {
  LotOnDisplayQuery_inner: LotOnDisplayQuery_inner,
  Raw: Raw$31,
  query: query$31,
  parse: parse$31,
  serialize: serialize$31,
  serializeVariables: serializeVariables$10,
  makeVariables: makeVariables$10,
  refetchQueryDescription: LotOnDisplayQuery_refetchQueryDescription,
  use: LotOnDisplayQuery_use,
  useLazy: LotOnDisplayQuery_useLazy,
  useLazyWithVariables: LotOnDisplayQuery_useLazyWithVariables
};

var LotOnDisplay = {
  LotDetailsLotFragment: undefined,
  PlaceBidButtonLotFragment: undefined,
  FeedLotMessageBoxFragment: undefined,
  CurrentLotCardLotFragment: undefined,
  LotOnDisplayLotFragment: LotOnDisplayLotFragment,
  LotOnDisplayQuery: LotOnDisplayQuery
};

var Raw$32 = {};

var query$32 = (require("@apollo/client").gql`
  fragment WelcomeAuctionRoomModalFragment on Auction   {
    __typename
    auctionId
    title
    sapSaleNumber
  }
`);

function parse$32(value) {
  var value$1 = value.title;
  var value$2 = value.sapSaleNumber;
  return {
          __typename: value.__typename,
          auctionId: value.auctionId,
          title: !(value$1 == null) ? value$1 : undefined,
          sapSaleNumber: !(value$2 == null) ? value$2 : undefined
        };
}

function serialize$32(value) {
  var value$1 = value.sapSaleNumber;
  var sapSaleNumber = value$1 !== undefined ? value$1 : null;
  var value$2 = value.title;
  var title = value$2 !== undefined ? value$2 : null;
  var value$3 = value.auctionId;
  var value$4 = value.__typename;
  return {
          __typename: value$4,
          auctionId: value$3,
          title: title,
          sapSaleNumber: sapSaleNumber
        };
}

function verifyArgsAndParse$21(_WelcomeAuctionRoomModalFragment, value) {
  return parse$32(value);
}

function verifyName$21(param) {
  
}

var WelcomeAuctionRoomModalFragment = {
  Raw: Raw$32,
  query: query$32,
  parse: parse$32,
  serialize: serialize$32,
  verifyArgsAndParse: verifyArgsAndParse$21,
  verifyName: verifyName$21
};

var WelcomeAuctionRoomModal = {
  WelcomeAuctionRoomModalFragment: WelcomeAuctionRoomModalFragment
};

var Raw$33 = {};

var query$33 = (require("@apollo/client").gql`
  fragment AuctionBidCapFragment on BidCapConnection   {
    __typename
    id
    bidCap  {
      __typename
      amount
      amountInUse
      isCapReached
    }
  }
`);

function parse$33(value) {
  var value$1 = value.bidCap;
  return {
          __typename: value.__typename,
          id: value.id,
          bidCap: !(value$1 == null) ? ({
                __typename: value$1.__typename,
                amount: value$1.amount,
                amountInUse: value$1.amountInUse,
                isCapReached: value$1.isCapReached
              }) : undefined
        };
}

function serialize$33(value) {
  var value$1 = value.bidCap;
  var bidCap;
  if (value$1 !== undefined) {
    var value$2 = value$1.isCapReached;
    var value$3 = value$1.amountInUse;
    var value$4 = value$1.amount;
    var value$5 = value$1.__typename;
    bidCap = {
      __typename: value$5,
      amount: value$4,
      amountInUse: value$3,
      isCapReached: value$2
    };
  } else {
    bidCap = null;
  }
  var value$6 = value.id;
  var value$7 = value.__typename;
  return {
          __typename: value$7,
          id: value$6,
          bidCap: bidCap
        };
}

function verifyArgsAndParse$22(_AuctionBidCapFragment, value) {
  return parse$33(value);
}

function verifyName$22(param) {
  
}

var AuctionBidCapFragment = {
  Raw: Raw$33,
  query: query$33,
  parse: parse$33,
  serialize: serialize$33,
  verifyArgsAndParse: verifyArgsAndParse$22,
  verifyName: verifyName$22
};

var Raw$34 = {};

var query$34 = ((frag_0) => require("@apollo/client").gql`
  fragment AuctionCurrentLotFragment on CurrentLot   {
    __typename
    id
    lot  {
      ...CurrentLotCardLotFragment
    }
  }
  ${frag_0}
`)(query$16);

function parse$34(value) {
  var value$1 = value.lot;
  return {
          __typename: value.__typename,
          id: value.id,
          lot: !(value$1 == null) ? parse$16(value$1) : undefined
        };
}

function serialize$34(value) {
  var value$1 = value.lot;
  var lot = value$1 !== undefined ? serialize$16(value$1) : null;
  var value$2 = value.id;
  var value$3 = value.__typename;
  return {
          __typename: value$3,
          id: value$2,
          lot: lot
        };
}

function verifyArgsAndParse$23(_AuctionCurrentLotFragment, value) {
  return parse$34(value);
}

function verifyName$23(param) {
  
}

var AuctionCurrentLotFragment = {
  Raw: Raw$34,
  query: query$34,
  parse: parse$34,
  serialize: serialize$34,
  verifyArgsAndParse: verifyArgsAndParse$23,
  verifyName: verifyName$23
};

var Raw$35 = {};

var query$35 = (require("@apollo/client").gql`
  fragment AuctionBidPhaseFragment on AuctionBidPhaseConnection   {
    __typename
    id
    auctionBidPhase  {
      __typename
      ...on LiveAuctionBidPhaseType   {
        __typename
        liveBidPhase
      }
    }
  }
`);

function parse$35(value) {
  var value$1 = value.auctionBidPhase;
  var typename = value$1["__typename"];
  var tmp;
  if (typename === "LiveAuctionBidPhaseType") {
    var value$2 = value$1.liveBidPhase;
    var tmp$1;
    switch (value$2) {
      case "AcceptingBids" :
          tmp$1 = "AcceptingBids";
          break;
      case "Closed" :
          tmp$1 = "Closed";
          break;
      case "Live" :
          tmp$1 = "Live";
          break;
      case "NotAcceptingBidsYet" :
          tmp$1 = "NotAcceptingBidsYet";
          break;
      default:
        tmp$1 = {
          NAME: "FutureAddedValue",
          VAL: value$2
        };
    }
    tmp = {
      NAME: "LiveAuctionBidPhaseType",
      VAL: {
        __typename: value$1.__typename,
        liveBidPhase: tmp$1
      }
    };
  } else {
    tmp = {
      NAME: "FutureAddedValue",
      VAL: value$1
    };
  }
  return {
          __typename: value.__typename,
          id: value.id,
          auctionBidPhase: tmp
        };
}

function serialize$35(value) {
  var value$1 = value.auctionBidPhase;
  var auctionBidPhase;
  if (value$1.NAME === "LiveAuctionBidPhaseType") {
    var value$2 = value$1.VAL.liveBidPhase;
    var liveBidPhase = typeof value$2 === "object" ? value$2.VAL : (
        value$2 === "AcceptingBids" ? "AcceptingBids" : (
            value$2 === "NotAcceptingBidsYet" ? "NotAcceptingBidsYet" : (
                value$2 === "Live" ? "Live" : "Closed"
              )
          )
      );
    auctionBidPhase = {
      __typename: "LiveAuctionBidPhaseType",
      liveBidPhase: liveBidPhase
    };
  } else {
    auctionBidPhase = value$1.VAL;
  }
  var value$3 = value.id;
  var value$4 = value.__typename;
  return {
          __typename: value$4,
          id: value$3,
          auctionBidPhase: auctionBidPhase
        };
}

function verifyArgsAndParse$24(_AuctionBidPhaseFragment, value) {
  return parse$35(value);
}

function verifyName$24(param) {
  
}

var AuctionBidPhaseFragment = {
  Raw: Raw$35,
  query: query$35,
  parse: parse$35,
  serialize: serialize$35,
  verifyArgsAndParse: verifyArgsAndParse$24,
  verifyName: verifyName$24
};

var Raw$36 = {};

var query$36 = ((frag_0, frag_1, frag_2, frag_3, frag_4, frag_5, frag_6, frag_7, frag_8, frag_9, frag_10) => require("@apollo/client").gql`
  query AuctionBySlug($slug: AuctionSlugIdentifier!, $language: TranslationLanguage!)  {
    auctionBySlug(slug: $slug, language: $language)  {
      __typename
      id
      auctionId
      title
      sapSaleNumber
      type
      state
      slug  {
        __typename
        name
        year
      }
      testRecord
      bidPhase  {
        ...AuctionBidPhaseFragment
      }
      enrollment  {
        __typename
        bidCap  {
          ...AuctionBidCapFragment
        }
        result  {
          ...AuctionBaseEnrollmentResultFragment
        }
        restrictedDate
      }
      currency: currencyV2
      location: locationV2  {
        __typename
        name
        displayLocation  {
          __typename
          name
        }
      }
      sessions  {
        __typename
        state: stateV2  {
          ...SessionStateFragment
        }
        sessionId
        lotCards  {
          __typename
          lotId
        }
      }
      currentLot  {
        __typename
        ...AuctionCurrentLotFragment
        lot  {
          ...LotOnDisplayLotFragment
        }
      }
      ...AuctionHeaderAuctionFragment
      ...PlaceBidButtonAuctionFragment
      ...LotCardListAuctionFragment
      ...AuctionEnrollmentModalFragment
      ...WelcomeAuctionRoomModalFragment
    }
  }
  ${frag_0}
  ${frag_1}
  ${frag_2}
  ${frag_3}
  ${frag_4}
  ${frag_5}
  ${frag_6}
  ${frag_7}
  ${frag_8}
  ${frag_9}
  ${frag_10}
`)(query$23, query$33, query$35, query$34, query$9, query$29, query$7, query$30, query$26, query$2, query$32);

function parse$36(value) {
  var value$1 = value.auctionBySlug;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1["title"];
    var value$3 = value$1["sapSaleNumber"];
    var value$4 = value$1["type"];
    var tmp$1;
    switch (value$4) {
      case "Live" :
          tmp$1 = "Live";
          break;
      case "Timed" :
          tmp$1 = "Timed";
          break;
      default:
        tmp$1 = {
          NAME: "FutureAddedValue",
          VAL: value$4
        };
    }
    var value$5 = value$1["state"];
    var tmp$2;
    if (value$5 == null) {
      tmp$2 = undefined;
    } else {
      var tmp$3;
      switch (value$5) {
        case "Archived" :
            tmp$3 = "Archived";
            break;
        case "Closed" :
            tmp$3 = "Closed";
            break;
        case "Closing" :
            tmp$3 = "Closing";
            break;
        case "Live" :
            tmp$3 = "Live";
            break;
        case "Opened" :
            tmp$3 = "Opened";
            break;
        case "Paused" :
            tmp$3 = "Paused";
            break;
        case "Published" :
            tmp$3 = "Published";
            break;
        default:
          tmp$3 = {
            NAME: "FutureAddedValue",
            VAL: value$5
          };
      }
      tmp$2 = tmp$3;
    }
    var value$6 = value$1["slug"];
    var value$7 = value$1["enrollment"];
    var value$8 = value$7.result;
    var value$9 = value$7.restrictedDate;
    var value$10 = value$1["currency"];
    var tmp$4;
    if (value$10 == null) {
      tmp$4 = undefined;
    } else {
      var tmp$5;
      switch (value$10) {
        case "AED" :
            tmp$5 = "AED";
            break;
        case "ARS" :
            tmp$5 = "ARS";
            break;
        case "AUD" :
            tmp$5 = "AUD";
            break;
        case "BRL" :
            tmp$5 = "BRL";
            break;
        case "BTC" :
            tmp$5 = "BTC";
            break;
        case "CAD" :
            tmp$5 = "CAD";
            break;
        case "CHF" :
            tmp$5 = "CHF";
            break;
        case "CNY" :
            tmp$5 = "CNY";
            break;
        case "ETH" :
            tmp$5 = "ETH";
            break;
        case "EUR" :
            tmp$5 = "EUR";
            break;
        case "GBP" :
            tmp$5 = "GBP";
            break;
        case "HKD" :
            tmp$5 = "HKD";
            break;
        case "IDR" :
            tmp$5 = "IDR";
            break;
        case "INR" :
            tmp$5 = "INR";
            break;
        case "JPY" :
            tmp$5 = "JPY";
            break;
        case "KRW" :
            tmp$5 = "KRW";
            break;
        case "MXN" :
            tmp$5 = "MXN";
            break;
        case "PHP" :
            tmp$5 = "PHP";
            break;
        case "QAR" :
            tmp$5 = "QAR";
            break;
        case "RUB" :
            tmp$5 = "RUB";
            break;
        case "SAR" :
            tmp$5 = "SAR";
            break;
        case "SGD" :
            tmp$5 = "SGD";
            break;
        case "TWD" :
            tmp$5 = "TWD";
            break;
        case "USD" :
            tmp$5 = "USD";
            break;
        default:
          tmp$5 = {
            NAME: "FutureAddedValue",
            VAL: value$10
          };
      }
      tmp$4 = tmp$5;
    }
    var value$11 = value$1["location"];
    var tmp$6;
    if (value$11 == null) {
      tmp$6 = undefined;
    } else {
      var value$12 = value$11.displayLocation;
      tmp$6 = {
        __typename: value$11.__typename,
        name: value$11.name,
        displayLocation: {
          __typename: value$12.__typename,
          name: value$12.name
        }
      };
    }
    var value$13 = value$1["sessions"];
    var value$14 = value$1["currentLot"];
    var value$15 = value$14["lot"];
    tmp = {
      __typename: value$1["__typename"],
      id: value$1["id"],
      auctionId: value$1["auctionId"],
      title: !(value$2 == null) ? value$2 : undefined,
      sapSaleNumber: !(value$3 == null) ? value$3 : undefined,
      type: tmp$1,
      state: tmp$2,
      slug: {
        __typename: value$6.__typename,
        name: value$6.name,
        year: value$6.year
      },
      testRecord: value$1["testRecord"],
      bidPhase: parse$35(value$1["bidPhase"]),
      enrollment: {
        __typename: value$7.__typename,
        bidCap: parse$33(value$7.bidCap),
        result: !(value$8 == null) ? parse$23(value$8) : undefined,
        restrictedDate: !(value$9 == null) ? Caml_option.some(value$9) : undefined
      },
      currency: tmp$4,
      location: tmp$6,
      sessions: Js_array.map((function (value) {
              var value$1 = value.lotCards;
              return {
                      __typename: value.__typename,
                      state: parse$2(value.state),
                      sessionId: value.sessionId,
                      lotCards: !(value$1 == null) ? Js_array.map((function (value) {
                                return {
                                        __typename: value.__typename,
                                        lotId: value.lotId
                                      };
                              }), value$1) : undefined
                    };
            }), value$13),
      currentLot: {
        __typename: value$14["__typename"],
        auctionCurrentLotFragment: parse$34(value$14),
        lot: !(value$15 == null) ? parse$30(value$15) : undefined
      },
      auctionHeaderAuctionFragment: parse$29(value$1),
      placeBidButtonAuctionFragment: parse$26(value$1),
      lotCardListAuctionFragment: parse$7(value$1),
      auctionEnrollmentModalFragment: parse$9(value$1),
      welcomeAuctionRoomModalFragment: parse$32(value$1)
    };
  }
  return {
          auctionBySlug: tmp
        };
}

function serialize$36(value) {
  var value$1 = value.auctionBySlug;
  var auctionBySlug;
  if (value$1 !== undefined) {
    var value$2 = value$1.currentLot;
    var value$3 = value$2.lot;
    var lot = value$3 !== undefined ? serialize$30(value$3) : null;
    var value$4 = value$2.__typename;
    var currentLot = Js_array.reduce(GraphQL_PPX.deepMerge, {
          __typename: value$4,
          lot: lot
        }, [serialize$34(value$2.auctionCurrentLotFragment)]);
    var value$5 = value$1.sessions;
    var sessions = Js_array.map((function (value) {
            var value$1 = value.lotCards;
            var lotCards = value$1 !== undefined ? Js_array.map((function (value) {
                      var value$1 = value.lotId;
                      var value$2 = value.__typename;
                      return {
                              __typename: value$2,
                              lotId: value$1
                            };
                    }), value$1) : null;
            var value$2 = value.sessionId;
            var value$3 = value.state;
            var state = serialize$2(value$3);
            var value$4 = value.__typename;
            return {
                    __typename: value$4,
                    state: state,
                    sessionId: value$2,
                    lotCards: lotCards
                  };
          }), value$5);
    var value$6 = value$1.location;
    var $$location;
    if (value$6 !== undefined) {
      var value$7 = value$6.displayLocation;
      var value$8 = value$7.name;
      var value$9 = value$7.__typename;
      var displayLocation = {
        __typename: value$9,
        name: value$8
      };
      var value$10 = value$6.name;
      var value$11 = value$6.__typename;
      $$location = {
        __typename: value$11,
        name: value$10,
        displayLocation: displayLocation
      };
    } else {
      $$location = null;
    }
    var value$12 = value$1.currency;
    var currency = value$12 !== undefined ? (
        typeof value$12 === "object" ? value$12.VAL : (
            value$12 === "ARS" ? "ARS" : (
                value$12 === "AUD" ? "AUD" : (
                    value$12 === "BRL" ? "BRL" : (
                        value$12 === "BTC" ? "BTC" : (
                            value$12 === "CAD" ? "CAD" : (
                                value$12 === "CHF" ? "CHF" : (
                                    value$12 === "CNY" ? "CNY" : (
                                        value$12 === "ETH" ? "ETH" : (
                                            value$12 === "EUR" ? "EUR" : (
                                                value$12 === "GBP" ? "GBP" : (
                                                    value$12 === "HKD" ? "HKD" : (
                                                        value$12 === "IDR" ? "IDR" : (
                                                            value$12 === "INR" ? "INR" : (
                                                                value$12 === "JPY" ? "JPY" : (
                                                                    value$12 === "KRW" ? "KRW" : (
                                                                        value$12 === "MXN" ? "MXN" : (
                                                                            value$12 === "PHP" ? "PHP" : (
                                                                                value$12 === "QAR" ? "QAR" : (
                                                                                    value$12 === "RUB" ? "RUB" : (
                                                                                        value$12 === "SAR" ? "SAR" : (
                                                                                            value$12 === "SGD" ? "SGD" : (
                                                                                                value$12 === "TWD" ? "TWD" : (
                                                                                                    value$12 === "USD" ? "USD" : "AED"
                                                                                                  )
                                                                                              )
                                                                                          )
                                                                                      )
                                                                                  )
                                                                              )
                                                                          )
                                                                      )
                                                                  )
                                                              )
                                                          )
                                                      )
                                                  )
                                              )
                                          )
                                      )
                                  )
                              )
                          )
                      )
                  )
              )
          )
      ) : null;
    var value$13 = value$1.enrollment;
    var value$14 = value$13.restrictedDate;
    var restrictedDate = value$14 !== undefined ? Caml_option.valFromOption(value$14) : null;
    var value$15 = value$13.result;
    var result = value$15 !== undefined ? serialize$23(value$15) : null;
    var value$16 = value$13.bidCap;
    var bidCap = serialize$33(value$16);
    var value$17 = value$13.__typename;
    var enrollment = {
      __typename: value$17,
      bidCap: bidCap,
      result: result,
      restrictedDate: restrictedDate
    };
    var value$18 = value$1.bidPhase;
    var bidPhase = serialize$35(value$18);
    var value$19 = value$1.testRecord;
    var value$20 = value$1.slug;
    var value$21 = value$20.year;
    var value$22 = value$20.name;
    var value$23 = value$20.__typename;
    var slug = {
      __typename: value$23,
      name: value$22,
      year: value$21
    };
    var value$24 = value$1.state;
    var state = value$24 !== undefined ? (
        typeof value$24 === "object" ? value$24.VAL : (
            value$24 === "Closing" ? "Closing" : (
                value$24 === "Archived" ? "Archived" : (
                    value$24 === "Opened" ? "Opened" : (
                        value$24 === "Published" ? "Published" : (
                            value$24 === "Paused" ? "Paused" : (
                                value$24 === "Live" ? "Live" : "Closed"
                              )
                          )
                      )
                  )
              )
          )
      ) : null;
    var value$25 = value$1.type;
    var type_ = typeof value$25 === "object" ? value$25.VAL : (
        value$25 === "Live" ? "Live" : "Timed"
      );
    var value$26 = value$1.sapSaleNumber;
    var sapSaleNumber = value$26 !== undefined ? value$26 : null;
    var value$27 = value$1.title;
    var title = value$27 !== undefined ? value$27 : null;
    var value$28 = value$1.auctionId;
    var value$29 = value$1.id;
    var value$30 = value$1.__typename;
    auctionBySlug = Js_array.reduce(GraphQL_PPX.deepMerge, {
          __typename: value$30,
          id: value$29,
          auctionId: value$28,
          title: title,
          sapSaleNumber: sapSaleNumber,
          type_: type_,
          state: state,
          slug: slug,
          testRecord: value$19,
          bidPhase: bidPhase,
          enrollment: enrollment,
          currency: currency,
          location: $$location,
          sessions: sessions,
          currentLot: currentLot
        }, [
          serialize$29(value$1.auctionHeaderAuctionFragment),
          serialize$26(value$1.placeBidButtonAuctionFragment),
          serialize$7(value$1.lotCardListAuctionFragment),
          serialize$9(value$1.auctionEnrollmentModalFragment),
          serialize$32(value$1.welcomeAuctionRoomModalFragment)
        ]);
  } else {
    auctionBySlug = null;
  }
  return {
          auctionBySlug: auctionBySlug
        };
}

function serializeInputObjectAuctionSlugIdentifier(inp) {
  return {
          name: inp.name,
          year: inp.year
        };
}

function serializeVariables$11(inp) {
  var a = inp.language;
  return {
          slug: serializeInputObjectAuctionSlugIdentifier(inp.slug),
          language: a === "CHINESE_TRADITIONAL" ? "CHINESE_TRADITIONAL" : (
              a === "GERMAN" ? "GERMAN" : (
                  a === "FRENCH" ? "FRENCH" : (
                      a === "ENGLISH" ? "ENGLISH" : (
                          a === "ITALIAN" ? "ITALIAN" : "CHINESE_SIMPLIFIED"
                        )
                    )
                )
            )
        };
}

function makeVariables$11(slug, language, param) {
  return {
          slug: slug,
          language: language
        };
}

function makeInputObjectAuctionSlugIdentifier(name, year, param) {
  return {
          name: name,
          year: year
        };
}

var AuctionBySlug_inner = {
  Raw: Raw$36,
  query: query$36,
  parse: parse$36,
  serialize: serialize$36,
  serializeVariables: serializeVariables$11,
  serializeInputObjectAuctionSlugIdentifier: serializeInputObjectAuctionSlugIdentifier,
  makeVariables: makeVariables$11,
  makeInputObjectAuctionSlugIdentifier: makeInputObjectAuctionSlugIdentifier
};

var include$11 = ApolloClient__React_Hooks_UseQuery.Extend({
      query: query$36,
      Raw: Raw$36,
      parse: parse$36,
      serialize: serialize$36,
      serializeVariables: serializeVariables$11
    });

var AuctionBySlug_refetchQueryDescription = include$11.refetchQueryDescription;

var AuctionBySlug_use = include$11.use;

var AuctionBySlug_useLazy = include$11.useLazy;

var AuctionBySlug_useLazyWithVariables = include$11.useLazyWithVariables;

var AuctionBySlug = {
  AuctionBySlug_inner: AuctionBySlug_inner,
  Raw: Raw$36,
  query: query$36,
  parse: parse$36,
  serialize: serialize$36,
  serializeVariables: serializeVariables$11,
  serializeInputObjectAuctionSlugIdentifier: serializeInputObjectAuctionSlugIdentifier,
  makeVariables: makeVariables$11,
  makeInputObjectAuctionSlugIdentifier: makeInputObjectAuctionSlugIdentifier,
  refetchQueryDescription: AuctionBySlug_refetchQueryDescription,
  use: AuctionBySlug_use,
  useLazy: AuctionBySlug_useLazy,
  useLazyWithVariables: AuctionBySlug_useLazyWithVariables
};

var Auction = {
  LotCardListAuctionFragment: undefined,
  LotCardFragment: undefined,
  LotOnDisplayLotFragment: undefined,
  PlaceBidButtonAuctionFragment: undefined,
  AuctionHeaderAuctionFragment: undefined,
  CurrentLotCardLotFragment: undefined,
  AuctionEnrollmentModalFragment: undefined,
  WelcomeAuctionRoomModalFragment: undefined,
  SessionStateFragment: undefined,
  AuctionBaseEnrollmentResultFragment: undefined,
  AuctionBidCapFragment: AuctionBidCapFragment,
  AuctionCurrentLotFragment: AuctionCurrentLotFragment,
  AuctionBidPhaseFragment: AuctionBidPhaseFragment,
  AuctionBySlug: AuctionBySlug
};

var Raw$37 = {};

var query$37 = (require("@apollo/client").gql`
  query AuctionAutochargeConfig($auctionId: String!)  {
    auctionAutochargeConfig(auctionId: $auctionId)  {
      __typename
      eligibleForAutocharge
    }
  }
`);

function parse$37(value) {
  var value$1 = value.auctionAutochargeConfig;
  return {
          auctionAutochargeConfig: {
            __typename: value$1.__typename,
            eligibleForAutocharge: value$1.eligibleForAutocharge
          }
        };
}

function serialize$37(value) {
  var value$1 = value.auctionAutochargeConfig;
  var value$2 = value$1.eligibleForAutocharge;
  var value$3 = value$1.__typename;
  var auctionAutochargeConfig = {
    __typename: value$3,
    eligibleForAutocharge: value$2
  };
  return {
          auctionAutochargeConfig: auctionAutochargeConfig
        };
}

function serializeVariables$12(inp) {
  return {
          auctionId: inp.auctionId
        };
}

function makeVariables$12(auctionId, param) {
  return {
          auctionId: auctionId
        };
}

var AuctionAutochargeConfig_inner = {
  Raw: Raw$37,
  query: query$37,
  parse: parse$37,
  serialize: serialize$37,
  serializeVariables: serializeVariables$12,
  makeVariables: makeVariables$12
};

var include$12 = ApolloClient__React_Hooks_UseQuery.Extend({
      query: query$37,
      Raw: Raw$37,
      parse: parse$37,
      serialize: serialize$37,
      serializeVariables: serializeVariables$12
    });

var AuctionAutochargeConfig_refetchQueryDescription = include$12.refetchQueryDescription;

var AuctionAutochargeConfig_use = include$12.use;

var AuctionAutochargeConfig_useLazy = include$12.useLazy;

var AuctionAutochargeConfig_useLazyWithVariables = include$12.useLazyWithVariables;

var AuctionAutochargeConfig = {
  AuctionAutochargeConfig_inner: AuctionAutochargeConfig_inner,
  Raw: Raw$37,
  query: query$37,
  parse: parse$37,
  serialize: serialize$37,
  serializeVariables: serializeVariables$12,
  makeVariables: makeVariables$12,
  refetchQueryDescription: AuctionAutochargeConfig_refetchQueryDescription,
  use: AuctionAutochargeConfig_use,
  useLazy: AuctionAutochargeConfig_useLazy,
  useLazyWithVariables: AuctionAutochargeConfig_useLazyWithVariables
};

var Raw$38 = {};

var query$38 = (require("@apollo/client").gql`
  query AutochargePaymentMethodQuery($accountId: String!, $saleLocation: SaleLocation!)  {
    addAutoChargePaymentMethodRequired(accountId: $accountId, saleLocation: $saleLocation)  {
      __typename
      required
    }
  }
`);

function parse$38(value) {
  var value$1 = value.addAutoChargePaymentMethodRequired;
  return {
          addAutoChargePaymentMethodRequired: {
            __typename: value$1.__typename,
            required: value$1.required
          }
        };
}

function serialize$38(value) {
  var value$1 = value.addAutoChargePaymentMethodRequired;
  var value$2 = value$1.required;
  var value$3 = value$1.__typename;
  var addAutoChargePaymentMethodRequired = {
    __typename: value$3,
    required: value$2
  };
  return {
          addAutoChargePaymentMethodRequired: addAutoChargePaymentMethodRequired
        };
}

function serializeVariables$13(inp) {
  var a = inp.saleLocation;
  return {
          accountId: inp.accountId,
          saleLocation: a === "NEW_JERSEY" ? "NEW_JERSEY" : (
              a === "NEW_YORK" ? "NEW_YORK" : (
                  a === "DUBAI" ? "DUBAI" : (
                      a === "SINGAPORE" ? "SINGAPORE" : (
                          a === "MUMBAI" ? "MUMBAI" : (
                              a === "HONG_KONG" ? "HONG_KONG" : (
                                  a === "COLOGNE" ? "COLOGNE" : (
                                      a === "MILAN" ? "MILAN" : (
                                          a === "BEIJING" ? "BEIJING" : (
                                              a === "RIYADH" ? "RIYADH" : (
                                                  a === "LONDON" ? "LONDON" : (
                                                      a === "SHANGHAI_MARK_AND_PVT" ? "SHANGHAI_MARK_AND_PVT" : (
                                                          a === "ZURICH" ? "ZURICH" : (
                                                              a === "DOHA" ? "DOHA" : (
                                                                  a === "SHANGHAI_AUCTION" ? "SHANGHAI_AUCTION" : (
                                                                      a === "PARIS" ? "PARIS" : "GENEVA"
                                                                    )
                                                                )
                                                            )
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            )
        };
}

function makeVariables$13(accountId, saleLocation, param) {
  return {
          accountId: accountId,
          saleLocation: saleLocation
        };
}

var AutochargePaymentMethodQuery_inner = {
  Raw: Raw$38,
  query: query$38,
  parse: parse$38,
  serialize: serialize$38,
  serializeVariables: serializeVariables$13,
  makeVariables: makeVariables$13
};

var include$13 = ApolloClient__React_Hooks_UseQuery.Extend({
      query: query$38,
      Raw: Raw$38,
      parse: parse$38,
      serialize: serialize$38,
      serializeVariables: serializeVariables$13
    });

var AutochargePaymentMethodQuery_refetchQueryDescription = include$13.refetchQueryDescription;

var AutochargePaymentMethodQuery_use = include$13.use;

var AutochargePaymentMethodQuery_useLazy = include$13.useLazy;

var AutochargePaymentMethodQuery_useLazyWithVariables = include$13.useLazyWithVariables;

var AutochargePaymentMethodQuery = {
  AutochargePaymentMethodQuery_inner: AutochargePaymentMethodQuery_inner,
  Raw: Raw$38,
  query: query$38,
  parse: parse$38,
  serialize: serialize$38,
  serializeVariables: serializeVariables$13,
  makeVariables: makeVariables$13,
  refetchQueryDescription: AutochargePaymentMethodQuery_refetchQueryDescription,
  use: AutochargePaymentMethodQuery_use,
  useLazy: AutochargePaymentMethodQuery_useLazy,
  useLazyWithVariables: AutochargePaymentMethodQuery_useLazyWithVariables
};

var Autocharge = {
  AuctionAutochargeConfig: AuctionAutochargeConfig,
  AutochargePaymentMethodQuery: AutochargePaymentMethodQuery
};

var Raw$39 = {};

var query$39 = ((frag_0, frag_1) => require("@apollo/client").gql`
  subscription BidStateByAuctionId($id: String!)  {
    bidStateByAuctionId(id: $id)  {
      __typename
      ...BidStateFragment
      ...PlaceBidBidStateFragment
    }
  }
  ${frag_0}
  ${frag_1}
`)(query$4, query$25);

function parse$39(value) {
  var value$1 = value.bidStateByAuctionId;
  return {
          bidStateByAuctionId: {
            __typename: value$1["__typename"],
            bidStateFragment: parse$4(value$1),
            placeBidBidStateFragment: parse$25(value$1)
          }
        };
}

function serialize$39(value) {
  var value$1 = value.bidStateByAuctionId;
  var bidStateByAuctionId = Js_array.reduce(GraphQL_PPX.deepMerge, {
        __typename: value$1.__typename
      }, [
        serialize$4(value$1.bidStateFragment),
        serialize$25(value$1.placeBidBidStateFragment)
      ]);
  return {
          bidStateByAuctionId: bidStateByAuctionId
        };
}

function serializeVariables$14(inp) {
  return {
          id: inp.id
        };
}

function makeVariables$14(id, param) {
  return {
          id: id
        };
}

var BidStateByAuctionId_inner = {
  Raw: Raw$39,
  query: query$39,
  parse: parse$39,
  serialize: serialize$39,
  serializeVariables: serializeVariables$14,
  makeVariables: makeVariables$14
};

var include$14 = ApolloClient__React_Hooks_UseSubscription.Extend({
      query: query$39,
      Raw: Raw$39,
      parse: parse$39,
      serialize: serialize$39,
      serializeVariables: serializeVariables$14
    });

var BidStateByAuctionId_use = include$14.use;

var BidStateByAuctionId = {
  BidStateByAuctionId_inner: BidStateByAuctionId_inner,
  Raw: Raw$39,
  query: query$39,
  parse: parse$39,
  serialize: serialize$39,
  serializeVariables: serializeVariables$14,
  makeVariables: makeVariables$14,
  use: BidStateByAuctionId_use
};

var Raw$40 = {};

var query$40 = ((frag_0, frag_1) => require("@apollo/client").gql`
  subscription LatestBidByAuctionId($auctionId: String!)  {
    latestBidByAuctionId(auctionId: $auctionId)  {
      __typename
      ...LatestUserBid
      ...PlaceBidUserBidConnectionFragment
    }
  }
  ${frag_0}
  ${frag_1}
`)(query$3, query$24);

function parse$40(value) {
  var value$1 = value.latestBidByAuctionId;
  return {
          latestBidByAuctionId: {
            __typename: value$1["__typename"],
            latestUserBid: parse$3(value$1),
            placeBidUserBidConnectionFragment: parse$24(value$1)
          }
        };
}

function serialize$40(value) {
  var value$1 = value.latestBidByAuctionId;
  var latestBidByAuctionId = Js_array.reduce(GraphQL_PPX.deepMerge, {
        __typename: value$1.__typename
      }, [
        serialize$3(value$1.latestUserBid),
        serialize$24(value$1.placeBidUserBidConnectionFragment)
      ]);
  return {
          latestBidByAuctionId: latestBidByAuctionId
        };
}

function serializeVariables$15(inp) {
  return {
          auctionId: inp.auctionId
        };
}

function makeVariables$15(auctionId, param) {
  return {
          auctionId: auctionId
        };
}

var LatestBidByAuctionId_inner = {
  Raw: Raw$40,
  query: query$40,
  parse: parse$40,
  serialize: serialize$40,
  serializeVariables: serializeVariables$15,
  makeVariables: makeVariables$15
};

var include$15 = ApolloClient__React_Hooks_UseSubscription.Extend({
      query: query$40,
      Raw: Raw$40,
      parse: parse$40,
      serialize: serialize$40,
      serializeVariables: serializeVariables$15
    });

var LatestBidByAuctionId_use = include$15.use;

var LatestBidByAuctionId = {
  LatestBidByAuctionId_inner: LatestBidByAuctionId_inner,
  Raw: Raw$40,
  query: query$40,
  parse: parse$40,
  serialize: serialize$40,
  serializeVariables: serializeVariables$15,
  makeVariables: makeVariables$15,
  use: LatestBidByAuctionId_use
};

var Raw$41 = {};

var query$41 = ((frag_0) => require("@apollo/client").gql`
  subscription SessionStateByAuction($auctionId: String!)  {
    sessionStateByAuction(auctionId: $auctionId)  {
      ...SessionStateFragment
    }
  }
  ${frag_0}
`)(query$2);

function parse$41(value) {
  return {
          sessionStateByAuction: parse$2(value.sessionStateByAuction)
        };
}

function serialize$41(value) {
  var value$1 = value.sessionStateByAuction;
  var sessionStateByAuction = serialize$2(value$1);
  return {
          sessionStateByAuction: sessionStateByAuction
        };
}

function serializeVariables$16(inp) {
  return {
          auctionId: inp.auctionId
        };
}

function makeVariables$16(auctionId, param) {
  return {
          auctionId: auctionId
        };
}

var SessionStateByAuction_inner = {
  Raw: Raw$41,
  query: query$41,
  parse: parse$41,
  serialize: serialize$41,
  serializeVariables: serializeVariables$16,
  makeVariables: makeVariables$16
};

var include$16 = ApolloClient__React_Hooks_UseSubscription.Extend({
      query: query$41,
      Raw: Raw$41,
      parse: parse$41,
      serialize: serialize$41,
      serializeVariables: serializeVariables$16
    });

var SessionStateByAuction_use = include$16.use;

var SessionStateByAuction = {
  SessionStateByAuction_inner: SessionStateByAuction_inner,
  Raw: Raw$41,
  query: query$41,
  parse: parse$41,
  serialize: serialize$41,
  serializeVariables: serializeVariables$16,
  makeVariables: makeVariables$16,
  use: SessionStateByAuction_use
};

var Raw$42 = {};

var query$42 = ((frag_0) => require("@apollo/client").gql`
  subscription BidCapByAuctionId($auctionId: String!)  {
    bidCapByAuctionId(auctionId: $auctionId)  {
      ...AuctionBidCapFragment
    }
  }
  ${frag_0}
`)(query$33);

function parse$42(value) {
  return {
          bidCapByAuctionId: parse$33(value.bidCapByAuctionId)
        };
}

function serialize$42(value) {
  var value$1 = value.bidCapByAuctionId;
  var bidCapByAuctionId = serialize$33(value$1);
  return {
          bidCapByAuctionId: bidCapByAuctionId
        };
}

function serializeVariables$17(inp) {
  return {
          auctionId: inp.auctionId
        };
}

function makeVariables$17(auctionId, param) {
  return {
          auctionId: auctionId
        };
}

var BidCapByAuctionId_inner = {
  Raw: Raw$42,
  query: query$42,
  parse: parse$42,
  serialize: serialize$42,
  serializeVariables: serializeVariables$17,
  makeVariables: makeVariables$17
};

var include$17 = ApolloClient__React_Hooks_UseSubscription.Extend({
      query: query$42,
      Raw: Raw$42,
      parse: parse$42,
      serialize: serialize$42,
      serializeVariables: serializeVariables$17
    });

var BidCapByAuctionId_use = include$17.use;

var BidCapByAuctionId = {
  BidCapByAuctionId_inner: BidCapByAuctionId_inner,
  Raw: Raw$42,
  query: query$42,
  parse: parse$42,
  serialize: serialize$42,
  serializeVariables: serializeVariables$17,
  makeVariables: makeVariables$17,
  use: BidCapByAuctionId_use
};

var Raw$43 = {};

var query$43 = ((frag_0) => require("@apollo/client").gql`
  subscription CurrentLotForAuction($auctionId: String!)  {
    currentLotForAuction(auctionId: $auctionId)  {
      ...AuctionCurrentLotFragment
    }
  }
  ${frag_0}
`)(query$34);

function parse$43(value) {
  var value$1 = value.currentLotForAuction;
  return {
          currentLotForAuction: !(value$1 == null) ? parse$34(value$1) : undefined
        };
}

function serialize$43(value) {
  var value$1 = value.currentLotForAuction;
  var currentLotForAuction = value$1 !== undefined ? serialize$34(value$1) : null;
  return {
          currentLotForAuction: currentLotForAuction
        };
}

function serializeVariables$18(inp) {
  return {
          auctionId: inp.auctionId
        };
}

function makeVariables$18(auctionId, param) {
  return {
          auctionId: auctionId
        };
}

var CurrentLotForAuction_inner = {
  Raw: Raw$43,
  query: query$43,
  parse: parse$43,
  serialize: serialize$43,
  serializeVariables: serializeVariables$18,
  makeVariables: makeVariables$18
};

var include$18 = ApolloClient__React_Hooks_UseSubscription.Extend({
      query: query$43,
      Raw: Raw$43,
      parse: parse$43,
      serialize: serialize$43,
      serializeVariables: serializeVariables$18
    });

var CurrentLotForAuction_use = include$18.use;

var CurrentLotForAuction = {
  CurrentLotForAuction_inner: CurrentLotForAuction_inner,
  Raw: Raw$43,
  query: query$43,
  parse: parse$43,
  serialize: serialize$43,
  serializeVariables: serializeVariables$18,
  makeVariables: makeVariables$18,
  use: CurrentLotForAuction_use
};

var Raw$44 = {};

var query$44 = ((frag_0) => require("@apollo/client").gql`
  subscription AuctionBidPhaseByAuctionId($auctionId: String!)  {
    auctionBidPhaseByAuctionId(auctionId: $auctionId)  {
      ...AuctionBidPhaseFragment
    }
  }
  ${frag_0}
`)(query$35);

function parse$44(value) {
  return {
          auctionBidPhaseByAuctionId: parse$35(value.auctionBidPhaseByAuctionId)
        };
}

function serialize$44(value) {
  var value$1 = value.auctionBidPhaseByAuctionId;
  var auctionBidPhaseByAuctionId = serialize$35(value$1);
  return {
          auctionBidPhaseByAuctionId: auctionBidPhaseByAuctionId
        };
}

function serializeVariables$19(inp) {
  return {
          auctionId: inp.auctionId
        };
}

function makeVariables$19(auctionId, param) {
  return {
          auctionId: auctionId
        };
}

var AuctionBidPhaseByAuctionId_inner = {
  Raw: Raw$44,
  query: query$44,
  parse: parse$44,
  serialize: serialize$44,
  serializeVariables: serializeVariables$19,
  makeVariables: makeVariables$19
};

var include$19 = ApolloClient__React_Hooks_UseSubscription.Extend({
      query: query$44,
      Raw: Raw$44,
      parse: parse$44,
      serialize: serialize$44,
      serializeVariables: serializeVariables$19
    });

var AuctionBidPhaseByAuctionId_use = include$19.use;

var AuctionBidPhaseByAuctionId = {
  AuctionBidPhaseByAuctionId_inner: AuctionBidPhaseByAuctionId_inner,
  Raw: Raw$44,
  query: query$44,
  parse: parse$44,
  serialize: serialize$44,
  serializeVariables: serializeVariables$19,
  makeVariables: makeVariables$19,
  use: AuctionBidPhaseByAuctionId_use
};

var Raw$45 = {};

var query$45 = ((frag_0) => require("@apollo/client").gql`
  subscription EnrollmentResultByAuctionId($auctionId: String!)  {
    enrollmentResultByAuctionId(auctionId: $auctionId)  {
      ...AuctionBaseEnrollmentResultFragment
    }
  }
  ${frag_0}
`)(query$23);

function parse$45(value) {
  return {
          enrollmentResultByAuctionId: parse$23(value.enrollmentResultByAuctionId)
        };
}

function serialize$45(value) {
  var value$1 = value.enrollmentResultByAuctionId;
  var enrollmentResultByAuctionId = serialize$23(value$1);
  return {
          enrollmentResultByAuctionId: enrollmentResultByAuctionId
        };
}

function serializeVariables$20(inp) {
  return {
          auctionId: inp.auctionId
        };
}

function makeVariables$20(auctionId, param) {
  return {
          auctionId: auctionId
        };
}

var EnrollmentResultByAuctionId_inner = {
  Raw: Raw$45,
  query: query$45,
  parse: parse$45,
  serialize: serialize$45,
  serializeVariables: serializeVariables$20,
  makeVariables: makeVariables$20
};

var include$20 = ApolloClient__React_Hooks_UseSubscription.Extend({
      query: query$45,
      Raw: Raw$45,
      parse: parse$45,
      serialize: serialize$45,
      serializeVariables: serializeVariables$20
    });

var EnrollmentResultByAuctionId_use = include$20.use;

var EnrollmentResultByAuctionId = {
  EnrollmentResultByAuctionId_inner: EnrollmentResultByAuctionId_inner,
  Raw: Raw$45,
  query: query$45,
  parse: parse$45,
  serialize: serialize$45,
  serializeVariables: serializeVariables$20,
  makeVariables: makeVariables$20,
  use: EnrollmentResultByAuctionId_use
};

var Raw$46 = {};

var query$46 = ((frag_0) => require("@apollo/client").gql`
  subscription PremiumLotStateForAuction($auctionId: String!)  {
    premiumLotStateForAuction(auctionId: $auctionId)  {
      ...PremiumLotStateFragment
    }
  }
  ${frag_0}
`)(query$1);

function parse$46(value) {
  return {
          premiumLotStateForAuction: parse$1(value.premiumLotStateForAuction)
        };
}

function serialize$46(value) {
  var value$1 = value.premiumLotStateForAuction;
  var premiumLotStateForAuction = serialize$1(value$1);
  return {
          premiumLotStateForAuction: premiumLotStateForAuction
        };
}

function serializeVariables$21(inp) {
  return {
          auctionId: inp.auctionId
        };
}

function makeVariables$21(auctionId, param) {
  return {
          auctionId: auctionId
        };
}

var PremiumLotStateForAuction_inner = {
  Raw: Raw$46,
  query: query$46,
  parse: parse$46,
  serialize: serialize$46,
  serializeVariables: serializeVariables$21,
  makeVariables: makeVariables$21
};

var include$21 = ApolloClient__React_Hooks_UseSubscription.Extend({
      query: query$46,
      Raw: Raw$46,
      parse: parse$46,
      serialize: serialize$46,
      serializeVariables: serializeVariables$21
    });

var PremiumLotStateForAuction_use = include$21.use;

var PremiumLotStateForAuction = {
  PremiumLotStateForAuction_inner: PremiumLotStateForAuction_inner,
  Raw: Raw$46,
  query: query$46,
  parse: parse$46,
  serialize: serialize$46,
  serializeVariables: serializeVariables$21,
  makeVariables: makeVariables$21,
  use: PremiumLotStateForAuction_use
};

var Subscriptions = {
  BidStateFragment: undefined,
  LatestUserBid: undefined,
  PlaceBidUserBidConnectionFragment: undefined,
  PlaceBidBidStateFragment: undefined,
  AuctionBidCapFragment: undefined,
  AuctionCurrentLotFragment: undefined,
  AuctionBidPhaseFragment: undefined,
  AuctionBaseEnrollmentResultFragment: undefined,
  PremiumLotStateFragment: undefined,
  SessionStateFragment: undefined,
  BidStateByAuctionId: BidStateByAuctionId,
  LatestBidByAuctionId: LatestBidByAuctionId,
  SessionStateByAuction: SessionStateByAuction,
  BidCapByAuctionId: BidCapByAuctionId,
  CurrentLotForAuction: CurrentLotForAuction,
  AuctionBidPhaseByAuctionId: AuctionBidPhaseByAuctionId,
  EnrollmentResultByAuctionId: EnrollmentResultByAuctionId,
  PremiumLotStateForAuction: PremiumLotStateForAuction
};

var Raw$47 = {};

var query$47 = (require("@apollo/client").gql`
  query PartyAccountsQuery  {
    me  {
      __typename
      status  {
        __typename
        ...on TransactionalUserStatus   {
          __typename
          activeAccounts
        }
      }
      partyAccounts  {
        __typename
        accountId
        role
        accountStatus
        legacyAccountNumber
        accountHolder  {
          __typename
          name
        }
        accountType
        addresses  {
          __typename
          addressLine1
          addressLine2
          addressLine3
          postalCode
          city
          regionCode
          associationType
          country  {
            __typename
            name
            code
          }
        }
        shippingPreferences  {
          __typename
          accountId
          location
          address  {
            __typename
            addressLine1
            addressLine2
            addressLine3
            postalCode
            city
            regionCode
            country  {
              __typename
              name
              code
            }
          }
        }
      }
    }
  }
`);

function parse$47(value) {
  var value$1 = value.me;
  var value$2 = value$1.status;
  var typename = value$2["__typename"];
  var tmp;
  if (typename === "TransactionalUserStatus") {
    var value$3 = value$2.activeAccounts;
    tmp = {
      NAME: "TransactionalUserStatus",
      VAL: {
        __typename: value$2.__typename,
        activeAccounts: Js_array.map((function (value) {
                return value;
              }), value$3)
      }
    };
  } else {
    tmp = {
      NAME: "FutureAddedValue",
      VAL: value$2
    };
  }
  var value$4 = value$1.partyAccounts;
  return {
          me: {
            __typename: value$1.__typename,
            status: tmp,
            partyAccounts: Js_array.map((function (value) {
                    var value$1 = value.accountId;
                    var value$2 = value.role;
                    var value$3 = value.accountStatus;
                    var value$4 = value.legacyAccountNumber;
                    var value$5 = value.accountHolder;
                    var tmp;
                    if (value$5 == null) {
                      tmp = undefined;
                    } else {
                      var value$6 = value$5.name;
                      tmp = {
                        __typename: value$5.__typename,
                        name: !(value$6 == null) ? value$6 : undefined
                      };
                    }
                    var value$7 = value.accountType;
                    var value$8 = value.addresses;
                    var value$9 = value.shippingPreferences;
                    return {
                            __typename: value.__typename,
                            accountId: !(value$1 == null) ? value$1 : undefined,
                            role: !(value$2 == null) ? value$2 : undefined,
                            accountStatus: !(value$3 == null) ? value$3 : undefined,
                            legacyAccountNumber: !(value$4 == null) ? value$4 : undefined,
                            accountHolder: tmp,
                            accountType: !(value$7 == null) ? value$7 : undefined,
                            addresses: !(value$8 == null) ? Js_array.map((function (value) {
                                      if (value == null) {
                                        return ;
                                      }
                                      var value$1 = value.addressLine1;
                                      var value$2 = value.addressLine2;
                                      var value$3 = value.addressLine3;
                                      var value$4 = value.postalCode;
                                      var value$5 = value.city;
                                      var value$6 = value.regionCode;
                                      var value$7 = value.associationType;
                                      var tmp;
                                      if (value$7 == null) {
                                        tmp = undefined;
                                      } else {
                                        var tmp$1;
                                        switch (value$7) {
                                          case "APPRAISAL_VALUATION" :
                                              tmp$1 = "APPRAISAL_VALUATION";
                                              break;
                                          case "BUYER" :
                                              tmp$1 = "BUYER";
                                              break;
                                          case "COPY" :
                                              tmp$1 = "COPY";
                                              break;
                                          case "MAIN" :
                                              tmp$1 = "MAIN";
                                              break;
                                          case "PROMOTIONAL_MAIL" :
                                              tmp$1 = "PROMOTIONAL_MAIL";
                                              break;
                                          case "SELLER" :
                                              tmp$1 = "SELLER";
                                              break;
                                          case "SHIP_TO" :
                                              tmp$1 = "SHIP_TO";
                                              break;
                                          case "SUBSCRIPTION" :
                                              tmp$1 = "SUBSCRIPTION";
                                              break;
                                          default:
                                            tmp$1 = {
                                              NAME: "FutureAddedValue",
                                              VAL: value$7
                                            };
                                        }
                                        tmp = tmp$1;
                                      }
                                      var value$8 = value.country;
                                      var tmp$2;
                                      if (value$8 == null) {
                                        tmp$2 = undefined;
                                      } else {
                                        var value$9 = value$8.name;
                                        var value$10 = value$8.code;
                                        tmp$2 = {
                                          __typename: value$8.__typename,
                                          name: !(value$9 == null) ? value$9 : undefined,
                                          code: !(value$10 == null) ? value$10 : undefined
                                        };
                                      }
                                      return {
                                              __typename: value.__typename,
                                              addressLine1: !(value$1 == null) ? value$1 : undefined,
                                              addressLine2: !(value$2 == null) ? value$2 : undefined,
                                              addressLine3: !(value$3 == null) ? value$3 : undefined,
                                              postalCode: !(value$4 == null) ? value$4 : undefined,
                                              city: !(value$5 == null) ? value$5 : undefined,
                                              regionCode: !(value$6 == null) ? value$6 : undefined,
                                              associationType: tmp,
                                              country: tmp$2
                                            };
                                    }), value$8) : undefined,
                            shippingPreferences: !(value$9 == null) ? Js_array.map((function (value) {
                                      if (value == null) {
                                        return ;
                                      }
                                      var value$1 = value.location;
                                      var tmp;
                                      if (value$1 == null) {
                                        tmp = undefined;
                                      } else {
                                        var tmp$1;
                                        switch (value$1) {
                                          case "AMSTERDAM" :
                                              tmp$1 = "AMSTERDAM";
                                              break;
                                          case "BEIJING" :
                                              tmp$1 = "BEIJING";
                                              break;
                                          case "BILLINGSHURST" :
                                              tmp$1 = "BILLINGSHURST";
                                              break;
                                          case "COLOGNE" :
                                              tmp$1 = "COLOGNE";
                                              break;
                                          case "DOHA" :
                                              tmp$1 = "DOHA";
                                              break;
                                          case "DUBAI" :
                                              tmp$1 = "DUBAI";
                                              break;
                                          case "GENEVA" :
                                              tmp$1 = "GENEVA";
                                              break;
                                          case "GLOBAL_SALE_ORG" :
                                              tmp$1 = "GLOBAL_SALE_ORG";
                                              break;
                                          case "HONG_KONG" :
                                              tmp$1 = "HONG_KONG";
                                              break;
                                          case "MADRID" :
                                              tmp$1 = "MADRID";
                                              break;
                                          case "MELBOURNE" :
                                              tmp$1 = "MELBOURNE";
                                              break;
                                          case "MILAN" :
                                              tmp$1 = "MILAN";
                                              break;
                                          case "MONACO" :
                                              tmp$1 = "MONACO";
                                              break;
                                          case "MUMBAI" :
                                              tmp$1 = "MUMBAI";
                                              break;
                                          case "MUNICH" :
                                              tmp$1 = "MUNICH";
                                              break;
                                          case "NEW_BOND_STREET" :
                                              tmp$1 = "NEW_BOND_STREET";
                                              break;
                                          case "NEW_YORK" :
                                              tmp$1 = "NEW_YORK";
                                              break;
                                          case "NEW_YORK_GENERAL_FA" :
                                              tmp$1 = "NEW_YORK_GENERAL_FA";
                                              break;
                                          case "OLYMPIA" :
                                              tmp$1 = "OLYMPIA";
                                              break;
                                          case "PARIS" :
                                              tmp$1 = "PARIS";
                                              break;
                                          case "SHANGHAI" :
                                              tmp$1 = "SHANGHAI";
                                              break;
                                          case "SINGAPORE" :
                                              tmp$1 = "SINGAPORE";
                                              break;
                                          case "STOCKHOLM" :
                                              tmp$1 = "STOCKHOLM";
                                              break;
                                          case "SYDNEY" :
                                              tmp$1 = "SYDNEY";
                                              break;
                                          case "TAIPEI" :
                                              tmp$1 = "TAIPEI";
                                              break;
                                          case "TEL_AVIV" :
                                              tmp$1 = "TEL_AVIV";
                                              break;
                                          case "TORONTO" :
                                              tmp$1 = "TORONTO";
                                              break;
                                          case "ZURICH" :
                                              tmp$1 = "ZURICH";
                                              break;
                                          default:
                                            tmp$1 = {
                                              NAME: "FutureAddedValue",
                                              VAL: value$1
                                            };
                                        }
                                        tmp = tmp$1;
                                      }
                                      var value$2 = value.address;
                                      var tmp$2;
                                      if (value$2 == null) {
                                        tmp$2 = undefined;
                                      } else {
                                        var value$3 = value$2.addressLine1;
                                        var value$4 = value$2.addressLine2;
                                        var value$5 = value$2.addressLine3;
                                        var value$6 = value$2.postalCode;
                                        var value$7 = value$2.city;
                                        var value$8 = value$2.regionCode;
                                        var value$9 = value$2.country;
                                        var tmp$3;
                                        if (value$9 == null) {
                                          tmp$3 = undefined;
                                        } else {
                                          var value$10 = value$9.name;
                                          var value$11 = value$9.code;
                                          tmp$3 = {
                                            __typename: value$9.__typename,
                                            name: !(value$10 == null) ? value$10 : undefined,
                                            code: !(value$11 == null) ? value$11 : undefined
                                          };
                                        }
                                        tmp$2 = {
                                          __typename: value$2.__typename,
                                          addressLine1: !(value$3 == null) ? value$3 : undefined,
                                          addressLine2: !(value$4 == null) ? value$4 : undefined,
                                          addressLine3: !(value$5 == null) ? value$5 : undefined,
                                          postalCode: !(value$6 == null) ? value$6 : undefined,
                                          city: !(value$7 == null) ? value$7 : undefined,
                                          regionCode: !(value$8 == null) ? value$8 : undefined,
                                          country: tmp$3
                                        };
                                      }
                                      return {
                                              __typename: value.__typename,
                                              accountId: value.accountId,
                                              location: tmp,
                                              address: tmp$2
                                            };
                                    }), value$9) : undefined
                          };
                  }), value$4)
          }
        };
}

function serialize$47(value) {
  var value$1 = value.me;
  var value$2 = value$1.partyAccounts;
  var partyAccounts = Js_array.map((function (value) {
          var value$1 = value.shippingPreferences;
          var shippingPreferences = value$1 !== undefined ? Js_array.map((function (value) {
                    if (value === undefined) {
                      return null;
                    }
                    var value$1 = value.address;
                    var address;
                    if (value$1 !== undefined) {
                      var value$2 = value$1.country;
                      var country;
                      if (value$2 !== undefined) {
                        var value$3 = value$2.code;
                        var code = value$3 !== undefined ? value$3 : null;
                        var value$4 = value$2.name;
                        var name = value$4 !== undefined ? value$4 : null;
                        var value$5 = value$2.__typename;
                        country = {
                          __typename: value$5,
                          name: name,
                          code: code
                        };
                      } else {
                        country = null;
                      }
                      var value$6 = value$1.regionCode;
                      var regionCode = value$6 !== undefined ? value$6 : null;
                      var value$7 = value$1.city;
                      var city = value$7 !== undefined ? value$7 : null;
                      var value$8 = value$1.postalCode;
                      var postalCode = value$8 !== undefined ? value$8 : null;
                      var value$9 = value$1.addressLine3;
                      var addressLine3 = value$9 !== undefined ? value$9 : null;
                      var value$10 = value$1.addressLine2;
                      var addressLine2 = value$10 !== undefined ? value$10 : null;
                      var value$11 = value$1.addressLine1;
                      var addressLine1 = value$11 !== undefined ? value$11 : null;
                      var value$12 = value$1.__typename;
                      address = {
                        __typename: value$12,
                        addressLine1: addressLine1,
                        addressLine2: addressLine2,
                        addressLine3: addressLine3,
                        postalCode: postalCode,
                        city: city,
                        regionCode: regionCode,
                        country: country
                      };
                    } else {
                      address = null;
                    }
                    var value$13 = value.location;
                    var $$location = value$13 !== undefined ? (
                        typeof value$13 === "object" ? value$13.VAL : (
                            value$13 === "MELBOURNE" ? "MELBOURNE" : (
                                value$13 === "GENEVA" ? "GENEVA" : (
                                    value$13 === "SHANGHAI" ? "SHANGHAI" : (
                                        value$13 === "NEW_YORK" ? "NEW_YORK" : (
                                            value$13 === "DUBAI" ? "DUBAI" : (
                                                value$13 === "MADRID" ? "MADRID" : (
                                                    value$13 === "SINGAPORE" ? "SINGAPORE" : (
                                                        value$13 === "MUMBAI" ? "MUMBAI" : (
                                                            value$13 === "HONG_KONG" ? "HONG_KONG" : (
                                                                value$13 === "MUNICH" ? "MUNICH" : (
                                                                    value$13 === "COLOGNE" ? "COLOGNE" : (
                                                                        value$13 === "NEW_YORK_GENERAL_FA" ? "NEW_YORK_GENERAL_FA" : (
                                                                            value$13 === "MONACO" ? "MONACO" : (
                                                                                value$13 === "MILAN" ? "MILAN" : (
                                                                                    value$13 === "BEIJING" ? "BEIJING" : (
                                                                                        value$13 === "BILLINGSHURST" ? "BILLINGSHURST" : (
                                                                                            value$13 === "SYDNEY" ? "SYDNEY" : (
                                                                                                value$13 === "ZURICH" ? "ZURICH" : (
                                                                                                    value$13 === "GLOBAL_SALE_ORG" ? "GLOBAL_SALE_ORG" : (
                                                                                                        value$13 === "TORONTO" ? "TORONTO" : (
                                                                                                            value$13 === "STOCKHOLM" ? "STOCKHOLM" : (
                                                                                                                value$13 === "OLYMPIA" ? "OLYMPIA" : (
                                                                                                                    value$13 === "DOHA" ? "DOHA" : (
                                                                                                                        value$13 === "NEW_BOND_STREET" ? "NEW_BOND_STREET" : (
                                                                                                                            value$13 === "TAIPEI" ? "TAIPEI" : (
                                                                                                                                value$13 === "TEL_AVIV" ? "TEL_AVIV" : (
                                                                                                                                    value$13 === "PARIS" ? "PARIS" : "AMSTERDAM"
                                                                                                                                  )
                                                                                                                              )
                                                                                                                          )
                                                                                                                      )
                                                                                                                  )
                                                                                                              )
                                                                                                          )
                                                                                                      )
                                                                                                  )
                                                                                              )
                                                                                          )
                                                                                      )
                                                                                  )
                                                                              )
                                                                          )
                                                                      )
                                                                  )
                                                              )
                                                          )
                                                      )
                                                  )
                                              )
                                          )
                                      )
                                  )
                              )
                          )
                      ) : null;
                    var value$14 = value.accountId;
                    var value$15 = value.__typename;
                    return {
                            __typename: value$15,
                            accountId: value$14,
                            location: $$location,
                            address: address
                          };
                  }), value$1) : null;
          var value$2 = value.addresses;
          var addresses = value$2 !== undefined ? Js_array.map((function (value) {
                    if (value === undefined) {
                      return null;
                    }
                    var value$1 = value.country;
                    var country;
                    if (value$1 !== undefined) {
                      var value$2 = value$1.code;
                      var code = value$2 !== undefined ? value$2 : null;
                      var value$3 = value$1.name;
                      var name = value$3 !== undefined ? value$3 : null;
                      var value$4 = value$1.__typename;
                      country = {
                        __typename: value$4,
                        name: name,
                        code: code
                      };
                    } else {
                      country = null;
                    }
                    var value$5 = value.associationType;
                    var associationType = value$5 !== undefined ? (
                        typeof value$5 === "object" ? value$5.VAL : (
                            value$5 === "SUBSCRIPTION" ? "SUBSCRIPTION" : (
                                value$5 === "APPRAISAL_VALUATION" ? "APPRAISAL_VALUATION" : (
                                    value$5 === "SHIP_TO" ? "SHIP_TO" : (
                                        value$5 === "SELLER" ? "SELLER" : (
                                            value$5 === "COPY" ? "COPY" : (
                                                value$5 === "MAIN" ? "MAIN" : (
                                                    value$5 === "BUYER" ? "BUYER" : "PROMOTIONAL_MAIL"
                                                  )
                                              )
                                          )
                                      )
                                  )
                              )
                          )
                      ) : null;
                    var value$6 = value.regionCode;
                    var regionCode = value$6 !== undefined ? value$6 : null;
                    var value$7 = value.city;
                    var city = value$7 !== undefined ? value$7 : null;
                    var value$8 = value.postalCode;
                    var postalCode = value$8 !== undefined ? value$8 : null;
                    var value$9 = value.addressLine3;
                    var addressLine3 = value$9 !== undefined ? value$9 : null;
                    var value$10 = value.addressLine2;
                    var addressLine2 = value$10 !== undefined ? value$10 : null;
                    var value$11 = value.addressLine1;
                    var addressLine1 = value$11 !== undefined ? value$11 : null;
                    var value$12 = value.__typename;
                    return {
                            __typename: value$12,
                            addressLine1: addressLine1,
                            addressLine2: addressLine2,
                            addressLine3: addressLine3,
                            postalCode: postalCode,
                            city: city,
                            regionCode: regionCode,
                            associationType: associationType,
                            country: country
                          };
                  }), value$2) : null;
          var value$3 = value.accountType;
          var accountType = value$3 !== undefined ? value$3 : null;
          var value$4 = value.accountHolder;
          var accountHolder;
          if (value$4 !== undefined) {
            var value$5 = value$4.name;
            var name = value$5 !== undefined ? value$5 : null;
            var value$6 = value$4.__typename;
            accountHolder = {
              __typename: value$6,
              name: name
            };
          } else {
            accountHolder = null;
          }
          var value$7 = value.legacyAccountNumber;
          var legacyAccountNumber = value$7 !== undefined ? value$7 : null;
          var value$8 = value.accountStatus;
          var accountStatus = value$8 !== undefined ? value$8 : null;
          var value$9 = value.role;
          var role = value$9 !== undefined ? value$9 : null;
          var value$10 = value.accountId;
          var accountId = value$10 !== undefined ? value$10 : null;
          var value$11 = value.__typename;
          return {
                  __typename: value$11,
                  accountId: accountId,
                  role: role,
                  accountStatus: accountStatus,
                  legacyAccountNumber: legacyAccountNumber,
                  accountHolder: accountHolder,
                  accountType: accountType,
                  addresses: addresses,
                  shippingPreferences: shippingPreferences
                };
        }), value$2);
  var value$3 = value$1.status;
  var status;
  if (value$3.NAME === "TransactionalUserStatus") {
    var value$4 = value$3.VAL.activeAccounts;
    var activeAccounts = Js_array.map((function (value) {
            return value;
          }), value$4);
    status = {
      __typename: "TransactionalUserStatus",
      activeAccounts: activeAccounts
    };
  } else {
    status = value$3.VAL;
  }
  var value$5 = value$1.__typename;
  var me = {
    __typename: value$5,
    status: status,
    partyAccounts: partyAccounts
  };
  return {
          me: me
        };
}

function serializeVariables$22(param) {
  
}

function makeVariables$22(param) {
  
}

function makeDefaultVariables(param) {
  
}

var PartyAccountsQuery_inner = {
  Raw: Raw$47,
  query: query$47,
  parse: parse$47,
  serialize: serialize$47,
  serializeVariables: serializeVariables$22,
  makeVariables: makeVariables$22,
  makeDefaultVariables: makeDefaultVariables
};

var include$22 = ApolloClient__React_Hooks_UseQuery.Extend({
      query: query$47,
      Raw: Raw$47,
      parse: parse$47,
      serialize: serialize$47,
      serializeVariables: serializeVariables$22
    });

var PartyAccountsQuery_refetchQueryDescription = include$22.refetchQueryDescription;

var PartyAccountsQuery_use = include$22.use;

var PartyAccountsQuery_useLazy = include$22.useLazy;

var PartyAccountsQuery_useLazyWithVariables = include$22.useLazyWithVariables;

var PartyAccountsQuery = {
  PartyAccountsQuery_inner: PartyAccountsQuery_inner,
  Raw: Raw$47,
  query: query$47,
  parse: parse$47,
  serialize: serialize$47,
  serializeVariables: serializeVariables$22,
  makeVariables: makeVariables$22,
  makeDefaultVariables: makeDefaultVariables,
  refetchQueryDescription: PartyAccountsQuery_refetchQueryDescription,
  use: PartyAccountsQuery_use,
  useLazy: PartyAccountsQuery_useLazy,
  useLazyWithVariables: PartyAccountsQuery_useLazyWithVariables
};

var SelectAccount = {
  PartyAccountsQuery: PartyAccountsQuery
};

var Raw$48 = {};

var query$48 = (require("@apollo/client").gql`
  query LiveStreamTokenQuery($auctionId: String!, $sessionId: Int!)  {
    auctionLiveStreamToken(auctionId: $auctionId, sessionId: $sessionId)  {
      __typename
      token
    }
  }
`);

function parse$48(value) {
  var value$1 = value.auctionLiveStreamToken;
  return {
          auctionLiveStreamToken: {
            __typename: value$1.__typename,
            token: value$1.token
          }
        };
}

function serialize$48(value) {
  var value$1 = value.auctionLiveStreamToken;
  var value$2 = value$1.token;
  var value$3 = value$1.__typename;
  var auctionLiveStreamToken = {
    __typename: value$3,
    token: value$2
  };
  return {
          auctionLiveStreamToken: auctionLiveStreamToken
        };
}

function serializeVariables$23(inp) {
  return {
          auctionId: inp.auctionId,
          sessionId: inp.sessionId
        };
}

function makeVariables$23(auctionId, sessionId, param) {
  return {
          auctionId: auctionId,
          sessionId: sessionId
        };
}

var LiveStreamTokenQuery_inner = {
  Raw: Raw$48,
  query: query$48,
  parse: parse$48,
  serialize: serialize$48,
  serializeVariables: serializeVariables$23,
  makeVariables: makeVariables$23
};

var include$23 = ApolloClient__React_Hooks_UseQuery.Extend({
      query: query$48,
      Raw: Raw$48,
      parse: parse$48,
      serialize: serialize$48,
      serializeVariables: serializeVariables$23
    });

var LiveStreamTokenQuery_refetchQueryDescription = include$23.refetchQueryDescription;

var LiveStreamTokenQuery_use = include$23.use;

var LiveStreamTokenQuery_useLazy = include$23.useLazy;

var LiveStreamTokenQuery_useLazyWithVariables = include$23.useLazyWithVariables;

var LiveStreamTokenQuery = {
  LiveStreamTokenQuery_inner: LiveStreamTokenQuery_inner,
  Raw: Raw$48,
  query: query$48,
  parse: parse$48,
  serialize: serialize$48,
  serializeVariables: serializeVariables$23,
  makeVariables: makeVariables$23,
  refetchQueryDescription: LiveStreamTokenQuery_refetchQueryDescription,
  use: LiveStreamTokenQuery_use,
  useLazy: LiveStreamTokenQuery_useLazy,
  useLazyWithVariables: LiveStreamTokenQuery_useLazyWithVariables
};

var LiveStreamToken = {
  LiveStreamTokenQuery: LiveStreamTokenQuery
};

var AmountFragment;

var MediaFragment;

export {
  AmountFragment ,
  LotSymbol ,
  PremiumLotState ,
  SessionState ,
  LotCard ,
  Agreements ,
  AuctionEnrollmentModal ,
  AuctionInfo ,
  BetweenSessionModal ,
  MediaFragment ,
  LotDetails ,
  CurrentLotCard ,
  AlternativeCurrency ,
  LotFeed ,
  ParcelLotModal ,
  FeedLotMessageBox ,
  Enrollment ,
  PlaceBidButton ,
  AuctionHeader ,
  LotOnDisplay ,
  WelcomeAuctionRoomModal ,
  Auction ,
  Autocharge ,
  Subscriptions ,
  SelectAccount ,
  LiveStreamToken ,
}
/* query Not a pure module */
